(function () {
  'use strict';

  const STORAGE_KEY = 'slimmr:assessment';

  // Add new screens here — each entry needs a unique `id` and matching markup in assessment-form.liquid.
  const STEP_CONFIG = [
    { id: 'AF-INTRO', step: 'intro' },
    { id: 'AF-BASIC-INFO', step: 'basic-info' },
    { id: 'AF-PS-1-DOB', step: 'date-of-birth' },
    { id: 'AF-PS-2-ETHNIC', step: 'ethnic-background' },
    { id: 'AF-MEDICATION-PROVIDER', step: 'medication-provider' },
    { id: 'AF-PS-3-BODY', step: 'body-measurements' },
    { id: 'AF-PS-5-BIOLOGICAL-SEX', step: 'biological-sex' },
    { id: 'AF-PS-6-MEDICAL-EXCLUSIONS', step: 'medical-exclusions' },
    { id: 'AF-PS-7-COMORBIDITIES', step: 'comorbidities' },
    { id: 'AF-PS-8-COMORBIDITY-FOLLOWUP', step: 'comorbidity-followup' },
    { id: 'AF-PS-9-WEIGHT-MOOD', step: 'weight-mood' },
    { id: 'AF-PS-10-ALLERGIES', step: 'allergies' },
    { id: 'AF-PS-13-ILLNESSES-OPERATIONS', step: 'illnesses-operations' },
    { id: 'AF-PS-14-MEDICATIONS', step: 'medications' },
    { id: 'AF-PS-15-APPLICABLE-CONDITIONS', step: 'applicable-conditions' },
    { id: 'AF-PS-16-GP-SURGERY', step: 'gp-surgery' },
    { id: 'AF-PS-17-DIET-LIFESTYLE', step: 'diet-lifestyle' },
    { id: 'AF-MEDICATION-SELECTION', step: 'medication-selection' },
    { id: 'AF-PREV-PRESCRIPTION', step: 'previous-prescription' },
    { id: 'AF-GLP1-TREATMENT-START', step: 'glp1-treatment-start' },
    { id: 'AF-GLP1-LAST-DOSE', step: 'glp1-last-dose' },
    { id: 'AF-PEN-DOSES-REMAINING', step: 'pen-doses-remaining' },
    { id: 'AF-PRESCRIPTION-EVIDENCE', step: 'prescription-evidence' },
    { id: 'AF-MEDICATION-PREFERENCE', step: 'medication-preference' },
    { id: 'AF-NEXT-DOSE-PREFERENCE', step: 'next-dose-preference' },
    { id: 'AF-MEDICATION-EXPERIENCE', step: 'medication-experience' },
    { id: 'AF-CONFIRM-DECLARATIONS', step: 'confirm-declarations' },
    { id: 'AF-WEGOVY-PENCYCLE', step: 'wegovy-pencycle' },
    { id: 'AF-VERIFY-IDENTITY', step: 'verify-identity' },
    { id: 'AF-SCALE-PHOTO', step: 'scale-photo' },
    { id: 'AF-OPTIONAL-EXTRAS', step: 'optional-extras' },
    { id: 'AF-DELIVERY-DATE', step: 'delivery-date' },
    { id: 'AF-INELIGIBLE', step: 'ineligible' }
  ];

  const NHS_ORG_API = 'https://demo-app-config.looprx.io/api/nhs-organisations';
  const ONEID_START_API = 'https://demo-app-config.looprx.io/api/oneid/start';
  const ONEID_VERIFICATION_API = 'https://demo-app-config.looprx.io/api/oneid/verification';
  const UPLOAD_ASSESSMENT_IMAGES_API = 'https://demo-app-config.looprx.io/api/upload-assessment-images-v2';
  const CHECK_ASSESSMENT_API = 'https://demo-app-config.looprx.io/api/check-assessment';
  const CREATE_ASSESSMENT_API = 'https://demo-app-config.looprx.io/api/create-assessment';
  const ASSESSMENT_CATEGORY_ID = 1;

  function resolveLooprxApiUrl(configuredUrl, endpointPath, fallbackUrl) {
    const url = String(configuredUrl || fallbackUrl).trim();
    return url.includes(endpointPath) ? url : fallbackUrl;
  }
  const PATIENT_PORTAL_LOGIN_URL = 'https://account.getslimmr.co.uk/login';
  const ONEID_STORAGE_KEY = 'oneid:lastResult';
  const ONEID_STATUS_NOT_VERIFIED = 'Not Verified - Click again on Verify My Identity Button';
  const ONEID_STATUS_VERIFIED = 'Verified';
  const GP_SEARCH_MIN_CHARS = 1;
  const GP_SEARCH_API_MIN_CHARS = 3;
  const GP_SEARCH_DEBOUNCE_MS = 350;

  const DELIVERY_BUSINESS_LEAD_DAYS = 1;
  const DELIVERY_DAILY_CUTOFF_HOUR = 17;
  const DELIVERY_DISABLED_WEEKDAYS = [0, 1];
  const DELIVERY_PERMANENT_DISABLED_RANGES = [
    { start: '2026-04-01', end: '2026-04-07' }
  ];
  const DELIVERY_PERMANENT_DISABLED_DATES = [
    '2026-05-05',
    '2026-05-06',
    '2026-05-26',
    '2026-05-27'
  ];

  function compareDeliveryDateKeys(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  }

  function isDeliveryDateKeyInRange(dateKey, startKey, endKey) {
    return compareDeliveryDateKeys(dateKey, startKey) >= 0 && compareDeliveryDateKeys(dateKey, endKey) <= 0;
  }

  function isPermanentDeliveryDate(dateKey) {
    if (!dateKey) return false;

    if (DELIVERY_PERMANENT_DISABLED_DATES.indexOf(dateKey) !== -1) {
      return true;
    }

    for (let i = 0; i < DELIVERY_PERMANENT_DISABLED_RANGES.length; i += 1) {
      const range = DELIVERY_PERMANENT_DISABLED_RANGES[i];
      if (isDeliveryDateKeyInRange(dateKey, range.start, range.end)) {
        return true;
      }
    }

    return false;
  }

  function getGpSearchApiTerms(query) {
    const q = String(query || '').trim();
    if (!q) return [];
    if (q.length >= GP_SEARCH_API_MIN_CHARS) return [q];
    if (q.length === 2) return ['a', 'e', 'i', 'o', 'u'].map((v) => q + v);
    return 'aeiounrstlm'.split('').map((c) => q + c + 'a');
  }

  function matchesGpSearchQuery(name, query) {
    const n = String(name || '').toLowerCase();
    const q = String(query || '').trim().toLowerCase();
    if (!q || !n.includes(q)) return false;
    if (n.startsWith(q)) return true;
    return n.split(/[\s,&(./-]+/).some((word) => word.startsWith(q));
  }

  function dedupeGpOrganisations(organisations) {
    const seen = new Set();
    return organisations.filter((org) => {
      const id = org.OrgId || org.Name;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }

  async function fetchGpOrganisationsFromApi(apiUrl, tenant, query, signal) {
    const trimmed = String(query || '').trim();
    const terms = getGpSearchApiTerms(trimmed);
    const headers = { Accept: 'application/json' };
    if (tenant) headers['X-Tenant'] = tenant;

    const chunks = await Promise.all(
      terms.map(async (term) => {
        try {
          const response = await fetch(`${apiUrl}?name=${encodeURIComponent(term)}`, { headers, signal });
          if (!response.ok) return [];
          const payload = await response.json();
          return payload.Organisations || [];
        } catch (err) {
          if (err.name === 'AbortError') throw err;
          return [];
        }
      })
    );

    const merged = dedupeGpOrganisations(chunks.flat());
    if (trimmed.length < GP_SEARCH_API_MIN_CHARS) {
      return merged.filter((org) => matchesGpSearchQuery(org.Name, trimmed));
    }
    return merged;
  }
  const GP_UNABLE_REASON = {
    DONT_WANT: "I don't want my GP to know",
    NO_GP: "I don't have a GP",
    NOT_LISTED: "My GP surgery isn't listed"
  };
  const PREVIOUS_PRESCRIPTION = {
    WEGOVY_INJECTION: 'Wegovy once weekly injection',
    MOUNJARO: 'Mounjaro once weekly injection',
    WEGOVY_PILL: 'Wegovy daily pill',
    OZEMPIC: 'Ozempic'
  };
  const PRESCRIPTION_EVIDENCE = {
    UPLOAD_NOW: "Yes — I'll upload it now",
    SEND_LATER: "Yes — but I'll need to send it later",
    CANT_PROVIDE: "No — I can't provide this",
    CONTINUE_BASIS: "Yes — I'd like to continue on this basis"
  };
  const MEDICATION_PREFERENCE_UNSURE = "I'm unsure — I'd like the prescriber to decide";
  const MEDICATION_PREFERENCE_DECIDE = "I'd like the prescriber to decide";
  const PEN_CYCLE = {
    YES: 'Yes please send me a free PenCycle return box',
    NO: 'No thank you'
  };
  const SCALE_PHOTO = {
    YES: 'Yes, absolutely',
    NO: 'No, not right now'
  };
  const BODY_MEASUREMENT_RANGES = {
    HEIGHT_CM: { min: 120, max: 250, message: 'Please enter a height between 120 cm and 250 cm.' },
    WEIGHT_KG: { min: 30, max: 300, message: 'Please enter a weight between 30 kg and 300 kg.' },
    WAIST_CM: { min: 40, max: 100, message: 'Please enter a waist measurement between 40 cm and 100 cm.' },
    HEIGHT_IMPERIAL_MESSAGE: 'Please enter a height between 3\u201911\u2033 and 8\u20192\u2033.',
    WEIGHT_IMPERIAL_MESSAGE: 'Please enter a weight between 4st 10lb and 47st 3lb.',
    INCHES_MAX: 12,
    POUNDS_MAX: 14,
    NUMBERS_ONLY: 'Please enter numbers only.'
  };
  const BODY_MEASUREMENT_INTEGER_FIELDS = new Set([
    'heightFeet', 'heightInches',
    'currentStones', 'currentPounds',
    'initialStones', 'initialPounds',
    'targetStones', 'targetPounds'
  ]);
  const BODY_MEASUREMENT_DECIMAL_FIELDS = new Set([
    'heightCm', 'currentKg', 'initialKg', 'targetKg', 'waistCm'
  ]);
  const ELIGIBILITY = {
    MIN_AGE: 18,
    MIN_BMI: 25,
    NONE_OF_ABOVE: 'None of the above',
    PREGNANCY_INELIGIBLE: ['Pregnant', 'Trying to become pregnant', 'Breastfeeding'],
    TYPE2_MANAGEMENT_INELIGIBLE: [
      'DDP-4 inhibitors (gliptins)',
      'Insulin',
      'Gliclazide, glimepiride, or another sulfonylurea',
      'Saxenda, Victoza, Ozempic, or another GLP-1 receptor agonists'
    ],
    TYPE2_APPLIES_INELIGIBLE: [
      'My diabetes is managed by a secondary care provider',
      'I have kidney problems',
      "I've had an episode of diabetic ketoacidosis within the last 6 months",
      "I've had hypoglycemia in the last 6 months",
      'I have a scheduled appointment for reviewing my diabetes medications'
    ],
    STEP_REASONS: {
      'date-of-birth': ['underage'],
      'body-measurements': ['low_bmi'],
      'biological-sex': ['pregnancy'],
      'medical-exclusions': ['medical_exclusions'],
      'comorbidity-followup': ['type2_management', 'type2_applies'],
      'allergies': ['medication_allergies']
    }
  };
  const MEDICATION_SELECTION = {
    MOUNJARO: 'Mounjaro once weekly injection',
    WEGOVY: 'Wegovy once weekly injection',
    WEGOVY_PILL: 'Wegovy daily pill',
    ALLI: 'Alli',
    PRESCRIBER: 'prescriber-decide'
  };
  const SELECTABLE_MEDICATIONS = [
    MEDICATION_SELECTION.MOUNJARO,
    MEDICATION_SELECTION.WEGOVY,
    MEDICATION_SELECTION.WEGOVY_PILL,
    MEDICATION_SELECTION.ALLI
  ];
  const MEDICATION_VARIANT_IDS = {
    MOUNJARO: 52483558703443,
    WEGOVY: 52483765272915,
    ALLI: 53117182116179,
    PRESCRIBER: 52825891045715
  };

  function applyWegovyPillVariantIds(root) {
    const raw = root?.dataset?.wegovyPillDoseVariants;
    if (!raw) return;

    try {
      const map = JSON.parse(raw);
      DOSE_CATALOG.WEGOVY_PILL.forEach((dose) => {
        const variantId = Number(map[dose.name]);
        if (variantId > 0) dose.value = variantId;
      });
    } catch (_) {}
  }
  const OPTIONAL_EXTRAS = {
    STANDARD_PANEL: 52627452395859,
    EXTENDED_PANEL: 52831084118355,
    PSYCHOTHERAPY_SIX: 52862864851283,
    PSYCHOTHERAPY_TWELVE: 52862864884051,
    DIETITIAN: 52491357192531,
    PSYCHIATRIC: 52505435799891
  };

  const DOSE_CATALOG = {
    WEGOVY: [
      { name: '0.25mg', value: 52483765272915 },
      { name: '0.5mg', value: 52483765305683 },
      { name: '1.0mg', value: 52483765338451 },
      { name: '1.7mg', value: 52483765371219 },
      { name: '2.4mg', value: 52483765403987 },
      { name: '7.2mg', value: 53931903058259 }
    ],
    MOUNJARO: [
      { name: '2.5mg', value: 52483558703443 },
      { name: '5mg', value: 52483558736211 },
      { name: '7.5mg', value: 52483558768979 },
      { name: '10mg', value: 52483558801747 },
      { name: '12.5mg', value: 52483558834515 },
      { name: '15mg', value: 52483558867283 }
    ],
    WEGOVY_PILL: [
      { name: '1.5mg', value: 0 },
      { name: '4mg', value: 0 },
      { name: '9mg', value: 0 },
      { name: '25mg', value: 0 }
    ],
    OZEMPIC: [
      { name: '0.25mg', value: 0 },
      { name: '0.5mg', value: 0 },
      { name: '1.0mg', value: 0 },
      { name: '2.0mg', value: 0 }
    ]
  };

  const WEGOVY_INJECTION_TO_WEGOVY_PILL = {
    0.25: 4,
    0.5: 4,
    1: 4,
    1.7: 9,
    2.4: 25,
    7.2: 25
  };

  const MOUNJARO_TO_WEGOVY_PILL = {
    2.5: 4,
    5: 4,
    7.5: 9,
    10: 9,
    12.5: 25,
    15: 25
  };

  function findCatalogDose(catalog, doseMg) {
    const match = catalog.find((d) => toDoseNumber(d.name) === doseMg);
    return match || null;
  }

  function getInjectableToWegovyPillSwitchDoses(current, isWegovy, isMounjaro, gapGreaterThan27) {
    const { WEGOVY_PILL } = DOSE_CATALOG;

    if (gapGreaterThan27) {
      return mapDoseResults([WEGOVY_PILL[0]]);
    }

    let mappedDose = 1.5;
    if (isWegovy) {
      mappedDose = WEGOVY_INJECTION_TO_WEGOVY_PILL[current] ?? 1.5;
    } else if (isMounjaro) {
      mappedDose = MOUNJARO_TO_WEGOVY_PILL[current] ?? 1.5;
    }

    const match = findCatalogDose(WEGOVY_PILL, mappedDose);
    return match ? mapDoseResults([match]) : [];
  }

  const GP_CORS_ORIGINS = new Set([
    'getslimmr.co.uk',
    'www.getslimmr.co.uk'
  ]);

  function isLocalDevServer() {
    const host = window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1' || host === '[::1]';
  }

  function isVerificationBypassEnabled() {
    return new URLSearchParams(window.location.search).get('bypass') === 'true';
  }

  function isCheckoutDisabled() {
    const params = new URLSearchParams(window.location.search);
    for (const [key, value] of params.entries()) {
      if (key.toLowerCase() === 'checkout' && String(value).toLowerCase() === 'false') {
        return true;
      }
    }
    return false;
  }

  function normalizeCheckoutParams(qs) {
    const normalized = qs instanceof URLSearchParams
      ? new URLSearchParams(qs.toString())
      : new URLSearchParams(qs || '');

    const alias = (keys, target) => {
      if (normalized.has(target)) return;
      keys.some((key) => {
        if (!normalized.has(key)) return false;
        normalized.set(target, normalized.get(key));
        return true;
      });
    };

    alias(['firstname', 'first', 'fname'], 'first_name');
    alias(['lastname', 'last', 'lname', 'surname'], 'last_name');
    alias(['mail', 'email_address'], 'email');
    alias(['mobile', 'phone_number', 'tel', 'telephone'], 'phone');

    if (!normalized.has('first_name') && normalized.has('name')) {
      const parts = String(normalized.get('name') || '').trim().split(/\s+/).filter(Boolean);
      if (parts.length) {
        normalized.set('first_name', parts[0]);
        if (parts.length > 1) normalized.set('last_name', parts.slice(1).join(' '));
      }
    }

    return normalized;
  }

  function resolvePhoneFromCheckoutParam(phoneRaw, countryHint) {
    const trimmed = String(phoneRaw || '').trim();
    if (!trimmed) return null;

    if (trimmed.startsWith('+')) {
      const digits = trimmed.replace(/\D/g, '');
      const region = PHONE_REGIONS.find((entry) => digits.startsWith(entry.dial));
      if (region) {
        const national = digits.slice(region.dial.length);
        return {
          phoneCountry: region.code,
          phoneNational: national,
          phone: `+${digits}`
        };
      }
    }

    const country = countryHint && getPhoneRegion(countryHint) ? countryHint : 'GB';
    if (!isValidPhone(trimmed, country)) return null;

    return {
      phoneCountry: country,
      phoneNational: String(trimmed).replace(/\D/g, ''),
      phone: formatE164(trimmed, country)
    };
  }

  const ONEID_STATUS_BYPASS = 'Verification skipped';

  const STEPS = STEP_CONFIG.map((entry) => entry.step);

  const STEP_IDS = Object.fromEntries(STEP_CONFIG.map((entry) => [entry.step, entry.id]));

  const STEP_BY_ID = Object.fromEntries(STEP_CONFIG.map((entry) => [entry.id, entry.step]));

  function formatMultiSelectValue(values) {
    if (!Array.isArray(values)) return values || '';
    return values
      .filter((value) => value && value !== 'None of the above' && value !== 'None of these')
      .join(', ');
  }

  function yesNoLabel(value) {
    if (value === 'yes') return 'Yes';
    if (value === 'no') return 'No';
    return value || '';
  }

  function parseNumericField(value) {
    const str = String(value ?? '').trim().replace(',', '.');
    if (str === '') return { empty: true, valid: false, value: NaN };
    const num = Number(str);
    return { empty: false, valid: Number.isFinite(num), value: num };
  }

  function hasSelectionOtherThanNone(values, noneValue) {
    return (Array.isArray(values) ? values : []).some((value) => value !== noneValue);
  }

  function clearAssessmentSession() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }

  function getAccessTokenFromCookie() {
    const match = document.cookie.match(/(?:^|;\s*)access_token=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getStepId(stepSlug) {
    return STEP_IDS[stepSlug] || '';
  }

  function getStepSlug(stepId) {
    return STEP_BY_ID[stepId] || '';
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function toDoseNumber(value) {
    if (typeof value === 'number') return value;

    if (typeof value === 'string') {
      const match = value.match(/[\d.]+/);
      return match ? parseFloat(match[0]) : NaN;
    }

    return NaN;
  }

  function mapDoseResults(doses) {
    return doses.map((dose) => ({
      name: dose.name,
      value: dose.value,
      active: false
    }));
  }

  /**
   * Neighbouring dose options for continue / switch paths.
   * Ported from the Nordcraft custom-code bundle.
   */
  function getNeighbourDoses(args) {
    const currentRaw = args.dose;
    const mode = (args.mode ?? 'continue').toLowerCase();
    const previouslyPrescribed = args.previouslyPrescribed;

    const dd = Number(args.dd);
    const mm = Number(args.mm);
    const yy = Number(args.yy);

    const { WEGOVY, MOUNJARO, WEGOVY_PILL, OZEMPIC } = DOSE_CATALOG;
    const current = toDoseNumber(currentRaw);

    if (isNaN(current)) return [];

    const doseInList = (list) => list.some((d) => toDoseNumber(d.name) === current);

    let isWegovy = false;
    let isWegovyPill = false;
    let isMounjaro = false;
    let isOzempic = false;

    if (previouslyPrescribed === PREVIOUS_PRESCRIPTION.WEGOVY_INJECTION) {
      isWegovy = doseInList(WEGOVY);
    } else if (previouslyPrescribed === PREVIOUS_PRESCRIPTION.WEGOVY_PILL) {
      isWegovyPill = doseInList(WEGOVY_PILL);
    } else if (previouslyPrescribed === PREVIOUS_PRESCRIPTION.MOUNJARO) {
      isMounjaro = doseInList(MOUNJARO);
    } else if (previouslyPrescribed === PREVIOUS_PRESCRIPTION.OZEMPIC) {
      isOzempic = doseInList(OZEMPIC);
    } else {
      isWegovy = doseInList(WEGOVY);
      isWegovyPill = doseInList(WEGOVY_PILL);
      isMounjaro = doseInList(MOUNJARO);
      isOzempic = doseInList(OZEMPIC);
    }

    let gapGreaterThan27 = false;

    if (dd && mm && yy) {
      const lastDate = new Date(yy, mm - 1, dd);
      const today = new Date();

      if (!isNaN(lastDate.getTime()) && lastDate <= today) {
        const diffDays = (today - lastDate) / (1000 * 60 * 60 * 24);
        if (diffDays > 27) gapGreaterThan27 = true;
      }
    }

    if (!mode.includes('switch')) {
      const list = isWegovyPill ? WEGOVY_PILL : isWegovy ? WEGOVY : isMounjaro ? MOUNJARO : null;
      if (!list) {
        if (isOzempic) {
          if (gapGreaterThan27) return mapDoseResults([WEGOVY[0]]);

          const OZEMPIC_TO_WEGOVY = {
            0.25: 0.25,
            0.5: 0.25,
            1.0: 0.5,
            2.0: 1.0
          };
          const mappedDose = OZEMPIC_TO_WEGOVY[current];
          const match = WEGOVY.find((d) => toDoseNumber(d.name) === mappedDose);
          return match ? mapDoseResults([match]) : [];
        }

        return [];
      }

      const sorted = list
        .map((d) => ({ ...d, num: toDoseNumber(d.name) }))
        .sort((a, b) => a.num - b.num);

      const index = sorted.findIndex((d) => d.num === current);
      if (index === -1) return [];

      if (gapGreaterThan27) {
        return mapDoseResults([sorted[0]]);
      }

      const result = [];
      if (sorted[index - 1]) result.push(sorted[index - 1]);
      if (sorted[index]) result.push(sorted[index]);
      if (sorted[index + 1]) result.push(sorted[index + 1]);

      return mapDoseResults(result);
    }

    const switchTarget = resolveMedicationPreferenceTarget(args.medicationPreference);

    if (switchTarget === 'mounjaro') {
      if (gapGreaterThan27) return mapDoseResults([MOUNJARO[0]]);

      if (isWegovy && current === 7.2) {
        const fiveMg = MOUNJARO.find((d) => toDoseNumber(d.name) === 5);
        return fiveMg ? mapDoseResults([fiveMg]) : [];
      }

      return mapDoseResults([MOUNJARO[0]]);
    }

    if (switchTarget === 'wegovy') {
      if (gapGreaterThan27) return mapDoseResults([WEGOVY[0]]);

      if (isMounjaro) {
        const MOUNJARO_TO_WEGOVY = {
          2.5: 0.25,
          5: 0.25,
          7.5: 0.5,
          10: 0.5,
          12.5: 1.0,
          15: 1.0
        };

        const mappedDose = MOUNJARO_TO_WEGOVY[current];
        const match = WEGOVY.find((d) => toDoseNumber(d.name) === mappedDose);
        return match ? mapDoseResults([match]) : [];
      }

      if (isOzempic) {
        const OZEMPIC_TO_WEGOVY = {
          0.25: 0.25,
          0.5: 0.25,
          1.0: 0.5,
          2.0: 1.0
        };

        const mappedDose = OZEMPIC_TO_WEGOVY[current];
        const match = WEGOVY.find((d) => toDoseNumber(d.name) === mappedDose);
        return match ? mapDoseResults([match]) : [];
      }

      return mapDoseResults([WEGOVY[0]]);
    }

    if (switchTarget === 'wegovy_pill') {
      return getInjectableToWegovyPillSwitchDoses(current, isWegovy, isMounjaro, gapGreaterThan27);
    }

    if (isWegovy || isWegovyPill) {
      if (gapGreaterThan27) return mapDoseResults([MOUNJARO[0]]);

      if (isWegovy && current === 7.2) {
        const fiveMg = MOUNJARO.find((d) => toDoseNumber(d.name) === 5);
        return fiveMg ? mapDoseResults([fiveMg]) : [];
      }

      return mapDoseResults([MOUNJARO[0]]);
    }

    if (isMounjaro) {
      if (gapGreaterThan27) return mapDoseResults([WEGOVY[0]]);

      const MOUNJARO_TO_WEGOVY = {
        2.5: 0.25,
        5: 0.25,
        7.5: 0.5,
        10: 0.5,
        12.5: 1.0,
        15: 1.0
      };

      const mappedDose = MOUNJARO_TO_WEGOVY[current];
      const match = WEGOVY.find((d) => toDoseNumber(d.name) === mappedDose);
      return match ? mapDoseResults([match]) : [];
    }

    if (isOzempic) {
      if (gapGreaterThan27) return mapDoseResults([WEGOVY[0]]);

      const OZEMPIC_TO_WEGOVY = {
        0.25: 0.25,
        0.5: 0.25,
        1.0: 0.5,
        2.0: 1.0
      };

      const mappedDose = OZEMPIC_TO_WEGOVY[current];
      const match = WEGOVY.find((d) => toDoseNumber(d.name) === mappedDose);
      return match ? mapDoseResults([match]) : [];
    }

    return [];
  }

  function resolveDosePreferenceMode(medicationPreference, previouslyPrescribed) {
    if (previouslyPrescribed === PREVIOUS_PRESCRIPTION.OZEMPIC) return 'switch';

    const pref = medicationPreference || '';
    if (/^(switch to|transition to)/i.test(pref)) return 'switch';
    return 'continue';
  }

  function resolveMedicationPreferenceTarget(medicationPreference) {
    const pref = String(medicationPreference || '').toLowerCase();
    if (!pref || pref.includes("i'm unsure") || pref.includes('prescriber to decide')) return null;
    if (pref.includes('mounjaro')) return 'mounjaro';
    if (pref.includes('daily pill')) return 'wegovy_pill';
    if (pref.includes('wegovy')) return 'wegovy';
    return null;
  }

  function getMedicationPreferenceMedicationKey(option) {
    if (option === MEDICATION_PREFERENCE_UNSURE || option === MEDICATION_PREFERENCE_DECIDE) return null;
    if (/mounjaro/i.test(option)) return MEDICATION_SELECTION.MOUNJARO;
    if (/daily pill/i.test(option)) return MEDICATION_SELECTION.WEGOVY_PILL;
    if (/wegovy/i.test(option)) return MEDICATION_SELECTION.WEGOVY;
    return null;
  }

  const ETHNIC_OPTIONS = [
    'White',
    'Arab or Middle Eastern',
    'Asian – Chinese',
    'Asian – South Asian',
    'Asian – Any Other',
    'Black – Caribbean',
    'Black – African',
    'Black – Any Other',
    'Mixed – White & Black Caribbean',
    'Mixed – White & Black African',
    'Mixed – White & Asian',
    'Mixed – White & Arab or Middle Eastern',
    'Mixed – Any Other',
    'Other',
    'Not known',
    'Prefer not to say'
  ];

  const MEDICATION_OPTIONS = [
    { value: 'never', label: "No, I haven't used weight loss medication before" },
    { value: 'switching', label: "Yes, I'm currently using weight loss medication with another provider and want to switch to Slimmr" },
    { value: 'used_before', label: "No, I'm not currently taking it, but I have taken it before." }
  ];

  const MEDICAL_EXCLUSIONS = [
    'Type 1 diabetes',
    'Diabetic retinopathy',
    'An eating disorder or history of disordered eating',
    'Inflammatory bowel disease (crohns disease, ulcerative collitis)',
    'Non-arteritic anterior ischaemic optic neuropathy (NAION)',
    'Acute or chronic pancreatitis',
    'History of acute pancreatitis',
    'Pancreatic cancer (current or history of)',
    'Impaired liver (excluding NAFLD and NASH)',
    'Chronic kidney disease (stage 4 & 5) (eGFR <30mL/min)',
    'Heart failure (history of)',
    'Medullary thyroid cancer (current or history of) or a family history of medullary thyroid cancer',
    'Multiple Endocrine Neoplasia syndrome type 2 (MEN 2) or neuroendocrine tumours (history of)',
    'Gallbladder cancer (current or history of)',
    'Active gallstones or other active gallbladder problems (within 12 months)',
    'Undergoing treatment for any cancer',
    'None of the above'
  ];
  const WEGOVY_PILL_ALLERGY_EXCLUSIONS = [
    'Salcaprozate sodium',
    'Magnesium stearate'
  ];
  const SHARED_MEDICATION_ALLERGY_INGREDIENTS = [
    'Propylene glycol'
  ];
  const INJECTION_INGREDIENT_ALLERGY_EXCLUSIONS = [
    'Disodium phosphate dihydrate',
    'Sodium phosphate dibasic heptahydrate',
    'Propylene glycol',
    'Phenol',
    'Glycerin',
    'Hydrochloric acid',
    'Sodium hydroxide',
    'Sodium chloride',
    'Benzyl alcohol',
    'Water for injection'
  ];
  const ORLISTAT_MEDICATION_ALLERGY_EXCLUSIONS = [
    'Orlistat',
    'Microcrystalline cellulose (E460)',
    'Sodium starch glycolate (Type A)',
    'Povidone (E1201) (K-value 30)',
    'Sodium laurilsulfate',
    'Talc',
    'Gelatin',
    'Titanium dioxide (E171)',
    'Sorbitan monolaurate',
    'Printing ink',
    'Shellac',
    'Iron oxide black (E172)',
    'Propylene glycol',
    'Polysorbate 80',
    'Indigo carmine (E132)'
  ];
  const LISTED_MEDICATION_WARFARIN = 'Warfarin or other oral anticoagulants';
  const MEDICATION_AGE_WEGOVY_MAX = 85;
  const FEMALE_ONLY_APPLICABLE_CONDITIONS = [
    'I take oral contraception',
    'I take HRT including oral Progesterone'
  ];

  const COMORBIDITIES = [
    'Pre-diabetes',
    'Hypertension (high blood pressure)',
    'Cardiovascular disease (heart disease)',
    'High cholesterol (dyslipidemia)',
    'Osteoarthritis',
    'Polycystic ovary syndrome',
    'Past problems conceiving related to obesity',
    'Sleep apnoea',
    'Chronic severe back pain',
    'Non-alcoholic fatty liver disease (NAFLD)',
    'Non-alcoholic steatohepatitis (NASH)',
    'Gastro-oesophageal reflux disease (GORD)',
    'Obesity hypoventilation syndrome (Pickwickian syndrome)',
    'Venous stasis disease',
    'Type 2 diabetes',
    'None of the above'
  ];

  const TYPE2_DIABETES = 'Type 2 diabetes';

  const COMORBIDITY_FOLLOWUP_API_PREFIX = {
    'Pre-diabetes': 'pre_diabetes',
    'Hypertension (high blood pressure)': 'hypertension',
    'Cardiovascular disease (heart disease)': 'cardiovascular_disease',
    'High cholesterol (dyslipidemia)': 'high_cholesterol',
    'Osteoarthritis': 'osteoarthritis',
    'Polycystic ovary syndrome': 'pcos',
    'Past problems conceiving related to obesity': 'problems_conceiving',
    'Sleep apnoea': 'sleep_apnoea',
    'Chronic severe back pain': 'chronic_severe_back_pain',
    'Non-alcoholic fatty liver disease (NAFLD)': 'nafld',
    'Non-alcoholic steatohepatitis (NASH)': 'nash',
    'Gastro-oesophageal reflux disease (GORD)': 'gord',
    'Obesity hypoventilation syndrome (Pickwickian syndrome)': 'obesity_hypoventilation_syndrome',
    'Venous stasis disease': 'venous_stasis_disease'
  };

  const PREGNANCY_OPTIONS = [
    'Pregnant',
    'Trying to become pregnant',
    'Breastfeeding',
    'None of the above'
  ];

  const BASIC_INFO = {
    NAME_MIN: 2,
    NAME_MAX: 50,
    NAME_PATTERN: /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]+$/,
    EMAIL_PATTERN: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/,
    EMAIL_MAX: 254,
    PHONE_DEFAULT_MIN: 4,
    PHONE_DEFAULT_MAX: 12
  };

  const PHONE_REGION_RULES = {
    GB: { min: 10, max: 11, trunk: true, example: '7123456789' },
    US: { min: 10, max: 10, trunk: false, example: '2025550123' },
    CA: { min: 10, max: 10, trunk: false, example: '2045550123' },
    AU: { min: 9, max: 9, trunk: true, example: '412345678' },
    NZ: { min: 8, max: 10, trunk: true, example: '211234567' },
    IE: { min: 9, max: 9, trunk: true, example: '851234567' },
    IN: { min: 10, max: 10, trunk: false, example: '9876543210' },
    PK: { min: 10, max: 10, trunk: false, example: '3001234567' },
    BD: { min: 10, max: 10, trunk: false, example: '1712345678' },
    CN: { min: 11, max: 11, trunk: false, example: '13123456789' },
    JP: { min: 10, max: 10, trunk: true, example: '9012345678' },
    KR: { min: 9, max: 10, trunk: true, example: '1012345678' },
    DE: { min: 10, max: 11, trunk: true, example: '15123456789' },
    FR: { min: 9, max: 9, trunk: true, example: '612345678' },
    ES: { min: 9, max: 9, trunk: false, example: '612345678' },
    IT: { min: 9, max: 10, trunk: false, example: '3123456789' },
    NL: { min: 9, max: 9, trunk: true, example: '612345678' },
    BE: { min: 9, max: 9, trunk: true, example: '470123456' },
    CH: { min: 9, max: 9, trunk: true, example: '791234567' },
    AT: { min: 10, max: 11, trunk: true, example: '6641234567' },
    SE: { min: 9, max: 10, trunk: true, example: '701234567' },
    NO: { min: 8, max: 8, trunk: false, example: '41234567' },
    DK: { min: 8, max: 8, trunk: false, example: '20123456' },
    FI: { min: 9, max: 10, trunk: true, example: '401234567' },
    PL: { min: 9, max: 9, trunk: false, example: '512345678' },
    PT: { min: 9, max: 9, trunk: false, example: '912345678' },
    GR: { min: 10, max: 10, trunk: false, example: '6912345678' },
    RO: { min: 9, max: 9, trunk: false, example: '712345678' },
    CZ: { min: 9, max: 9, trunk: false, example: '601234567' },
    HU: { min: 9, max: 9, trunk: false, example: '201234567' },
    TR: { min: 10, max: 10, trunk: true, example: '5321234567' },
    RU: { min: 10, max: 10, trunk: true, example: '9123456789' },
    UA: { min: 9, max: 9, trunk: true, example: '501234567' },
    AE: { min: 9, max: 9, trunk: false, example: '501234567' },
    SA: { min: 9, max: 9, trunk: false, example: '512345678' },
    ZA: { min: 9, max: 9, trunk: true, example: '821234567' },
    NG: { min: 10, max: 10, trunk: true, example: '8012345678' },
    EG: { min: 10, max: 10, trunk: true, example: '1012345678' },
    KE: { min: 9, max: 9, trunk: true, example: '712345678' },
    BR: { min: 10, max: 11, trunk: true, example: '11912345678' },
    MX: { min: 10, max: 10, trunk: false, example: '5512345678' },
    AR: { min: 10, max: 10, trunk: false, example: '9112345678' },
    CL: { min: 9, max: 9, trunk: false, example: '912345678' },
    CO: { min: 10, max: 10, trunk: false, example: '3012345678' },
    SG: { min: 8, max: 8, trunk: false, example: '81234567' },
    MY: { min: 9, max: 10, trunk: true, example: '123456789' },
    TH: { min: 9, max: 9, trunk: true, example: '812345678' },
    PH: { min: 10, max: 10, trunk: true, example: '9171234567' },
    ID: { min: 9, max: 11, trunk: true, example: '8123456789' },
    VN: { min: 9, max: 9, trunk: false, example: '912345678' },
    HK: { min: 8, max: 8, trunk: false, example: '51234567' },
    IL: { min: 9, max: 9, trunk: true, example: '501234567' }
  };

  const PHONE_COUNTRIES = [
    ['AF', '93', 'Afghanistan'], ['AL', '355', 'Albania'], ['DZ', '213', 'Algeria'], ['AS', '1684', 'American Samoa'],
    ['AD', '376', 'Andorra'], ['AO', '244', 'Angola'], ['AI', '1264', 'Anguilla'], ['AG', '1268', 'Antigua and Barbuda'],
    ['AR', '54', 'Argentina'], ['AM', '374', 'Armenia'], ['AW', '297', 'Aruba'], ['AU', '61', 'Australia'],
    ['AT', '43', 'Austria'], ['AZ', '994', 'Azerbaijan'], ['BS', '1242', 'Bahamas'], ['BH', '973', 'Bahrain'],
    ['BD', '880', 'Bangladesh'], ['BB', '1246', 'Barbados'], ['BY', '375', 'Belarus'], ['BE', '32', 'Belgium'],
    ['BZ', '501', 'Belize'], ['BJ', '229', 'Benin'], ['BM', '1441', 'Bermuda'], ['BT', '975', 'Bhutan'],
    ['BO', '591', 'Bolivia'], ['BA', '387', 'Bosnia and Herzegovina'], ['BW', '267', 'Botswana'], ['BR', '55', 'Brazil'],
    ['BN', '673', 'Brunei'], ['BG', '359', 'Bulgaria'], ['BF', '226', 'Burkina Faso'], ['BI', '257', 'Burundi'],
    ['KH', '855', 'Cambodia'], ['CM', '237', 'Cameroon'], ['CA', '1', 'Canada'], ['CV', '238', 'Cape Verde'],
    ['KY', '1345', 'Cayman Islands'], ['CF', '236', 'Central African Republic'], ['TD', '235', 'Chad'], ['CL', '56', 'Chile'],
    ['CN', '86', 'China'], ['CO', '57', 'Colombia'], ['KM', '269', 'Comoros'], ['CG', '242', 'Congo'],
    ['CD', '243', 'DR Congo'], ['CR', '506', 'Costa Rica'], ['CI', '225', "Côte d'Ivoire"], ['HR', '385', 'Croatia'],
    ['CU', '53', 'Cuba'], ['CY', '357', 'Cyprus'], ['CZ', '420', 'Czech Republic'], ['DK', '45', 'Denmark'],
    ['DJ', '253', 'Djibouti'], ['DM', '1767', 'Dominica'], ['DO', '1', 'Dominican Republic'], ['EC', '593', 'Ecuador'],
    ['EG', '20', 'Egypt'], ['SV', '503', 'El Salvador'], ['GQ', '240', 'Equatorial Guinea'], ['ER', '291', 'Eritrea'],
    ['EE', '372', 'Estonia'], ['SZ', '268', 'Eswatini'], ['ET', '251', 'Ethiopia'], ['FJ', '679', 'Fiji'],
    ['FI', '358', 'Finland'], ['FR', '33', 'France'], ['GA', '241', 'Gabon'], ['GM', '220', 'Gambia'],
    ['GE', '995', 'Georgia'], ['DE', '49', 'Germany'], ['GH', '233', 'Ghana'], ['GR', '30', 'Greece'],
    ['GD', '1473', 'Grenada'], ['GU', '1671', 'Guam'], ['GT', '502', 'Guatemala'], ['GN', '224', 'Guinea'],
    ['GW', '245', 'Guinea-Bissau'], ['GY', '592', 'Guyana'], ['HT', '509', 'Haiti'], ['HN', '504', 'Honduras'],
    ['HK', '852', 'Hong Kong'], ['HU', '36', 'Hungary'], ['IS', '354', 'Iceland'], ['IN', '91', 'India'],
    ['ID', '62', 'Indonesia'], ['IR', '98', 'Iran'], ['IQ', '964', 'Iraq'], ['IE', '353', 'Ireland'],
    ['IL', '972', 'Israel'], ['IT', '39', 'Italy'], ['JM', '1876', 'Jamaica'], ['JP', '81', 'Japan'],
    ['JO', '962', 'Jordan'], ['KZ', '7', 'Kazakhstan'], ['KE', '254', 'Kenya'], ['KI', '686', 'Kiribati'],
    ['KW', '965', 'Kuwait'], ['KG', '996', 'Kyrgyzstan'], ['LA', '856', 'Laos'], ['LV', '371', 'Latvia'],
    ['LB', '961', 'Lebanon'], ['LS', '266', 'Lesotho'], ['LR', '231', 'Liberia'], ['LY', '218', 'Libya'],
    ['LI', '423', 'Liechtenstein'], ['LT', '370', 'Lithuania'], ['LU', '352', 'Luxembourg'], ['MO', '853', 'Macau'],
    ['MG', '261', 'Madagascar'], ['MW', '265', 'Malawi'], ['MY', '60', 'Malaysia'], ['MV', '960', 'Maldives'],
    ['ML', '223', 'Mali'], ['MT', '356', 'Malta'], ['MH', '692', 'Marshall Islands'], ['MR', '222', 'Mauritania'],
    ['MU', '230', 'Mauritius'], ['MX', '52', 'Mexico'], ['FM', '691', 'Micronesia'], ['MD', '373', 'Moldova'],
    ['MC', '377', 'Monaco'], ['MN', '976', 'Mongolia'], ['ME', '382', 'Montenegro'], ['MA', '212', 'Morocco'],
    ['MZ', '258', 'Mozambique'], ['MM', '95', 'Myanmar'], ['NA', '264', 'Namibia'], ['NR', '674', 'Nauru'],
    ['NP', '977', 'Nepal'], ['NL', '31', 'Netherlands'], ['NZ', '64', 'New Zealand'], ['NI', '505', 'Nicaragua'],
    ['NE', '227', 'Niger'], ['NG', '234', 'Nigeria'], ['MK', '389', 'North Macedonia'], ['NO', '47', 'Norway'],
    ['OM', '968', 'Oman'], ['PK', '92', 'Pakistan'], ['PW', '680', 'Palau'], ['PS', '970', 'Palestine'],
    ['PA', '507', 'Panama'], ['PG', '675', 'Papua New Guinea'], ['PY', '595', 'Paraguay'], ['PE', '51', 'Peru'],
    ['PH', '63', 'Philippines'], ['PL', '48', 'Poland'], ['PT', '351', 'Portugal'], ['PR', '1', 'Puerto Rico'],
    ['QA', '974', 'Qatar'], ['RO', '40', 'Romania'], ['RU', '7', 'Russia'], ['RW', '250', 'Rwanda'],
    ['KN', '1869', 'Saint Kitts and Nevis'], ['LC', '1758', 'Saint Lucia'], ['VC', '1784', 'Saint Vincent and the Grenadines'],
    ['WS', '685', 'Samoa'], ['SM', '378', 'San Marino'], ['ST', '239', 'São Tomé and Príncipe'], ['SA', '966', 'Saudi Arabia'],
    ['SN', '221', 'Senegal'], ['RS', '381', 'Serbia'], ['SC', '248', 'Seychelles'], ['SL', '232', 'Sierra Leone'],
    ['SG', '65', 'Singapore'], ['SK', '421', 'Slovakia'], ['SI', '386', 'Slovenia'], ['SB', '677', 'Solomon Islands'],
    ['SO', '252', 'Somalia'], ['ZA', '27', 'South Africa'], ['KR', '82', 'South Korea'], ['SS', '211', 'South Sudan'],
    ['ES', '34', 'Spain'], ['LK', '94', 'Sri Lanka'], ['SD', '249', 'Sudan'], ['SR', '597', 'Suriname'],
    ['SE', '46', 'Sweden'], ['CH', '41', 'Switzerland'], ['SY', '963', 'Syria'], ['TW', '886', 'Taiwan'],
    ['TJ', '992', 'Tajikistan'], ['TZ', '255', 'Tanzania'], ['TH', '66', 'Thailand'], ['TL', '670', 'Timor-Leste'],
    ['TG', '228', 'Togo'], ['TO', '676', 'Tonga'], ['TT', '1868', 'Trinidad and Tobago'], ['TN', '216', 'Tunisia'],
    ['TR', '90', 'Turkey'], ['TM', '993', 'Turkmenistan'], ['TV', '688', 'Tuvalu'], ['UG', '256', 'Uganda'],
    ['UA', '380', 'Ukraine'], ['AE', '971', 'United Arab Emirates'], ['GB', '44', 'United Kingdom'],
    ['US', '1', 'United States'], ['UY', '598', 'Uruguay'], ['UZ', '998', 'Uzbekistan'], ['VU', '678', 'Vanuatu'],
    ['VA', '39', 'Vatican City'], ['VE', '58', 'Venezuela'], ['VN', '84', 'Vietnam'], ['YE', '967', 'Yemen'],
    ['ZM', '260', 'Zambia'], ['ZW', '263', 'Zimbabwe']
  ];

  const PHONE_REGIONS = PHONE_COUNTRIES.map(([code, dial, name]) => {
    const rules = PHONE_REGION_RULES[code] || {};
    return {
      code,
      dial,
      name,
      min: rules.min || BASIC_INFO.PHONE_DEFAULT_MIN,
      max: rules.max || BASIC_INFO.PHONE_DEFAULT_MAX,
      trunk: !!rules.trunk,
      example: rules.example || '1234567890'
    };
  });

  function getPhoneRegion(countryCode) {
    return PHONE_REGIONS.find((r) => r.code === countryCode) || PHONE_REGIONS.find((r) => r.code === 'GB');
  }

  function normalizeNationalNumber(value, region) {
    let digits = String(value || '').replace(/\D/g, '');
    if (region.trunk && digits.startsWith('0')) {
      digits = digits.slice(1);
    }
    return digits;
  }

  function isValidPhone(value, countryCode) {
    const region = getPhoneRegion(countryCode);
    const national = normalizeNationalNumber(value, region);
    if (!national || national.length < region.min || national.length > region.max) return false;
    return /^[1-9]\d*$/.test(national);
  }

  function formatE164(value, countryCode) {
    const region = getPhoneRegion(countryCode);
    const national = normalizeNationalNumber(value, region);
    return '+' + region.dial + national;
  }

  function getPhoneValidationMessage(countryCode) {
    const region = getPhoneRegion(countryCode);
    const trunkHint = region.trunk ? ' You can include a leading 0.' : '';
    return `Please enter a valid ${region.name} phone number (${region.min}–${region.max} digits, e.g. ${region.example}).${trunkHint}`;
  }

  function sanitizePhoneInput(value, countryCode) {
    const region = getPhoneRegion(countryCode);
    let digits = String(value || '').replace(/\D/g, '');
    const maxLen = region.max + (region.trunk ? 1 : 0);
    return digits.slice(0, maxLen);
  }

  function isValidName(value) {
    const trimmed = String(value || '').trim();
    if (trimmed.length < BASIC_INFO.NAME_MIN || trimmed.length > BASIC_INFO.NAME_MAX) return false;
    return BASIC_INFO.NAME_PATTERN.test(trimmed);
  }

  function isValidEmail(value) {
    const trimmed = String(value || '').trim();
    if (!trimmed || trimmed.length > BASIC_INFO.EMAIL_MAX) return false;
    return BASIC_INFO.EMAIL_PATTERN.test(trimmed);
  }

  function sanitizeNameInput(value) {
    return String(value || '').replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ' -]/g, '').slice(0, BASIC_INFO.NAME_MAX);
  }

  const DOB = {
    MAX_AGE_YEARS: 120
  };

  function sanitizeDobPart(value, maxLen) {
    return String(value || '').replace(/\D/g, '').slice(0, maxLen);
  }

  function sanitizeIntegerInput(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function sanitizeDecimalInput(value) {
    let str = String(value || '').replace(/[^\d.,]/g, '').replace(',', '.');
    const dotIndex = str.indexOf('.');
    if (dotIndex === -1) return str;

    const whole = str.slice(0, dotIndex);
    const fraction = str.slice(dotIndex + 1).replace(/\./g, '');
    return `${whole}.${fraction}`;
  }

  function calculateAge(birthDate, referenceDate) {
    const ref = new Date(referenceDate);
    ref.setHours(0, 0, 0, 0);
    let age = ref.getFullYear() - birthDate.getFullYear();
    const monthDiff = ref.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && ref.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  function parseDateOfBirth(dayStr, monthStr, yearStr) {
    const dayRaw = String(dayStr || '').trim();
    const monthRaw = String(monthStr || '').trim();
    const yearRaw = String(yearStr || '').trim();
    const allFilled = !!(dayRaw && monthRaw && yearRaw);

    if (!dayRaw) return { valid: false, field: 'dobDay', message: 'Please enter a day.', banner: false };
    if (!monthRaw) return { valid: false, field: 'dobMonth', message: 'Please enter a month.', banner: false };
    if (!yearRaw) return { valid: false, field: 'dobYear', message: 'Please enter a year.', banner: false };

    if (!/^\d{1,2}$/.test(dayRaw)) {
      return { valid: false, field: 'dobDay', message: 'Day must be 1 or 2 digits.', banner: allFilled };
    }
    if (!/^\d{1,2}$/.test(monthRaw)) {
      return { valid: false, field: 'dobMonth', message: 'Month must be 1 or 2 digits.', banner: allFilled };
    }
    if (!/^\d{4}$/.test(yearRaw)) {
      return { valid: false, field: 'dobYear', message: 'Please enter a 4-digit year.', banner: allFilled };
    }

    const day = parseInt(dayRaw, 10);
    const month = parseInt(monthRaw, 10);
    const year = parseInt(yearRaw, 10);

    if (day < 1 || day > 31) {
      return { valid: false, field: 'dobDay', message: 'Day must be between 1 and 31.', banner: true };
    }
    if (month < 1 || month > 12) {
      return { valid: false, field: 'dobMonth', message: 'Month must be between 1 and 12.', banner: true };
    }

    const currentYear = new Date().getFullYear();
    const minYear = currentYear - DOB.MAX_AGE_YEARS;
    if (year < minYear || year > currentYear) {
      return {
        valid: false,
        field: 'dobYear',
        message: `Year must be between ${minYear} and ${currentYear}.`,
        banner: true
      };
    }

    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return { valid: false, field: 'dobDay', message: 'Please enter a valid date.', banner: true };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) {
      return { valid: false, field: 'dobDay', message: 'Date of birth cannot be in the future.', banner: true };
    }

    const age = calculateAge(date, today);

    return {
      valid: true,
      day,
      month,
      year,
      age,
      iso: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    };
  }

  function parseGlp1TreatmentStart(dayStr, monthStr, yearStr) {
    const dayRaw = String(dayStr || '').trim();
    const monthRaw = String(monthStr || '').trim();
    const yearRaw = String(yearStr || '').trim();
    const allFilled = !!(dayRaw && monthRaw && yearRaw);

    if (!dayRaw) return { valid: false, field: 'glp1StartDay', message: 'Please enter a day.', banner: false };
    if (!monthRaw) return { valid: false, field: 'glp1StartMonth', message: 'Please enter a month.', banner: false };
    if (!yearRaw) return { valid: false, field: 'glp1StartYear', message: 'Please enter a year.', banner: false };

    if (!/^\d{1,2}$/.test(dayRaw)) {
      return { valid: false, field: 'glp1StartDay', message: 'Day must be 1 or 2 digits.', banner: allFilled };
    }
    if (!/^\d{1,2}$/.test(monthRaw)) {
      return { valid: false, field: 'glp1StartMonth', message: 'Month must be 1 or 2 digits.', banner: allFilled };
    }
    if (!/^\d{4}$/.test(yearRaw)) {
      return { valid: false, field: 'glp1StartYear', message: 'Please enter a 4-digit year.', banner: allFilled };
    }

    const day = parseInt(dayRaw, 10);
    const month = parseInt(monthRaw, 10);
    const year = parseInt(yearRaw, 10);

    if (day < 1 || day > 31) {
      return { valid: false, field: 'glp1StartDay', message: 'Day must be between 1 and 31.', banner: true };
    }
    if (month < 1 || month > 12) {
      return { valid: false, field: 'glp1StartMonth', message: 'Month must be between 1 and 12.', banner: true };
    }

    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 15;
    if (year < minYear || year > currentYear) {
      return {
        valid: false,
        field: 'glp1StartYear',
        message: `Year must be between ${minYear} and ${currentYear}.`,
        banner: true
      };
    }

    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return { valid: false, field: 'glp1StartDay', message: 'Please enter a valid date.', banner: true };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) {
      return { valid: false, field: 'glp1StartDay', message: 'Start date cannot be in the future.', banner: true };
    }

    return {
      valid: true,
      day,
      month,
      year,
      iso: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    };
  }

  function parseGlp1LastDose(dayStr, monthStr, yearStr, treatmentStartIso) {
    const dayRaw = String(dayStr || '').trim();
    const monthRaw = String(monthStr || '').trim();
    const yearRaw = String(yearStr || '').trim();
    const allFilled = !!(dayRaw && monthRaw && yearRaw);

    if (!dayRaw) return { valid: false, field: 'glp1LastDoseDay', message: 'Please enter a day.', banner: false };
    if (!monthRaw) return { valid: false, field: 'glp1LastDoseMonth', message: 'Please enter a month.', banner: false };
    if (!yearRaw) return { valid: false, field: 'glp1LastDoseYear', message: 'Please enter a year.', banner: false };

    if (!/^\d{1,2}$/.test(dayRaw)) {
      return { valid: false, field: 'glp1LastDoseDay', message: 'Day must be 1 or 2 digits.', banner: allFilled };
    }
    if (!/^\d{1,2}$/.test(monthRaw)) {
      return { valid: false, field: 'glp1LastDoseMonth', message: 'Month must be 1 or 2 digits.', banner: allFilled };
    }
    if (!/^\d{4}$/.test(yearRaw)) {
      return { valid: false, field: 'glp1LastDoseYear', message: 'Please enter a 4-digit year.', banner: allFilled };
    }

    const day = parseInt(dayRaw, 10);
    const month = parseInt(monthRaw, 10);
    const year = parseInt(yearRaw, 10);

    if (day < 1 || day > 31) {
      return { valid: false, field: 'glp1LastDoseDay', message: 'Day must be between 1 and 31.', banner: true };
    }
    if (month < 1 || month > 12) {
      return { valid: false, field: 'glp1LastDoseMonth', message: 'Month must be between 1 and 12.', banner: true };
    }

    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 15;
    if (year < minYear || year > currentYear) {
      return {
        valid: false,
        field: 'glp1LastDoseYear',
        message: `Year must be between ${minYear} and ${currentYear}.`,
        banner: true
      };
    }

    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
      return { valid: false, field: 'glp1LastDoseDay', message: 'Please enter a valid date.', banner: true };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) {
      return { valid: false, field: 'glp1LastDoseDay', message: 'Last dose date cannot be in the future.', banner: true };
    }

    const iso = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    if (treatmentStartIso && iso < treatmentStartIso) {
      return {
        valid: false,
        field: 'glp1LastDoseDay',
        message: 'Last dose cannot be before your treatment start date.',
        banner: true
      };
    }

    return { valid: true, day, month, year, iso };
  }

  class AssessmentForm {
    constructor(root) {
      this.root = root;
      this.currentStep = 0;
      this.data = this.loadData();
      this.gpSearchTimer = null;
      this.gpSearchAbort = null;
      this.gpSearchResults = [];
      this.gpRelayRequestId = 0;
      this.gpRelayPopup = null;
      this.gpRelayReady = false;
      this.uploadcareWidget = null;
      this.scalePhotoUploadcareWidget = null;
      this.oneIdPollTimer = null;
      this.oneIdPopup = null;
      this.wegovyPillStarterVariantId = Number(root.dataset.wegovyPillStarterVariantId) || 0;
      applyWegovyPillVariantIds(root);
      this.init();
    }

    loadData() {
      try {
        const saved = sessionStorage.getItem(STORAGE_KEY);
        return saved ? JSON.parse(saved) : {};
      } catch (_) {
        return {};
      }
    }

    saveData() {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.data));
      } catch (_) {}
    }

    init() {
      this.stepsEl = this.root.querySelector('[data-assessment-steps]');
      this.progressFill = this.root.querySelector('[data-assessment-progress]');
      this.navEl = this.root.querySelector('[data-assessment-nav]');

      this.bindEvents();
      this.initPhoneCountrySelect();
      this.initGpSearchRelayListener();
      this.restoreValues();
      this.applyBasicInfoFromUrlParams();
      this.initPrescriptionEvidenceUpload();

      const savedIndex = Number(this.data._stepIndex);
      let startIndex = Number.isInteger(savedIndex) && savedIndex >= 0 && savedIndex < STEPS.length
        ? savedIndex
        : 0;

      if (this.data.ineligible) {
        const ineligibleIndex = STEPS.indexOf('ineligible');
        if (ineligibleIndex >= 0) startIndex = ineligibleIndex;
      } else if (this.hasNoEligibleMedicationsFromAllergies()) {
        this.markIneligible('medication_allergies');
        const ineligibleIndex = STEPS.indexOf('ineligible');
        if (ineligibleIndex >= 0) startIndex = ineligibleIndex;
      }

      this.goToStep(startIndex, false);

      if (!this.root.querySelector('[data-step].is-active')) {
      this.goToStep(0, false);
      }

      if (this.needsMedicationSelectionStep()) {
        const skipSteps = new Set([
          'previous-prescription',
          'glp1-treatment-start',
          'glp1-last-dose',
          'pen-doses-remaining',
          'prescription-evidence',
          'medication-preference',
          'next-dose-preference',
          'medication-experience'
        ]);
        if (skipSteps.has(STEPS[this.currentStep])) {
          if (this.redirectIfAllergyMedicationKickOut()) return;
          const medIndex = STEPS.indexOf('medication-selection');
          if (medIndex >= 0) this.goToStep(medIndex, false);
        }
      }

      if (this.hasPendingAssessmentImages()) {
        this.syncAssessmentImagesToApi();
      }
    }

    initPhoneCountrySelect() {
      const select = this.root.querySelector('[data-phone-country]');
      if (!select || select.dataset.populated) return;

      select.innerHTML = '';

      PHONE_REGIONS.slice()
        .sort((a, b) => {
          if (a.code === 'GB') return -1;
          if (b.code === 'GB') return 1;
          return a.name.localeCompare(b.name);
        })
        .forEach((region) => {
        const option = document.createElement('option');
        option.value = region.code;
        option.textContent = '+' + region.dial;
        option.title = region.name;
        select.appendChild(option);
      });

      select.dataset.populated = 'true';

      if (!this.data.phoneCountry || !getPhoneRegion(this.data.phoneCountry)) {
        this.data.phoneCountry = 'GB';
      }

      select.value = this.data.phoneCountry;
      this.updatePhoneFieldHints();
    }

    getPhoneCountry() {
      const select = this.root.querySelector('[data-phone-country]');
      return this.data.phoneCountry || select?.value || 'GB';
    }

    updatePhoneFieldHints() {
      const region = getPhoneRegion(this.getPhoneCountry());
      const phoneInput = this.root.querySelector('[name="phone"]');
      if (!phoneInput) return;

      phoneInput.placeholder = region.example;
      phoneInput.maxLength = region.max + (region.trunk ? 1 : 0);
    }

    bindEvents() {
      this.root.addEventListener('click', (e) => this.handleClick(e));
      this.root.addEventListener('change', (e) => this.handleChange(e));
      this.root.addEventListener('input', (e) => this.handleInput(e));
      this.root.addEventListener('blur', (e) => this.handleBlur(e), true);
    }

    handleClick(e) {
      const backBtn = e.target.closest('[data-assessment-back]');
      if (backBtn) {
        this.goBack();
        return;
      }

      const gpOption = e.target.closest('[data-gp-option]');
      if (gpOption) {
        const index = Number(gpOption.dataset.gpIndex);
        const org = this.gpSearchResults[index];
        if (org) this.selectGpOrganisation(org);
        return;
      }

      const uploadTrigger = e.target.closest('[data-prescription-upload-trigger]');
      if (uploadTrigger) {
        this.initPrescriptionEvidenceUpload();
        if (this.uploadcareWidget) this.uploadcareWidget.openDialog();
        return;
      }

      const scaleUploadTrigger = e.target.closest('[data-scale-upload-trigger]');
      if (scaleUploadTrigger) {
        this.initScalePhotoUpload();
        if (this.scalePhotoUploadcareWidget) this.scalePhotoUploadcareWidget.openDialog();
        return;
      }

      const oneIdTrigger = e.target.closest('[data-oneid-verify-trigger]');
      if (oneIdTrigger && !oneIdTrigger.disabled) {
        this.startIdentityVerification();
        return;
      }

      const medCheckoutBtn = e.target.closest('[data-med-checkout]');
      if (medCheckoutBtn && !medCheckoutBtn.disabled) {
        this.handleMedicationCheckout(medCheckoutBtn);
        return;
      }

      const optionalExtraSkip = e.target.closest('[data-optional-extras-skip]');
      if (optionalExtraSkip) {
        this.goToDeliveryDateStep();
        return;
      }

      const deliveryPrev = e.target.closest('[data-delivery-prev]');
      if (deliveryPrev) {
        this.shiftDeliveryCalendarMonth(-1);
        return;
      }

      const deliveryNext = e.target.closest('[data-delivery-next]');
      if (deliveryNext) {
        this.shiftDeliveryCalendarMonth(1);
        return;
      }

      const deliveryDay = e.target.closest('[data-delivery-day]');
      if (deliveryDay && !deliveryDay.disabled) {
        this.selectDeliveryDate(deliveryDay.dataset.date);
        return;
      }

      const deliverySubmit = e.target.closest('[data-delivery-submit]');
      if (deliverySubmit && !deliverySubmit.disabled) {
        void this.submitDeliveryDate();
        return;
      }

      const optionalExtraAdd = e.target.closest('[data-optional-extra-add]');
      if (optionalExtraAdd && !optionalExtraAdd.disabled) {
        this.handleOptionalExtraAdd(optionalExtraAdd);
        return;
      }

      if (!e.target.closest('[data-gp-search-field]')) {
        this.hideGpResults();
      }

      const selector = e.target.closest('[data-selector]');
      if (selector) {
        this.handleSelector(selector);
        return;
      }

      const toggle = e.target.closest('[data-unit-toggle]');
      if (toggle) {
        this.handleUnitToggle(toggle);
        return;
      }

      const returnHomeBtn = e.target.closest('[data-assessment-return-home]');
      if (returnHomeBtn) {
        clearAssessmentSession();
        window.location.href = '/';
        return;
      }

      const continueBtn = e.target.closest('[data-assessment-continue]');
      if (continueBtn) {
        if (continueBtn.classList.contains('is-disabled')) {
          this.validateCurrentStep();
          return;
        }
        void this.handleContinue();
        return;
      }

      const infoLink = e.target.closest('[data-measuring-info]');
      if (infoLink) {
        const callout = this.root.querySelector('[data-measuring-callout]');
        if (callout) callout.hidden = !callout.hidden;
      }
    }

    handleChange(e) {
      if (e.target.matches('[data-optional-extra-select]')) {
        this.updateOptionalExtraSelectState(e.target);
        return;
      }

      if (e.target.matches('[data-assessment-checkbox]')) {
        this.data.counsellingAgreed = e.target.checked;
        this.updateContinueState();
        return;
      }

      if (e.target.matches('[data-confirm-declarations-checkbox]')) {
        this.data.confirmDeclarationsAgreed = e.target.checked;
        this.saveData();
        this.updateContinueState();
        return;
      }

      if (e.target.matches('[data-type2-checkbox]')) {
        this.data.type2Acknowledged = e.target.checked;
        this.saveData();
        this.updateContinueState();
        return;
      }

      if (e.target.matches('[data-gp-unable-checkbox]')) {
        this.data.gpUnableToProvide = e.target.checked;
        if (e.target.checked) {
          delete this.data.gpSurgery;
          delete this.data.gpSearch;
          const input = this.root.querySelector('[data-gp-input]');
          if (input) input.value = '';
          this.hideGpResults();
        } else {
          delete this.data.gpUnableReason;
          const group = this.root.querySelector('[data-selector-group][data-key="gpUnableReason"]');
          if (group) {
            group.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
          }
          this.clearGpUnableFollowupFields(null);
        }
        this.updateGpSearchState();
        this.updateGpUnableDetail();
        this.saveData();
        this.updateContinueState();
        return;
      }

      if (e.target.matches('[data-gp-register-checkbox]')) {
        this.data.gpRegisterAcknowledged = e.target.checked;
        this.saveData();
        this.updateContinueState();
        return;
      }

      if (e.target.matches('[data-phone-country]')) {
        this.data.phoneCountry = e.target.value;
        this.updatePhoneFieldHints();
        this.saveData();
        this.updateContinueState();
      }
    }

    initGpSearchRelayListener() {
      if (this.gpRelayListenerBound) return;
      this.gpRelayListenerBound = true;

      window.addEventListener('message', (event) => {
        if (event.data?.type === 'gp-relay-ready') {
          this.gpRelayReady = true;
        }
      });

      const gpInput = this.root.querySelector('[data-gp-input]');
      if (gpInput) {
        gpInput.addEventListener('focus', () => {
          if (this.data.gpUnableToProvide) return;
          if (!this.canUseDirectGpApi()) {
            this.ensureGpRelayPopup();
          }
        });
      }
    }

    handleInput(e) {
      const field = e.target;
      if (!field.matches('input, textarea, [data-assessment-textarea]')) return;

      if (field.name === 'gpSearch') {
        if (this.data.gpUnableToProvide) return;

        const selected = this.data.gpSurgery;
        if (selected && field.value.trim() !== selected.Name) {
          delete this.data.gpSurgery;
        }
        this.data.gpSearch = field.value;
        this.saveData();
        this.queueGpSearch(field.value);
        this.updateContinueState();
        return;
      }

      if (field.name === 'firstName' || field.name === 'lastName') {
        const cleaned = sanitizeNameInput(field.value);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'phone') {
        const cleaned = sanitizePhoneInput(field.value, this.getPhoneCountry());
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'dobDay') {
        const cleaned = sanitizeDobPart(field.value, 2);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'dobMonth') {
        const cleaned = sanitizeDobPart(field.value, 2);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'dobYear') {
        const cleaned = sanitizeDobPart(field.value, 4);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'dobDay' || field.name === 'dobMonth' || field.name === 'dobYear') {
        this.updateDobErrorBanner();
      }

      if (field.name === 'glp1StartDay') {
        const cleaned = sanitizeDobPart(field.value, 2);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'glp1StartMonth') {
        const cleaned = sanitizeDobPart(field.value, 2);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'glp1StartYear') {
        const cleaned = sanitizeDobPart(field.value, 4);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'glp1StartDay' || field.name === 'glp1StartMonth' || field.name === 'glp1StartYear') {
        this.updateGlp1StartErrorBanner();
      }

      if (field.name === 'glp1LastDoseDay') {
        const cleaned = sanitizeDobPart(field.value, 2);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'glp1LastDoseMonth') {
        const cleaned = sanitizeDobPart(field.value, 2);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'glp1LastDoseYear') {
        const cleaned = sanitizeDobPart(field.value, 4);
        if (field.value !== cleaned) field.value = cleaned;
      }

      if (field.name === 'glp1LastDoseDay' || field.name === 'glp1LastDoseMonth' || field.name === 'glp1LastDoseYear') {
        this.updateGlp1LastDoseErrorBanner();
        this.updateNextDosePreferenceOptions();
      }

      if (BODY_MEASUREMENT_INTEGER_FIELDS.has(field.name)) {
        const before = field.value;
        const cleaned = sanitizeIntegerInput(before);
        if (before !== cleaned) {
          field.value = cleaned;
          this.showFieldError(field.name, BODY_MEASUREMENT_RANGES.NUMBERS_ONLY);
        }
        this.validateBodyMeasurementField(field.name);
      } else if (BODY_MEASUREMENT_DECIMAL_FIELDS.has(field.name)) {
        const before = field.value;
        const cleaned = sanitizeDecimalInput(before);
        if (before !== cleaned) {
          field.value = cleaned;
          this.showFieldError(field.name, BODY_MEASUREMENT_RANGES.NUMBERS_ONLY);
        }
        this.validateBodyMeasurementField(field.name);
      } else {
      field.classList.remove('is-error');
      const errorEl = field.closest('[data-field]')?.querySelector('[data-field-error]');
      if (errorEl) errorEl.classList.remove('is-visible');
      }

      this.syncFieldToData(field);
      this.updateContinueState();
    }

    handleBlur(e) {
      const field = e.target;
      if (!field.matches('input[name]')) return;

      if (
        BODY_MEASUREMENT_INTEGER_FIELDS.has(field.name)
        || BODY_MEASUREMENT_DECIMAL_FIELDS.has(field.name)
      ) {
        this.validateBodyMeasurementField(field.name);
      }
    }

    validateBodyMeasurementField(name) {
      if (STEPS[this.currentStep] !== 'body-measurements') return;

      if (['heightFeet', 'heightInches', 'heightCm'].includes(name)) {
        this.validateHeightField();
        return;
      }

      if (['initialStones', 'initialPounds', 'initialKg'].includes(name)) {
        this.validateWeightFields('initial', this.data.medicationStatus === 'switching');
        return;
      }

      if (['currentStones', 'currentPounds', 'currentKg'].includes(name)) {
        this.validateWeightFields('current', true);
        return;
      }

      if (['targetStones', 'targetPounds', 'targetKg'].includes(name)) {
        const unit = this.data.unitSystem || 'imperial';
        const hasTarget = unit === 'imperial'
          ? (this.getFieldValue('targetStones') || this.getFieldValue('targetPounds'))
          : this.getFieldValue('targetKg');
        if (hasTarget) {
          this.validateWeightFields('target', false);
        } else {
          this.hideRangeError('targetKg');
          this.hideFieldError('targetStones');
          this.hideFieldError('targetPounds');
        }
        return;
      }

      if (name === 'waistCm') {
        const waist = parseNumericField(this.getFieldValue('waistCm'));
        const waistRange = BODY_MEASUREMENT_RANGES.WAIST_CM;
        if (waist.empty) {
          this.hideRangeError('waistCm');
          return;
        }
        if (!waist.valid || waist.value < waistRange.min || waist.value > waistRange.max) {
          this.showRangeError('waistCm', waistRange.message);
        } else {
          this.hideRangeError('waistCm');
        }
      }
    }

    syncFieldToData(field) {
      const name = field.name;
      if (!name) return;
      this.data[name] = field.value;
      this.saveData();
    }

    handleSelector(btn) {
      const group = btn.closest('[data-selector-group]');
      if (!group) return;

      const isMulti = group.dataset.multi === 'true';
      const value = btn.dataset.value;

      if (isMulti) {
        const noneValue = group.dataset.noneValue;
        const selected = this.data[group.dataset.key] || [];

        if (value === noneValue) {
          this.data[group.dataset.key] = [value];
          group.querySelectorAll('[data-selector]').forEach((el) => {
            el.classList.toggle('is-selected', el.dataset.value === value);
          });
        } else {
          let next = selected.filter((v) => v !== noneValue);
          if (next.includes(value)) {
            next = next.filter((v) => v !== value);
          } else {
            next.push(value);
          }
          this.data[group.dataset.key] = next;
          group.querySelectorAll('[data-selector]').forEach((el) => {
            const v = el.dataset.value;
            if (v === noneValue) {
              el.classList.remove('is-selected');
            } else {
              el.classList.toggle('is-selected', next.includes(v));
            }
          });
        }
      } else {
        this.data[group.dataset.key] = value;

        if (group.dataset.key === 'nextDosePreference') {
          const variantId = btn.dataset.variantId;
          if (variantId && variantId !== '0') {
            this.data.nextDosePreferenceVariantId = Number(variantId);
          } else {
            delete this.data.nextDosePreferenceVariantId;
          }
        }

        const isPrescriptionDose = group.dataset.key === 'previousPrescriptionDose';
        group.querySelectorAll('[data-selector]').forEach((el) => {
          const isMatch = isPrescriptionDose
            ? el.dataset.value === value && el.dataset.doseFor === this.data.previouslyPrescribed
            : el.dataset.value === value;
          el.classList.toggle('is-selected', isMatch);
        });

        if (group.dataset.key === 'biologicalSex') {
          this.toggleFemaleSection(value === 'female');
          this.updateFemaleOnlyApplicableConditions();
        }

        if (group.dataset.key === 'pregnancyStatus') {
          const ineligible = ['Pregnant', 'Trying to become pregnant', 'Breastfeeding'].includes(value);
          this.data.pregnancyIneligible = ineligible;
        }

        if (group.dataset.key === 'ethnicBackground') {
          this.updateEthnicOther();
          if (value === 'Other') {
            requestAnimationFrame(() => {
              const detail = this.root.querySelector('[data-ethnic-other]');
              const input = detail?.querySelector('[data-assessment-textarea]');
              if (input && !detail.hidden) input.focus();
            });
          }
        }

        if (group.dataset.key === 'comorbidities') {
          this.pruneComorbidityFollowups();
          if ((this.data.followupIndex || 0) >= this.getFollowupConditions().length) {
            this.data.followupIndex = 0;
          }
        }

        if (group.dataset.key === 'otherAllergies') {
          this.updateOtherAllergiesDetail();
          if (value === 'yes') {
            requestAnimationFrame(() => {
              const detail = this.root.querySelector('[data-other-allergies-detail]');
              const input = detail?.querySelector('[data-assessment-textarea]');
              if (input && !detail.hidden) input.focus();
            });
          }
        }

        if (group.dataset.key === 'illnessesOrOperations') {
          this.updateIllnessesOperationsDetail();
          if (value === 'yes') {
            requestAnimationFrame(() => {
              const detail = this.root.querySelector('[data-illnesses-operations-detail]');
              const input = detail?.querySelector('[data-assessment-textarea]');
              if (input && !detail.hidden) input.focus();
            });
          }
        }

        if (group.dataset.key === 'medicationStatus') {
          if (value === 'never' || value === 'used_before') {
            delete this.data.previouslyPrescribed;
            delete this.data.previousPrescriptionDose;
            delete this.data.glp1TreatmentStartDate;
            delete this.data.glp1LastDoseDate;
            delete this.data.penDosesRemaining;
            delete this.data.prescriptionEvidence;
            delete this.data.prescriptionEvidenceUpload;
            delete this.data.prescriptionEvidenceUploadUuid;
            delete this.data.prescriptionEvidenceAcknowledgement;
            delete this.data.medicationPreference;
            delete this.data.nextDosePreference;
            delete this.data.nextDosePreferenceVariantId;
            delete this.data.medicationExperience;
            delete this.data.penCycleReturnBox;
            ['glp1StartDay', 'glp1StartMonth', 'glp1StartYear', 'glp1LastDoseDay', 'glp1LastDoseMonth', 'glp1LastDoseYear'].forEach((name) => {
              delete this.data[name];
              const field = this.root.querySelector(`[name="${name}"]`);
              if (field) field.value = '';
            });
            const prevGroup = this.root.querySelector('[data-selector-group][data-key="previouslyPrescribed"]');
            if (prevGroup) {
              prevGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
            }
            const doseGroup = this.root.querySelector('[data-selector-group][data-key="previousPrescriptionDose"]');
            if (doseGroup) {
              doseGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
            }
            const penDosesGroup = this.root.querySelector('[data-selector-group][data-key="penDosesRemaining"]');
            if (penDosesGroup) {
              penDosesGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
            }
            const evidenceGroup = this.root.querySelector('[data-selector-group][data-key="prescriptionEvidence"]');
            if (evidenceGroup) {
              evidenceGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
            }
            const evidenceAckGroup = this.root.querySelector('[data-selector-group][data-key="prescriptionEvidenceAcknowledgement"]');
            if (evidenceAckGroup) {
              evidenceAckGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
            }
            this.updateMedicationPreferenceOptions();
            this.updateNextDosePreferenceOptions();
            if (this.uploadcareWidget) this.uploadcareWidget.value(null);
            this.updatePrescriptionUploadPreview(null);
            this.updatePrescriptionEvidenceDetail();
            this.updatePreviousPrescriptionDose();
          }
        }

        if (group.dataset.key === 'previouslyPrescribed') {
          delete this.data.previousPrescriptionDose;
          delete this.data.medicationPreference;
          delete this.data.nextDosePreference;
          delete this.data.nextDosePreferenceVariantId;
          if (value === PREVIOUS_PRESCRIPTION.WEGOVY_PILL) {
            delete this.data.penDosesRemaining;
            delete this.data.penCycleReturnBox;
            const penDosesGroup = this.root.querySelector('[data-selector-group][data-key="penDosesRemaining"]');
            if (penDosesGroup) {
              penDosesGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
            }
            const penCycleGroup = this.root.querySelector('[data-selector-group][data-key="penCycleReturnBox"]');
            if (penCycleGroup) {
              penCycleGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
            }
          }
          const doseGroup = this.root.querySelector('[data-selector-group][data-key="previousPrescriptionDose"]');
          if (doseGroup) {
            doseGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
          }
          this.updatePreviousPrescriptionDose();
          this.updateMedicationPreferenceOptions();
          this.updateNextDosePreferenceOptions();
        }

        if (group.dataset.key === 'previousPrescriptionDose') {
          delete this.data.nextDosePreference;
          delete this.data.nextDosePreferenceVariantId;
        }

        if (group.dataset.key === 'medicationPreference') {
          delete this.data.nextDosePreference;
          delete this.data.nextDosePreferenceVariantId;
          delete this.data.penCycleReturnBox;
        }

        if (group.dataset.key === 'prescriptionEvidence') {
          this.clearPrescriptionEvidenceFollowup(value);
          this.updatePrescriptionEvidenceDetail();
        }

        if (group.dataset.key === 'scalePhoto') {
          this.clearScalePhotoFollowup(value);
          this.updateScalePhotoDetail();
        }

        if (group.dataset.key === 'otherMedications') {
          this.updateOtherMedicationsDetail();
          if (value === 'yes') {
            requestAnimationFrame(() => {
              const detail = this.root.querySelector('[data-other-medications-detail]');
              const input = detail?.querySelector('[data-assessment-textarea]');
              if (input && !detail.hidden) input.focus();
            });
          }
        }

        if (group.dataset.key === 'gpUnableReason') {
          this.clearGpUnableFollowupFields(value);
          this.updateGpUnableFollowup();
          if (value === GP_UNABLE_REASON.DONT_WANT) {
            requestAnimationFrame(() => {
              const detail = this.root.querySelector('[data-gp-reason-dont-want]');
              const input = detail?.querySelector('[data-assessment-textarea]');
              if (input && !detail.hidden) input.focus();
            });
          } else if (value === GP_UNABLE_REASON.NOT_LISTED) {
            requestAnimationFrame(() => {
              const detail = this.root.querySelector('[data-gp-reason-not-listed]');
              const input = detail?.querySelector('[name="gpManualName"]');
              if (input && !detail.hidden) input.focus();
            });
          }
        }
      }

      if (['allergyInjection', 'allergyMedication', 'listedMedications'].includes(group.dataset.key)) {
        this.updateMedicationSelectionVisibility();
        if (group.dataset.key === 'allergyMedication') {
          this.updateMedicationPreferenceOptions();
        }
      }

      this.saveData();
      this.updateConditionalSections();
      this.updateContinueState();
    }

    handleUnitToggle(btn) {
      const unit = btn.dataset.unit;
      this.data.unitSystem = unit;

      this.root.querySelectorAll('[data-unit-toggle]').forEach((el) => {
        el.classList.toggle('is-active', el.dataset.unit === unit);
      });

      this.root.querySelectorAll('[data-metric-fields]').forEach((el) => {
        el.hidden = unit !== 'metric';
      });
      this.root.querySelectorAll('[data-imperial-fields]').forEach((el) => {
        el.hidden = unit !== 'imperial';
      });

      this.hideBodyMeasurementRangeErrors();
      this.saveData();
      this.updateContinueState();
    }

    toggleFemaleSection(show) {
      const section = this.root.querySelector('[data-female-section]');
      if (section) section.hidden = !show;
    }

    updateEthnicOther() {
      const ethnicOther = this.root.querySelector('[data-ethnic-other]');
      if (!ethnicOther) return;

      const showOther = this.data.ethnicBackground === 'Other';
      ethnicOther.hidden = !showOther;

      if (!showOther) {
        const input = ethnicOther.querySelector('[data-assessment-textarea]');
        if (input) {
          input.value = '';
          input.classList.remove('is-error');
        }
        delete this.data.ethnicOther;
      }
    }

    updateOtherMedicationsDetail() {
      const detailSection = this.root.querySelector('[data-other-medications-detail]');
      if (!detailSection) return;

      const showDetail = this.data.otherMedications === 'yes';
      detailSection.hidden = !showDetail;

      if (!showDetail) {
        const input = detailSection.querySelector('[data-assessment-textarea]');
        if (input) {
          input.value = '';
          input.classList.remove('is-error');
        }
        delete this.data.otherMedicationsDetail;
      }
    }

    getGpSearchElements() {
      return {
        searchField: this.root.querySelector('[data-gp-search-field]'),
        input: this.root.querySelector('[data-gp-input]'),
        results: this.root.querySelector('[data-gp-results]'),
        error: this.root.querySelector('[data-gp-error]'),
        unableCheckbox: this.root.querySelector('[data-gp-unable-checkbox]')
      };
    }

    updateGpUnableDetail() {
      const detail = this.root.querySelector('[data-gp-unable-detail]');
      if (!detail) return;

      const showDetail = !!this.data.gpUnableToProvide;
      detail.hidden = !showDetail;

      if (!showDetail) {
        delete this.data.gpUnableReason;
        const group = this.root.querySelector('[data-selector-group][data-key="gpUnableReason"]');
        if (group) {
          group.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
        }
        this.clearGpUnableFollowupFields(null);
      }

      this.updateGpUnableFollowup();
    }

    clearGpUnableFollowupFields(keepReason) {
      if (keepReason !== GP_UNABLE_REASON.DONT_WANT) {
        delete this.data.gpDontWantGpDetail;
        const textarea = this.getTextarea('gpDontWantGpDetail');
        if (textarea) {
          textarea.value = '';
          textarea.classList.remove('is-error');
        }
      }

      if (keepReason !== GP_UNABLE_REASON.NO_GP) {
        delete this.data.gpRegisterAcknowledged;
        const checkbox = this.root.querySelector('[data-gp-register-checkbox]');
        if (checkbox) checkbox.checked = false;
        const errorEl = this.root.querySelector('[data-group-error="gpRegisterAcknowledgement"]');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
      }

      if (keepReason !== GP_UNABLE_REASON.NOT_LISTED) {
        delete this.data.gpManualName;
        delete this.data.gpManualAddress;
        ['gpManualName', 'gpManualAddress'].forEach((name) => {
          const field = this.root.querySelector(`[name="${name}"]`);
          if (field) {
            field.value = '';
            field.classList.remove('is-error');
          }
        });
      }
    }

    updateGpUnableFollowup() {
      const reason = this.data.gpUnableReason;
      const showFollowup = !!this.data.gpUnableToProvide && !!reason;

      const dontWant = this.root.querySelector('[data-gp-reason-dont-want]');
      const noGp = this.root.querySelector('[data-gp-reason-no-gp]');
      const notListed = this.root.querySelector('[data-gp-reason-not-listed]');

      if (dontWant) {
        dontWant.hidden = !showFollowup || reason !== GP_UNABLE_REASON.DONT_WANT;
      }
      if (noGp) {
        noGp.hidden = !showFollowup || reason !== GP_UNABLE_REASON.NO_GP;
      }
      if (notListed) {
        notListed.hidden = !showFollowup || reason !== GP_UNABLE_REASON.NOT_LISTED;
      }
    }

    isGpUnableFollowupFilled() {
      const reason = this.data.gpUnableReason;
      if (!reason) return false;

      if (reason === GP_UNABLE_REASON.DONT_WANT) {
        return this.getFieldValue('gpDontWantGpDetail').length > 0;
      }

      if (reason === GP_UNABLE_REASON.NO_GP) {
        return !!this.data.gpRegisterAcknowledged;
      }

      if (reason === GP_UNABLE_REASON.NOT_LISTED) {
        return !!this.getFieldValue('gpManualName') && !!this.getFieldValue('gpManualAddress');
      }

      return false;
    }

    validateGpUnableFollowup() {
      const reason = this.data.gpUnableReason;
      if (!reason) {
        return this.showGroupError('gpUnableReason', 'Please choose a reason.');
      }

      if (reason === GP_UNABLE_REASON.DONT_WANT) {
        const detail = this.getFieldValue('gpDontWantGpDetail');
        if (!detail) {
          return this.markTextareaError('gpDontWantGpDetail');
        }
        this.data.gpDontWantGpDetail = detail;
        return true;
      }

      if (reason === GP_UNABLE_REASON.NO_GP) {
        if (!this.data.gpRegisterAcknowledged) {
          return this.showGroupError('gpRegisterAcknowledgement', 'Please confirm you understand.');
        }
        return true;
      }

      if (reason === GP_UNABLE_REASON.NOT_LISTED) {
        const name = this.getFieldValue('gpManualName');
        const address = this.getFieldValue('gpManualAddress');
        let valid = true;

        if (!name) {
          this.showFieldError('gpManualName', 'Please enter your surgery name.');
          valid = false;
        }
        if (!address) {
          this.showFieldError('gpManualAddress', 'Please enter your GP address.');
          valid = false;
        }

        if (!valid) return false;

        this.data.gpManualName = name;
        this.data.gpManualAddress = address;
        return true;
      }

      return this.showGroupError('gpUnableReason', 'Please choose a reason.');
    }

    updateGpSearchState() {
      const { searchField, input, unableCheckbox } = this.getGpSearchElements();
      const disabled = !!this.data.gpUnableToProvide;

      if (searchField) {
        searchField.classList.toggle('is-disabled', disabled);
        searchField.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }

      if (input) {
        input.disabled = disabled;
        input.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        if (disabled) input.blur();
      }

      if (unableCheckbox) unableCheckbox.checked = disabled;

      if (disabled) this.hideGpResults();
    }

    queueGpSearch(query) {
      if (this.data.gpUnableToProvide) return;

      clearTimeout(this.gpSearchTimer);
      const trimmed = (query || '').trim();

      if (trimmed.length < GP_SEARCH_MIN_CHARS) {
        this.hideGpResults();
        return;
      }

      this.gpSearchTimer = setTimeout(() => this.fetchGpOrganisations(trimmed), GP_SEARCH_DEBOUNCE_MS);
    }

    getGpApiConfig() {
      const root = this.root;
      return {
        apiUrl: root.dataset.gpApiUrl || NHS_ORG_API,
        tenant: root.dataset.gpApiTenant || '',
        relayUrl: root.dataset.gpRelayUrl || ''
      };
    }

    canUseDirectGpApi() {
      return GP_CORS_ORIGINS.has(window.location.hostname);
    }

    getGpApiHeaders(tenant) {
      const headers = { Accept: 'application/json' };
      if (tenant) headers['X-Tenant'] = tenant;
      return headers;
    }

    ensureGpRelayPopup() {
      const relayUrl = this.getGpApiConfig().relayUrl;
      if (!relayUrl) return null;

      if (this.gpRelayPopup && !this.gpRelayPopup.closed) {
        return this.gpRelayPopup;
      }

      const popup = window.open(
        relayUrl,
        'gpSearchRelay',
        'width=1,height=1,left=-10000,top=-10000,noopener=no,noreferrer=no'
      );

      if (!popup) return null;

      this.gpRelayPopup = popup;
      this.gpRelayReady = false;
      return popup;
    }

    waitForGpRelayReady(timeoutMs) {
      if (this.gpRelayReady) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          window.removeEventListener('message', onReady);
          reject(new Error('Relay timeout'));
        }, timeoutMs);

        const onReady = (event) => {
          if (event.data?.type !== 'gp-relay-ready') return;
          this.gpRelayReady = true;
          window.removeEventListener('message', onReady);
          clearTimeout(timeoutId);
          resolve();
        };

        window.addEventListener('message', onReady);
      });
    }

    fetchGpOrganisationsViaRelay(query, relayUrl) {
      const requestId = ++this.gpRelayRequestId;
      const relayOrigin = new URL(relayUrl).origin;

      const popup = this.ensureGpRelayPopup();
      if (!popup) {
        return Promise.reject(new Error('Popup blocked'));
      }

      return this.waitForGpRelayReady(12000).then(() => new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          window.removeEventListener('message', onResult);
          reject(new Error('Relay search timeout'));
        }, 12000);

        const onResult = (event) => {
          if (event.origin !== relayOrigin) return;
          if (event.data?.type !== 'gp-search-result' || event.data.requestId !== requestId) return;

          window.removeEventListener('message', onResult);
          clearTimeout(timeoutId);

          if (event.data.ok) {
            resolve(event.data.organisations || []);
          } else {
            reject(new Error(event.data.error || 'Search failed'));
          }
        };

        window.addEventListener('message', onResult);

        popup.postMessage({
          type: 'gp-search',
          query,
          requestId
        }, relayOrigin);
      }));
    }

    async requestGpOrganisations(query) {
      const { apiUrl, tenant, relayUrl } = this.getGpApiConfig();
      const trimmed = String(query || '').trim();

      if (!this.canUseDirectGpApi()) {
        if (!relayUrl) throw new Error('Relay URL missing');
        return this.fetchGpOrganisationsViaRelay(trimmed, relayUrl);
      }

      const organisations = await fetchGpOrganisationsFromApi(
        apiUrl,
        tenant,
        trimmed,
        this.gpSearchAbort.signal
      );
      return organisations;
    }

    async fetchGpOrganisations(query) {
      const { results, error } = this.getGpSearchElements();
      if (!results) return;

      if (this.gpSearchAbort) this.gpSearchAbort.abort();
      this.gpSearchAbort = new AbortController();

      results.hidden = false;
      results.classList.add('is-loading');
      results.innerHTML = '<li class="assessment-form__gp-results-empty">Searching...</li>';

      if (error) {
        error.textContent = '';
        error.classList.remove('is-visible');
      }

      try {
        const organisations = (await this.requestGpOrganisations(query))
          .filter((org) => org.Status === 'Active')
          .slice(0, 20);

        this.gpSearchResults = organisations;
        results.classList.remove('is-loading');

        if (!organisations.length) {
          results.innerHTML = '<li class="assessment-form__gp-results-empty">No surgeries found. Try a different search.</li>';
          return;
        }

        results.innerHTML = organisations.map((org, index) => (
          `<li><button type="button" class="assessment-form__gp-option" data-gp-option data-gp-index="${index}" role="option">` +
          `<span class="assessment-form__gp-option-name">${escapeHtml(org.Name)}</span>` +
          `</button></li>`
        )).join('');
      } catch (err) {
        if (err.name === 'AbortError') return;

        this.gpSearchResults = [];
        results.classList.remove('is-loading');
        results.hidden = true;

        if (error) {
          const popupBlocked = err.message === 'Popup blocked';
          error.textContent = popupBlocked
            ? 'Please allow pop-ups for this site to search GP surgeries in local preview.'
            : this.canUseDirectGpApi()
              ? 'Unable to load GP surgeries. Please try again.'
              : 'Unable to load GP surgeries. Click the GP field and allow pop-ups, or test on getslimmr.co.uk.';
          error.classList.add('is-visible');
        }
      }
    }

    selectGpOrganisation(org) {
      this.data.gpSurgery = {
        Name: org.Name,
        OrgId: org.OrgId,
        GP_Address: org.GP_Address,
        PostCode: org.PostCode,
        OrgLink: org.OrgLink
      };

      const { input, results, error } = this.getGpSearchElements();
      if (input) input.value = org.Name;
      this.hideGpResults();

      if (error) {
        error.textContent = '';
        error.classList.remove('is-visible');
      }

      this.saveData();
      this.updateContinueState();
    }

    hideGpResults() {
      const { results } = this.getGpSearchElements();
      if (!results) return;

      results.hidden = true;
      results.innerHTML = '';
      results.classList.remove('is-loading');
      this.gpSearchResults = [];
    }

    isGpSurgeryFilled() {
      if (this.data.gpUnableToProvide) {
        return this.isGpUnableFollowupFilled();
      }
      return !!(this.data.gpSurgery && this.data.gpSurgery.OrgId);
    }

    validateGpSurgery() {
      if (this.data.gpUnableToProvide) {
        const { error } = this.getGpSearchElements();
        if (error) {
          error.textContent = '';
          error.classList.remove('is-visible');
        }

        if (!this.data.gpUnableReason) {
          return this.showGroupError('gpUnableReason', 'Please choose a reason.');
        }

        if (this.validateGpUnableFollowup()) {
          this.saveData();
          return true;
        }
        return false;
      }

      if (this.data.gpSurgery && this.data.gpSurgery.OrgId) {
        const { error } = this.getGpSearchElements();
        if (error) {
          error.textContent = '';
          error.classList.remove('is-visible');
        }
        return true;
      }

      const { error } = this.getGpSearchElements();
      if (error) {
        error.textContent = 'Please select your GP surgery or tick the box if you are unable to provide this.';
        error.classList.add('is-visible');
      }
      return false;
    }

    updateIllnessesOperationsDetail() {
      const detailSection = this.root.querySelector('[data-illnesses-operations-detail]');
      if (!detailSection) return;

      const showDetail = this.data.illnessesOrOperations === 'yes';
      detailSection.hidden = !showDetail;

      if (!showDetail) {
        const input = detailSection.querySelector('[data-assessment-textarea]');
        if (input) {
          input.value = '';
          input.classList.remove('is-error');
        }
        delete this.data.illnessesOrOperationsDetail;
      }
    }

    updateOtherAllergiesDetail() {
      const otherAllergiesDetail = this.root.querySelector('[data-other-allergies-detail]');
      if (!otherAllergiesDetail) return;

      const showDetail = this.data.otherAllergies === 'yes';
      otherAllergiesDetail.hidden = !showDetail;

      if (!showDetail) {
        const input = otherAllergiesDetail.querySelector('[data-assessment-textarea]');
        if (input) {
          input.value = '';
          input.classList.remove('is-error');
        }
        delete this.data.otherAllergiesDetail;
      }
    }

    getFollowupConditions() {
      const comorbidities = this.data.comorbidities || [];
      return comorbidities.filter((condition) => condition !== 'None of the above');
    }

    needsComorbidityFollowup() {
      return this.getFollowupConditions().length > 0;
    }

    isType2DiabetesFollowup(condition) {
      return condition === TYPE2_DIABETES;
    }

    restoreMultiSelectGroup(key) {
      const selected = this.data[key] || [];
      const group = this.root.querySelector(`[data-selector-group][data-key="${key}"]`);
      if (!group) return;

      const noneValue = group.dataset.noneValue;
      group.querySelectorAll('[data-selector]').forEach((el) => {
        const value = el.dataset.value;
        if (noneValue && value === noneValue) {
          el.classList.toggle('is-selected', selected.includes(value));
        } else {
          el.classList.toggle('is-selected', selected.includes(value));
        }
      });
    }

    clearFollowupErrors() {
      ['doctorDiagnosed', 'type2Management', 'type2Applies', 'type2Acknowledgement'].forEach((key) => {
        const errorEl = this.root.querySelector(`[data-group-error="${key}"]`);
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
      });

      this.root.querySelectorAll('[data-assessment-textarea]').forEach((field) => {
        field.classList.remove('is-error');
      });
    }

    ensureFollowupData() {
      if (!this.data.comorbidityFollowups) this.data.comorbidityFollowups = {};
      return this.data.comorbidityFollowups;
    }

    getCurrentFollowupCondition() {
      const conditions = this.getFollowupConditions();
      const index = this.data.followupIndex || 0;
      return conditions[index] || null;
    }

    pruneComorbidityFollowups() {
      if (!this.data.comorbidityFollowups) return;
      const valid = new Set(this.getFollowupConditions());
      Object.keys(this.data.comorbidityFollowups).forEach((key) => {
        if (!valid.has(key)) delete this.data.comorbidityFollowups[key];
      });
    }

    saveCurrentFollowupToData() {
      const condition = this.getCurrentFollowupCondition();
      if (!condition) return;

      const followups = this.ensureFollowupData();

      if (this.isType2DiabetesFollowup(condition)) {
        followups[condition] = {
          type2Management: this.data.type2Management || [],
          type2Applies: this.data.type2Applies || [],
          type2Acknowledged: !!this.data.type2Acknowledged
        };
        return;
      }

      followups[condition] = {
        doctorDiagnosed: this.data.doctorDiagnosed || '',
        symptomChanges: this.getFieldValue('symptomChanges'),
        currentManagement: this.getFieldValue('currentManagement')
      };
    }

    loadFollowupFormForCurrentCondition(forceReload) {
      const condition = this.getCurrentFollowupCondition();
      const followup = this.root.querySelector('[data-followup-section]');
      if (!followup || !condition) return;

      const isType2 = this.isType2DiabetesFollowup(condition);
      const standardSection = followup.querySelector('[data-followup-standard]');
      const type2Section = followup.querySelector('[data-followup-type2]');
      if (standardSection) standardSection.hidden = isType2;
      if (type2Section) type2Section.hidden = !isType2;

      if (!forceReload && this.data.followupCondition === condition) {
        return;
      }

      this.data.followupCondition = condition;
      this.clearFollowupErrors();

      const answers = this.ensureFollowupData()[condition] || {};

      if (isType2) {
        this.data.type2Management = answers.type2Management || [];
        this.data.type2Applies = answers.type2Applies || [];
        this.data.type2Acknowledged = !!answers.type2Acknowledged;

        this.restoreMultiSelectGroup('type2Management');
        this.restoreMultiSelectGroup('type2Applies');

        const checkbox = followup.querySelector('[data-type2-checkbox]');
        if (checkbox) checkbox.checked = this.data.type2Acknowledged;
        return;
      }

      const heading = followup.querySelector('[data-followup-heading]');
      if (heading) {
        heading.textContent = `Have you been diagnosed with ${condition} by a healthcare professional?`;
      }

      this.data.doctorDiagnosed = answers.doctorDiagnosed || '';

      const group = this.root.querySelector('[data-selector-group][data-key="doctorDiagnosed"]');
      if (group) {
        group.querySelectorAll('[data-selector]').forEach((el) => {
          el.classList.toggle('is-selected', el.dataset.value === this.data.doctorDiagnosed);
        });
      }

      const symptomField = this.getTextarea('symptomChanges');
      const mgmtField = this.getTextarea('currentManagement');
      if (symptomField) {
        symptomField.value = answers.symptomChanges || '';
        symptomField.classList.remove('is-error');
      }
      if (mgmtField) {
        mgmtField.value = answers.currentManagement || '';
        mgmtField.classList.remove('is-error');
      }
    }

    needsPreviousPrescriptionStep() {
      return this.data.medicationStatus === 'switching';
    }

    needsPenDosesRemainingStep() {
      if (!this.needsPreviousPrescriptionStep()) return false;
      return this.data.previouslyPrescribed !== PREVIOUS_PRESCRIPTION.WEGOVY_PILL;
    }

    needsMedicationSelectionStep() {
      const status = this.data.medicationStatus;
      if (status !== 'never' && status !== 'used_before') return false;
      if (this.hasNoEligibleMedicationsFromAllergies()) return false;
      return true;
    }

    isPreviousPrescriptionFilled() {
      if (!this.needsPreviousPrescriptionStep()) return true;
      if (!this.data.previouslyPrescribed) return false;
      return !!this.data.previousPrescriptionDose;
    }

    updatePreviousPrescriptionDose() {
      const wrapper = this.root.querySelector('[data-prescription-dose-detail]');
      if (!wrapper) return;

      const prescription = this.data.previouslyPrescribed;
      const showDetail = !!prescription;
      wrapper.hidden = !showDetail;

      const ozempicNotice = wrapper.querySelector('[data-ozempic-notice]');
      if (ozempicNotice) {
        ozempicNotice.hidden = prescription !== PREVIOUS_PRESCRIPTION.OZEMPIC;
      }

      const heading = wrapper.querySelector('[data-prescription-dose-heading]');
      if (heading) {
        const headings = {
          [PREVIOUS_PRESCRIPTION.WEGOVY_INJECTION]: 'What was your most recent dose of Wegovy',
          [PREVIOUS_PRESCRIPTION.MOUNJARO]: 'What was your most recent dose of Mounjaro',
          [PREVIOUS_PRESCRIPTION.WEGOVY_PILL]: 'What was your most recent dose of Wegovy',
          [PREVIOUS_PRESCRIPTION.OZEMPIC]: 'What was your most recent dose of Ozempic'
        };
        heading.textContent = headings[prescription] || '';
        heading.hidden = !prescription;
      }

      wrapper.querySelectorAll('[data-dose-for]').forEach((btn) => {
        btn.hidden = btn.dataset.doseFor !== prescription;
      });

      if (!showDetail) {
        delete this.data.previousPrescriptionDose;
        const doseGroup = this.root.querySelector('[data-selector-group][data-key="previousPrescriptionDose"]');
        if (doseGroup) {
          doseGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
        }
      }
    }

    validatePreviousPrescription() {
      if (!this.needsPreviousPrescriptionStep()) return true;

      if (!this.data.previouslyPrescribed) {
        return this.showGroupError('previouslyPrescribed', 'Please choose an option.');
      }

      if (!this.data.previousPrescriptionDose) {
        return this.showGroupError('previousPrescriptionDose', 'Please choose your most recent dose.');
      }

      return true;
    }

    getPatientEmail() {
      return (this.data.email || this.getFieldValue('email') || '').trim();
    }

    getCreateAssessmentApiConfig() {
      return {
        apiUrl: resolveLooprxApiUrl(
          this.root.dataset.createAssessmentApiUrl,
          'create-assessment',
          CREATE_ASSESSMENT_API
        ),
        tenant: this.root.dataset.gpApiTenant || 'slimmr-K9FQ7A2D'
      };
    }

    formatAssessmentHeight() {
      const unit = this.data.unitSystem || 'imperial';
      if (unit === 'metric') {
        const cm = this.getFieldValue('heightCm');
        return cm ? `${cm} cm` : '';
      }
      const feet = this.getFieldValue('heightFeet');
      const inches = this.getFieldValue('heightInches') || '0';
      return feet ? `${feet}'${inches}"` : '';
    }

    formatAssessmentWeight(prefix) {
      const unit = this.data.unitSystem || 'imperial';
      if (unit === 'metric') {
        const kg = this.getFieldValue(`${prefix}Kg`);
        return kg ? `${kg} kg` : '';
      }
      const stones = this.getFieldValue(`${prefix}Stones`);
      const pounds = this.getFieldValue(`${prefix}Pounds`) || '0';
      return stones ? `${stones} st ${pounds} lb` : '';
    }

    parseHeightCm() {
      const unit = this.data.unitSystem || 'imperial';
      if (unit === 'metric') {
        const cm = parseFloat(this.getFieldValue('heightCm'));
        return Number.isFinite(cm) ? cm : 0;
      }

      const feet = parseFloat(this.getFieldValue('heightFeet')) || 0;
      const inches = parseFloat(this.getFieldValue('heightInches')) || 0;
      const totalInches = (feet * 12) + inches;
      return totalInches > 0 ? Math.round(totalInches * 2.54) : 0;
    }

    parseWeightKg(prefix) {
      const unit = this.data.unitSystem || 'imperial';
      if (unit === 'metric') {
        const kg = parseFloat(this.getFieldValue(`${prefix}Kg`));
        return Number.isFinite(kg) ? kg : 0;
      }

      const stones = parseFloat(this.getFieldValue(`${prefix}Stones`)) || 0;
      const pounds = parseFloat(this.getFieldValue(`${prefix}Pounds`)) || 0;
      const totalLb = (stones * 14) + pounds;
      return totalLb > 0 ? Math.round(totalLb * 0.453592 * 10) / 10 : 0;
    }

    getDobParts() {
      const iso = this.data.dateOfBirth || '';
      const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (match) {
        return {
          dob_year: match[1],
          dob_month: match[2],
          dob_date: match[3]
        };
      }

      return {
        dob_date: this.getFieldValue('dobDay') || '',
        dob_month: this.getFieldValue('dobMonth') || '',
        dob_year: this.getFieldValue('dobYear') || ''
      };
    }

    appendComorbidityFollowupToAssessment(assessment) {
      const followups = this.data.comorbidityFollowups || {};

      Object.entries(COMORBIDITY_FOLLOWUP_API_PREFIX).forEach(([condition, prefix]) => {
        const answers = followups[condition];
        if (!answers) return;

        assessment[`${prefix}_diagnosed`] = yesNoLabel(answers.doctorDiagnosed);
        assessment[`${prefix}_diagnosed_on`] = answers.diagnosedOn || '';
        assessment[`${prefix}_condition_changes_over_time`] = answers.symptomChanges || '';
        assessment[`${prefix}_current_management_details`] = answers.currentManagement || '';

        if (condition === 'Sleep apnoea') {
          assessment.diagnosed_with_sleep_apnoea = yesNoLabel(answers.doctorDiagnosed);
          assessment.sleep_apnoea_diagnosed_on = answers.diagnosedOn || '';
          assessment.sa_condition_changes_over_time = answers.symptomChanges || '';
          assessment.sa_current_management_details = answers.currentManagement || '';
        }
      });

      const type2Answers = followups[TYPE2_DIABETES];
      if (type2Answers) {
        assessment.type2_diabetes_management = formatMultiSelectValue(type2Answers.type2Management);
        assessment.diabetes_applicable_statements = formatMultiSelectValue(type2Answers.type2Applies);
        assessment.diabetes_consent = type2Answers.type2Acknowledged ? 'Yes' : 'No';
      }
    }

    buildAssessmentJsonObject() {
      if (STEPS[this.currentStep] === 'comorbidity-followup') {
        this.saveCurrentFollowupToData();
      }

      const medStatusOption = MEDICATION_OPTIONS.find((option) => option.value === this.data.medicationStatus);
      const currentWeightKg = this.parseWeightKg('current');
      const targetWeightKg = this.parseWeightKg('target');
      const waistCm = parseFloat(this.getFieldValue('waistCm'));
      const dobParts = this.getDobParts();

      const illnessesValue = this.data.illnessesOrOperations === 'yes'
        ? (this.data.illnessesOrOperationsDetail || 'Yes')
        : yesNoLabel(this.data.illnessesOrOperations);

      const counterMedicationsValue = this.data.otherMedications === 'yes'
        ? (this.data.otherMedicationsDetail || 'Yes')
        : yesNoLabel(this.data.otherMedications);

      let gpName = '-';
      let gpAddress = '';
      let gpOds = '';
      let gpUnavailableReason = '';
      let registeredSurgeryName = '';

      if (this.data.gpUnableToProvide) {
        gpUnavailableReason = this.data.gpUnableReason || '';
        if (this.data.gpUnableReason === GP_UNABLE_REASON.NOT_LISTED) {
          gpName = this.data.gpManualName || '-';
          gpAddress = this.data.gpManualAddress || '';
        } else if (this.data.gpUnableReason === GP_UNABLE_REASON.DONT_WANT) {
          registeredSurgeryName = this.data.gpDontWantGpDetail || '';
        }
      } else if (this.data.gpSurgery) {
        gpName = this.data.gpSurgery.Name || '-';
        gpOds = this.data.gpSurgery.OrgId || '';
        const addressParts = [this.data.gpSurgery.GP_Address, this.data.gpSurgery.PostCode].filter(Boolean);
        gpAddress = addressParts.join(', ');
      }

      const assessment = {
        age: this.data.age != null ? String(this.data.age) : '',
        Ethnicity: this.data.ethnicBackground || '',
        height_cm: this.parseHeightCm(),
        weight_kg: currentWeightKg,
        bmi: this.calculateBmi(),
        waist_measurement: Number.isFinite(waistCm) ? waistCm : 0,
        target_weight: targetWeightKg,
        can_step_now_scales: this.data.scalePhoto || '',
        gender: this.data.biologicalSex || '',
        pregnant: this.data.pregnancyStatus || '',
        any_of_the_following_statements_1: formatMultiSelectValue(this.data.medicalExclusions),
        any_other_medical_conditions: formatMultiSelectValue(this.data.comorbidities),
        diabetes_applicable_statements: '',
        type2_diabetes_management: '',
        weight_affects_mood: this.data.weightMoodImpact || '',
        has_other_illnesses_or_major_operations: illnessesValue || '-',
        current_medications_listed: formatMultiSelectValue(this.data.listedMedications),
        q11a_medications_allergies: formatMultiSelectValue(this.data.allergyInjection),
        gp_name: gpName,
        gp_details_unavailable_reason: gpUnavailableReason,
        registered_surgery_name: registeredSurgeryName,
        gp_address: gpAddress,
        weight_loss_reasons: formatMultiSelectValue(this.data.weightLossReasons),
        weight_affects_mental_health: this.data.weightMentalHealthFrequency || '',
        current_diet_quality: this.data.currentDiet || '',
        current_exercise_level: this.data.physicalExercise || '',
        last_dose_strength: this.data.previousPrescriptionDose || '',
        last_dose_date: this.data.glp1LastDoseDate || '',
        current_pen_doses_left: this.data.penDosesRemaining || '',
        switcher_med_choice: this.data.medicationPreference || this.data.selectedMedication || '',
        next_dose_preference: this.data.nextDosePreference || '',
        previous_prescription_evidence_status: this.data.prescriptionEvidence || '',
        starting_weight: this.data.medicationStatus === 'switching' ? this.parseWeightKg('initial') : 0,
        weight: currentWeightKg ? `${currentWeightKg} kg` : '0 kg',
        medication_period: '',
        current_medication: this.data.selectedMedication || this.data.medicationPreference || '',
        consent: 'Yes',
        recycle_pens: this.data.penCycleReturnBox || '',
        currently_taking_contraceptive: yesNoLabel(this.data.contraceptiveUse),
        Phone: this.data.phone || '',
        dob_date: dobParts.dob_date,
        dob_month: dobParts.dob_month,
        dob_year: dobParts.dob_year,
        gp_ods: gpOds,
        using_weight_loss_medication_other_provider: medStatusOption?.label || '',
        allergic_to_orlistat_exclusions: formatMultiSelectValue(this.data.allergyMedication),
        applicable_conditions_multiple_select: formatMultiSelectValue(this.data.applicableConditions),
        counter_medications: counterMedicationsValue,
        treatment_preferences: formatMultiSelectValue(this.data.treatmentPriorities),
        last_taken_medication: this.data.previouslyPrescribed || '',
        first_medication_date: this.data.glp1TreatmentStartDate || '',
        ethnicity_other_text: this.data.ethnicOther || '',
        delivery_date: this.data.deliveryDate ? this.formatDeliveryDateLabel(this.data.deliveryDate) : null,
        allergies_other_text: this.data.otherAllergies === 'yes' ? (this.data.otherAllergiesDetail || '') : '',
        diabetes_consent: '',
        diagnosed_with_sleep_apnoea: '',
        sleep_apnoea_diagnosed_on: '',
        sa_condition_changes_over_time: '',
        sa_current_management_details: '',
        category_id: ASSESSMENT_CATEGORY_ID
      };

      Object.keys(COMORBIDITY_FOLLOWUP_API_PREFIX).forEach((condition) => {
        const prefix = COMORBIDITY_FOLLOWUP_API_PREFIX[condition];
        assessment[`${prefix}_diagnosed`] = '';
        assessment[`${prefix}_diagnosed_on`] = '';
        assessment[`${prefix}_condition_changes_over_time`] = '';
        assessment[`${prefix}_current_management_details`] = '';
      });

      this.appendComorbidityFollowupToAssessment(assessment);
      return assessment;
    }

    buildCreateAssessmentPayload() {
      return {
        'First-Name': (this.data.firstName || '').trim(),
        'Last-Name': (this.data.lastName || '').trim(),
        patient_email: this.getPatientEmail(),
        Phone: (this.data.phone || '').trim(),
        consent: 'Yes',
        assessment: this.buildAssessmentJsonObject()
      };
    }

    isCreateAssessmentResponseSuccessful(response, rawText, result) {
      if (!response.ok) return false;
      if (!String(rawText || '').trim()) return false;
      if (result.success === false || result.status === 'error') return false;
      return result.success === true && result.form_submission_saved === true;
    }

    async syncCreateAssessmentToApi() {
      const email = this.getPatientEmail();
      if (!email) return false;

      const { apiUrl, tenant } = this.getCreateAssessmentApiConfig();
      const payload = this.buildCreateAssessmentPayload();

      if (!payload['First-Name'] || !payload['Last-Name'] || !payload.Phone) {
        return false;
      }

      const requestBody = {
        'First-Name': payload['First-Name'],
        'Last-Name': payload['Last-Name'],
        patient_email: payload.patient_email,
        Phone: payload.Phone,
        consent: payload.consent,
        assessment: JSON.stringify(payload.assessment)
      };

      this.lastCreateAssessmentSubmission = payload;

      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Tenant': tenant
      };

      const accessToken = getAccessTokenFromCookie();
      if (accessToken) {
        headers.Authorization = `Bearer ${accessToken}`;
      }

      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers,
          body: JSON.stringify(requestBody),
          credentials: 'include'
        });

        const rawText = await response.text();
        let result = {};

        if (rawText.trim()) {
          try {
            result = JSON.parse(rawText);
          } catch (_) {
            this.lastCreateAssessmentResponse = {
              ok: false,
              status: response.status,
              result: {},
              text: rawText
            };
            return false;
          }
        }

        this.lastCreateAssessmentResponse = {
          ok: response.ok,
          status: response.status,
          result,
          text: rawText.trim() ? JSON.stringify(result, null, 2) : rawText
        };

        if (!this.isCreateAssessmentResponseSuccessful(response, rawText, result)) {
          return false;
        }

        this.data.assessmentSubmitted = true;
        this.saveData();
        return true;
      } catch (_) {
        return false;
      }
    }

    getAssessmentImageApiConfig() {
      return {
        apiUrl: this.root.dataset.imageUploadApiUrl || UPLOAD_ASSESSMENT_IMAGES_API,
        tenant: this.root.dataset.gpApiTenant || 'slimmr-K9FQ7A2D'
      };
    }

    buildAssessmentImagePayload() {
      const email = this.getPatientEmail();
      if (!email) return null;

      const payload = {
        category_id: ASSESSMENT_CATEGORY_ID,
        patient_email: email
      };
      let hasPendingPhoto = false;

      if (
        this.data.prescriptionEvidenceUpload
        && this.data.prescriptionEvidenceUploadSyncedUrl !== this.data.prescriptionEvidenceUpload
      ) {
        payload.photo3 = this.data.prescriptionEvidenceUpload;
        hasPendingPhoto = true;
      }

      if (
        this.data.scalePhotoUpload
        && this.data.scalePhotoUploadSyncedUrl !== this.data.scalePhotoUpload
      ) {
        payload.photo4 = this.data.scalePhotoUpload;
        hasPendingPhoto = true;
      }

      return hasPendingPhoto ? payload : null;
    }

    hasPendingAssessmentImages() {
      return this.buildAssessmentImagePayload() !== null;
    }

    showImageApiError(errorKey, message) {
      if (!errorKey) return;
      const errorEl = this.root.querySelector(`[data-group-error="${errorKey}"]`);
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.add('is-visible');
    }

    clearImageApiError(errorKey) {
      if (!errorKey) return;
      const errorEl = this.root.querySelector(`[data-group-error="${errorKey}"]`);
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }

    async syncAssessmentImagesToApi(options = {}) {
      const payload = this.buildAssessmentImagePayload();
      if (!payload) return true;

      if (!this.data.assessmentSubmitted) {
        return true;
      }

      const { apiUrl, tenant } = this.getAssessmentImageApiConfig();
      const maxAttempts = options.maxAttempts ?? 3;
      const retryDelayMs = options.retryDelayMs ?? 1000;

      const isCustomerNotFoundResponse = (response, result) => {
        const message = String(result?.message || '').toLowerCase();
        return response.status === 404
          || message === 'customer not found.'
          || message.includes('customer not found');
      };

      for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
        try {
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Tenant': tenant
            },
            body: JSON.stringify(payload)
          });

          const result = await response.json().catch(() => ({}));

          if (!response.ok) {
            if (isCustomerNotFoundResponse(response, result)) {
              if (attempt < maxAttempts) {
                await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
                continue;
              }
              return true;
            }

            if (options.showError && result.message) {
              this.showImageApiError(
                options.errorKey,
                'We saved your file but could not register it yet. Please try uploading again or continue and we will retry.'
              );
            }
            return false;
          }

          if (payload.photo3) {
            this.data.prescriptionEvidenceUploadSyncedUrl = payload.photo3;
          }
          if (payload.photo4) {
            this.data.scalePhotoUploadSyncedUrl = payload.photo4;
          }
          this.saveData();

          if (payload.photo3) this.clearImageApiError('prescriptionEvidenceUpload');
          if (payload.photo4) this.clearImageApiError('scalePhotoUpload');

          return true;
        } catch (_) {
          if (attempt < maxAttempts) {
            await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
            continue;
          }

          if (options.showError) {
            this.showImageApiError(
              options.errorKey,
              'Unable to save your photo right now. Please check your connection and try again.'
            );
          }
          return false;
        }
      }

      return true;
    }

    initPrescriptionEvidenceUpload() {
      const input = this.root.querySelector('[data-prescription-upload-input]');
      if (!input || this.uploadcareWidget) return;

      if (typeof uploadcare === 'undefined') {
        setTimeout(() => this.initPrescriptionEvidenceUpload(), 150);
        return;
      }

      const pubkey = this.root.dataset.uploadcareKey || input.dataset.publicKey;
      if (pubkey) input.setAttribute('data-public-key', pubkey);

      this.uploadcareWidget = uploadcare.Widget(input);

      this.uploadcareWidget.onChange((file) => {
        if (!file) {
          delete this.data.prescriptionEvidenceUpload;
          delete this.data.prescriptionEvidenceUploadUuid;
          delete this.data.prescriptionEvidenceUploadSyncedUrl;
          this.updatePrescriptionUploadPreview(null);
          this.saveData();
          this.updateContinueState();
          return;
        }

        file.done((info) => {
          this.data.prescriptionEvidenceUpload = info.cdnUrl;
          this.data.prescriptionEvidenceUploadUuid = info.uuid;
          this.saveData();
          this.updatePrescriptionUploadPreview(info);
          this.clearImageApiError('prescriptionEvidenceUpload');
          this.updateContinueState();
        }).fail(() => {
          delete this.data.prescriptionEvidenceUpload;
          delete this.data.prescriptionEvidenceUploadUuid;
          delete this.data.prescriptionEvidenceUploadSyncedUrl;
          this.updatePrescriptionUploadPreview(null);
          this.saveData();
          this.updateContinueState();
        });
      });

      if (this.data.prescriptionEvidenceUpload) {
        this.uploadcareWidget.value(this.data.prescriptionEvidenceUpload);
        this.updatePrescriptionUploadPreviewFromUrl(this.data.prescriptionEvidenceUpload);
      }
    }

    clearPrescriptionEvidenceFollowup(keepEvidence) {
      if (keepEvidence !== PRESCRIPTION_EVIDENCE.UPLOAD_NOW) {
        delete this.data.prescriptionEvidenceUpload;
        delete this.data.prescriptionEvidenceUploadUuid;
        delete this.data.prescriptionEvidenceUploadSyncedUrl;
        if (this.uploadcareWidget) this.uploadcareWidget.value(null);
        this.updatePrescriptionUploadPreview(null);
        const uploadError = this.root.querySelector('[data-group-error="prescriptionEvidenceUpload"]');
        if (uploadError) {
          uploadError.textContent = '';
          uploadError.classList.remove('is-visible');
        }
      }

      if (keepEvidence !== PRESCRIPTION_EVIDENCE.CANT_PROVIDE) {
        delete this.data.prescriptionEvidenceAcknowledgement;
        const ackGroup = this.root.querySelector('[data-selector-group][data-key="prescriptionEvidenceAcknowledgement"]');
        if (ackGroup) {
          ackGroup.querySelectorAll('[data-selector]').forEach((el) => el.classList.remove('is-selected'));
        }
      }
    }

    updatePrescriptionEvidenceDetail() {
      const choice = this.data.prescriptionEvidence;
      const uploadDetail = this.root.querySelector('[data-prescription-upload-detail]');
      const noDetail = this.root.querySelector('[data-prescription-no-detail]');

      if (uploadDetail) uploadDetail.hidden = choice !== PRESCRIPTION_EVIDENCE.UPLOAD_NOW;
      if (noDetail) noDetail.hidden = choice !== PRESCRIPTION_EVIDENCE.CANT_PROVIDE;

      if (choice === PRESCRIPTION_EVIDENCE.UPLOAD_NOW) {
        this.initPrescriptionEvidenceUpload();
      }

      if (!choice) {
        this.clearPrescriptionEvidenceFollowup(null);
      }
    }

    updatePrescriptionUploadPreview(info) {
      const preview = this.root.querySelector('[data-prescription-upload-preview]');
      const img = this.root.querySelector('[data-prescription-upload-preview-img]');
      const fileLabel = this.root.querySelector('[data-prescription-upload-preview-file]');
      if (!preview || !img || !fileLabel) return;

      if (!info || !info.cdnUrl) {
        preview.hidden = true;
        img.removeAttribute('src');
        img.hidden = false;
        fileLabel.hidden = true;
        fileLabel.textContent = '';
        return;
      }

      preview.hidden = false;
      const isPdf = (info.mimeType && info.mimeType === 'application/pdf')
        || /\.pdf(\?|$)/i.test(info.cdnUrl);

      if (isPdf) {
        img.hidden = true;
        fileLabel.hidden = false;
        fileLabel.textContent = info.name || 'PDF uploaded';
      } else {
        img.hidden = false;
        fileLabel.hidden = true;
        img.src = info.cdnUrl + '-/preview/600x400/';
        img.alt = info.name || 'Uploaded prescription evidence';
      }
    }

    updatePrescriptionUploadPreviewFromUrl(url) {
      if (!url) {
        this.updatePrescriptionUploadPreview(null);
        return;
      }

      this.updatePrescriptionUploadPreview({
        cdnUrl: url,
        mimeType: /\.pdf(\?|$)/i.test(url) ? 'application/pdf' : 'image/jpeg',
        name: 'Uploaded file'
      });
    }

    initScalePhotoUpload() {
      const input = this.root.querySelector('[data-scale-upload-input]');
      if (!input || this.scalePhotoUploadcareWidget) return;

      if (typeof uploadcare === 'undefined') {
        setTimeout(() => this.initScalePhotoUpload(), 150);
        return;
      }

      const pubkey = this.root.dataset.scaleUploadcareKey || input.dataset.publicKey;
      if (pubkey) input.setAttribute('data-public-key', pubkey);

      this.scalePhotoUploadcareWidget = uploadcare.Widget(input);

      this.scalePhotoUploadcareWidget.onChange((file) => {
        if (!file) {
          delete this.data.scalePhotoUpload;
          delete this.data.scalePhotoUploadUuid;
          delete this.data.scalePhotoUploadSyncedUrl;
          this.updateScalePhotoUploadPreview(null);
          this.saveData();
          this.updateContinueState();
          return;
        }

        file.done((info) => {
          this.data.scalePhotoUpload = info.cdnUrl;
          this.data.scalePhotoUploadUuid = info.uuid;
          this.saveData();
          this.updateScalePhotoUploadPreview(info);
          this.clearImageApiError('scalePhotoUpload');
          this.updateContinueState();
        }).fail(() => {
          delete this.data.scalePhotoUpload;
          delete this.data.scalePhotoUploadUuid;
          delete this.data.scalePhotoUploadSyncedUrl;
          this.updateScalePhotoUploadPreview(null);
          this.saveData();
          this.updateContinueState();
        });
      });

      if (this.data.scalePhotoUpload) {
        this.scalePhotoUploadcareWidget.value(this.data.scalePhotoUpload);
        this.updateScalePhotoUploadPreviewFromUrl(this.data.scalePhotoUpload);
      }
    }

    clearScalePhotoFollowup(keepChoice) {
      if (keepChoice !== SCALE_PHOTO.YES) {
        delete this.data.scalePhotoUpload;
        delete this.data.scalePhotoUploadUuid;
        delete this.data.scalePhotoUploadSyncedUrl;
        if (this.scalePhotoUploadcareWidget) this.scalePhotoUploadcareWidget.value(null);
        this.updateScalePhotoUploadPreview(null);
        const uploadError = this.root.querySelector('[data-group-error="scalePhotoUpload"]');
        if (uploadError) {
          uploadError.textContent = '';
          uploadError.classList.remove('is-visible');
        }
      }
    }

    updateScalePhotoDetail() {
      const choice = this.data.scalePhoto;
      const uploadDetail = this.root.querySelector('[data-scale-upload-detail]');
      if (uploadDetail) uploadDetail.hidden = choice !== SCALE_PHOTO.YES;

      if (choice === SCALE_PHOTO.YES) {
        this.initScalePhotoUpload();
        if (this.data.scalePhotoUpload) {
          this.updateScalePhotoUploadPreviewFromUrl(this.data.scalePhotoUpload);
        } else {
          const preview = this.root.querySelector('[data-scale-upload-preview]');
          const img = this.root.querySelector('[data-scale-upload-preview-img]');
          const fileLabel = this.root.querySelector('[data-scale-upload-preview-file]');
          if (preview) preview.hidden = false;
          if (img) {
            img.removeAttribute('src');
            img.hidden = true;
          }
          if (fileLabel) {
            fileLabel.hidden = true;
            fileLabel.textContent = '';
          }
        }
      }

      if (!choice) {
        this.clearScalePhotoFollowup(null);
      }
    }

    updateScalePhotoUploadPreview(info) {
      const preview = this.root.querySelector('[data-scale-upload-preview]');
      const img = this.root.querySelector('[data-scale-upload-preview-img]');
      const fileLabel = this.root.querySelector('[data-scale-upload-preview-file]');
      if (!preview || !img || !fileLabel) return;

      if (!info || !info.cdnUrl) {
        preview.hidden = true;
        img.removeAttribute('src');
        img.hidden = false;
        fileLabel.hidden = true;
        fileLabel.textContent = '';
        return;
      }

      preview.hidden = false;
      const isPdf = (info.mimeType && info.mimeType === 'application/pdf')
        || /\.pdf(\?|$)/i.test(info.cdnUrl);

      if (isPdf) {
        img.hidden = true;
        fileLabel.hidden = false;
        fileLabel.textContent = info.name || 'PDF uploaded';
      } else {
        img.hidden = false;
        fileLabel.hidden = true;
        img.src = info.cdnUrl + '-/preview/600x400/';
        img.alt = info.name || 'Uploaded scale photo';
      }
    }

    updateScalePhotoUploadPreviewFromUrl(url) {
      if (!url) {
        this.updateScalePhotoUploadPreview(null);
        return;
      }

      this.updateScalePhotoUploadPreview({
        cdnUrl: url,
        mimeType: /\.pdf(\?|$)/i.test(url) ? 'application/pdf' : 'image/jpeg',
        name: 'Uploaded file'
      });
    }

    isScalePhotoFilled() {
      const choice = this.data.scalePhoto;
      if (!choice) return false;
      if (choice === SCALE_PHOTO.YES) return !!this.data.scalePhotoUpload;
      return true;
    }

    validateScalePhoto() {
      if (!this.data.scalePhoto) {
        return this.showGroupError('scalePhoto', 'Please choose an option.');
      }

      if (this.data.scalePhoto === SCALE_PHOTO.YES && !this.data.scalePhotoUpload) {
        return this.showGroupError('scalePhotoUpload', 'Please upload a photo of your scale display.');
      }

      return true;
    }

    isPrescriptionEvidenceFilled() {
      const choice = this.data.prescriptionEvidence;
      if (!choice) return false;
      if (choice === PRESCRIPTION_EVIDENCE.UPLOAD_NOW) return !!this.data.prescriptionEvidenceUpload;
      if (choice === PRESCRIPTION_EVIDENCE.CANT_PROVIDE) return !!this.data.prescriptionEvidenceAcknowledgement;
      return true;
    }

    validatePrescriptionEvidence() {
      if (!this.needsPreviousPrescriptionStep()) return true;

      if (!this.data.prescriptionEvidence) {
        return this.showGroupError('prescriptionEvidence', 'Please choose an option.');
      }

      if (this.data.prescriptionEvidence === PRESCRIPTION_EVIDENCE.UPLOAD_NOW) {
        if (!this.data.prescriptionEvidenceUpload) {
          return this.showGroupError('prescriptionEvidenceUpload', 'Please upload your prescription evidence.');
        }
        return true;
      }

      if (this.data.prescriptionEvidence === PRESCRIPTION_EVIDENCE.CANT_PROVIDE) {
        if (!this.data.prescriptionEvidenceAcknowledgement) {
          return this.showGroupError('prescriptionEvidenceAcknowledgement', 'Please confirm you would like to continue on this basis.');
        }
        return true;
      }

      return true;
    }

    validateConfirmDeclarations() {
      const checkbox = this.root.querySelector('[data-confirm-declarations-checkbox]');
      if (!checkbox?.checked) {
        return this.showGroupError('confirmDeclarations', "Please confirm you've read and understood the statements above.");
      }

      this.data.confirmDeclarationsAgreed = true;
      this.saveData();
      return true;
    }

    isConfirmDeclarationsFilled() {
      const checkbox = this.root.querySelector('[data-confirm-declarations-checkbox]');
      return !!checkbox?.checked;
    }

    getOneIdApiConfig() {
      return {
        apiUrl: this.root.dataset.oneidApiUrl || ONEID_START_API,
        tenant: this.root.dataset.gpApiTenant || ''
      };
    }

    getOneIdVerificationApiConfig() {
      return {
        apiUrl: this.root.dataset.oneidVerificationApiUrl || ONEID_VERIFICATION_API,
        tenant: this.root.dataset.gpApiTenant || 'slimmr-K9FQ7A2D'
      };
    }

    resolveIdentityVerifiedFlag() {
      if (this.isIdentityVerified()) return 'true';
      if (this.data.identityVerificationAttempted) return 'false';
      if (this.canSkipIdentityVerification()) return '';
      return null;
    }

    buildOneIdVerificationPayload() {
      const identityVerified = this.resolveIdentityVerifiedFlag();
      if (identityVerified === null) return null;

      const email = this.getPatientEmail();
      if (!email) return null;

      const params = this.data.oneIdResult?.params || {};
      const firstName = String(
        params.first_name || this.data.firstName || ''
      ).trim();
      const lastName = String(
        params.last_name || this.data.lastName || ''
      ).trim();
      const name = String(
        params.name
        || [firstName, lastName].filter(Boolean).join(' ')
        || ''
      ).trim();
      const birthdate = String(
        params.birthdate || this.data.dateOfBirth || ''
      ).trim();
      const oneidUserId = String(
        params.oneid_user_id
        || params.user_id
        || params.sub
        || params.id
        || ''
      ).trim();

      return {
        email: String(email).trim().toLowerCase(),
        oneid_verification: identityVerified,
        verified_by: 'OneID',
        oneid_user_id: oneidUserId,
        name,
        first_name: firstName,
        last_name: lastName,
        birthdate
      };
    }

    async syncOneIdVerificationToApi() {
      const payload = this.buildOneIdVerificationPayload();
      if (!payload) return false;

      const syncKey = [
        payload.email,
        payload.oneid_verification,
        payload.oneid_user_id
      ].join('|');

      if (this.data.oneIdVerificationSyncedKey === syncKey) return true;

      const { apiUrl, tenant } = this.getOneIdVerificationApiConfig();
      if (!apiUrl) return false;

      try {
        const headers = {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        };
        if (tenant) headers['X-Tenant'] = tenant;

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers,
          credentials: 'omit',
          body: JSON.stringify(payload)
        });

        if (!response.ok) return false;

        this.data.oneIdVerificationSyncedKey = syncKey;
        this.saveData();
        return true;
      } catch (_) {
        return false;
      }
    }

    isIdentityVerified() {
      return !!this.data.identityVerified;
    }

    canSkipIdentityVerification() {
      return isLocalDevServer() || isVerificationBypassEnabled();
    }

    normalizePersonName(value) {
      return String(value || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase();
    }

    normalizeBirthdate(value) {
      const raw = String(value || '').trim();
      if (!raw) return '';
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
      const dmy = raw.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
      if (dmy) {
        return `${dmy[3]}-${dmy[2].padStart(2, '0')}-${dmy[1].padStart(2, '0')}`;
      }
      return raw;
    }

    getFormFullName() {
      return this.normalizePersonName(
        [this.data.firstName, this.data.lastName].filter(Boolean).join(' ')
      );
    }

    getOneIdFullName() {
      const result = this.data.oneIdResult || {};
      const params = result.params || {};
      const fromParts = [params.first_name, params.last_name].filter(Boolean).join(' ');
      return this.normalizePersonName(result.name || fromParts || '');
    }

    getOneIdBirthdate() {
      const result = this.data.oneIdResult || {};
      const params = result.params || {};
      return this.normalizeBirthdate(result.birthdate || params.birthdate || '');
    }

    doesOneIdMatchFormDetails() {
      if (!this.isIdentityVerified()) return true;

      const oneIdName = this.getOneIdFullName();
      if (oneIdName && oneIdName !== this.getFormFullName()) return false;

      const oneIdDob = this.getOneIdBirthdate();
      if (oneIdDob && oneIdDob !== this.normalizeBirthdate(this.data.dateOfBirth)) {
        return false;
      }

      return true;
    }

    updateOneIdMismatchCorrectionNote(activeStepId) {
      this.root.querySelectorAll('[data-oneid-mismatch-note]').forEach((el) => {
        el.textContent = '';
        el.classList.remove('is-visible');
        el.hidden = true;
      });

      if (!this.data.oneIdMismatchCorrectionActive) return;
      if (activeStepId !== 'basic-info' && activeStepId !== 'date-of-birth') return;

      const step = this.root.querySelector(`[data-step="${activeStepId}"]`);
      if (!step) return;

      const titleBlock = step.querySelector('.assessment-form__title-block');
      if (!titleBlock) return;

      let note = step.querySelector('[data-oneid-mismatch-note]');
      if (!note) {
        note = document.createElement('p');
        note.className = 'assessment-form__inline-error';
        note.setAttribute('data-oneid-mismatch-note', '');
        titleBlock.appendChild(note);
      }

      const oneIdName = this.data.oneIdResult?.name || this.getOneIdFullName();
      const oneIdDob = this.getOneIdBirthdate();
      const parts = [];
      if (oneIdName) parts.push(`name: ${oneIdName}`);
      if (oneIdDob) parts.push(`date of birth: ${oneIdDob}`);
      const expected = parts.length ? ` (${parts.join(', ')})` : '';

      note.textContent = activeStepId === 'basic-info'
        ? `Your name must match your OneID verification${expected}. Please update your details below.`
        : `Your date of birth must match your OneID verification${expected}. Please update it below.`;
      note.hidden = false;
      note.classList.add('is-visible');
    }

    syncOneIdFromStorage() {
      return this.processOneIdStorageResult();
    }

    processOneIdStorageResult() {
      try {
        const raw = localStorage.getItem(ONEID_STORAGE_KEY);
        if (!raw) return false;

        const stored = JSON.parse(raw);
        const params = stored.params || {};
        const verified = String(params.verified || '').toLowerCase() === 'true';
        const hasError = !!(params.error || params.error_description);

        this.data.identityVerificationAttempted = true;

        if (verified && !hasError) {
          this.data.identityVerified = true;
          this.data.oneIdResult = {
            name: params.name || [params.first_name, params.last_name].filter(Boolean).join(' '),
            birthdate: params.birthdate || '',
            verifiedAt: stored.saved_at || new Date().toISOString(),
            params
          };
          this.saveData();
          void this.syncOneIdVerificationToApi();
          return true;
        }

        delete this.data.identityVerified;
        delete this.data.oneIdResult;
        this.saveData();
        void this.syncOneIdVerificationToApi();
        return false;
      } catch (_) {
        return false;
      }
    }

    markIdentityVerificationAttempted() {
      this.data.identityVerificationAttempted = true;
      if (!this.isIdentityVerified()) {
        delete this.data.identityVerified;
        delete this.data.oneIdResult;
      }
      this.saveData();
      void this.syncOneIdVerificationToApi();
    }

    stopOneIdPolling() {
      if (this.oneIdPollTimer) {
        clearInterval(this.oneIdPollTimer);
        this.oneIdPollTimer = null;
      }
    }

    updateIdentityVerificationUI() {
      const step = this.root.querySelector('[data-step="verify-identity"]');
      if (!step) return;

      this.processOneIdStorageResult();

      const verified = this.isIdentityVerified();
      const skipped = this.canSkipIdentityVerification() && !verified;
      const trigger = step.querySelector('[data-oneid-verify-trigger]');
      const nameEl = step.querySelector('[data-oneid-name]');
      const dobEl = step.querySelector('[data-oneid-dob]');
      const statusEl = step.querySelector('[data-oneid-status]');
      const errorEl = step.querySelector('[data-group-error="identityVerification"]');

      if (nameEl) {
        nameEl.textContent = verified && this.data.oneIdResult?.name
          ? this.data.oneIdResult.name
          : '—';
      }

      if (dobEl) {
        dobEl.textContent = verified && this.data.oneIdResult?.birthdate
          ? this.data.oneIdResult.birthdate
          : '—';
      }

      if (statusEl) {
        if (verified) {
          statusEl.textContent = ONEID_STATUS_VERIFIED;
          statusEl.classList.add('is-verified');
          statusEl.classList.remove('is-not-verified');
        } else if (skipped) {
          statusEl.textContent = ONEID_STATUS_BYPASS;
          statusEl.classList.add('is-verified');
          statusEl.classList.remove('is-not-verified');
        } else {
          statusEl.textContent = ONEID_STATUS_NOT_VERIFIED;
          statusEl.classList.remove('is-verified');
          statusEl.classList.add('is-not-verified');
        }
      }

      if (trigger) {
        if (verified) {
          trigger.disabled = true;
          trigger.textContent = 'Identity verified';
          trigger.classList.add('is-disabled');
        } else if (skipped) {
          trigger.disabled = true;
          trigger.textContent = 'Verification not required';
          trigger.classList.add('is-disabled');
        } else {
          trigger.disabled = false;
          trigger.textContent = 'Verify My Identity';
          trigger.classList.remove('is-disabled');
        }
      }

      if ((verified || skipped) && errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
    }

    async fetchOneIdAuthorizeUrl() {
      const { apiUrl, tenant } = this.getOneIdApiConfig();
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      };
      if (tenant) headers['X-Tenant'] = tenant;

      const response = await fetch(apiUrl, { headers });
      if (!response.ok) throw new Error('Unable to start identity verification.');

      const payload = await response.json();
      const url = payload?.data?.authorize_url || payload?.data?.authorizationUrl;
      if (!url) throw new Error('Missing authorization URL.');

      return url;
    }

    async startIdentityVerification() {
      const step = this.root.querySelector('[data-step="verify-identity"]');
      const trigger = step?.querySelector('[data-oneid-verify-trigger]');
      const errorEl = step?.querySelector('[data-group-error="identityVerification"]');

      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }

      if (trigger) {
        trigger.disabled = true;
        trigger.classList.add('is-loading');
      }

      try {
        const authorizeUrl = await this.fetchOneIdAuthorizeUrl();
        this.stopOneIdPolling();

        if (this.oneIdPopup && !this.oneIdPopup.closed) {
          this.oneIdPopup.close();
        }

        this.oneIdPopup = window.open(
          authorizeUrl,
          'slimmr_oneid_verify',
          'width=520,height=760,scrollbars=yes,resizable=yes'
        );

        if (!this.oneIdPopup) {
          throw new Error('Please allow pop-ups to verify your identity.');
        }

        this.oneIdPollTimer = setInterval(() => {
          if (this.syncOneIdFromStorage()) {
            this.stopOneIdPolling();
            if (this.oneIdPopup && !this.oneIdPopup.closed) {
              this.oneIdPopup.close();
            }
            this.updateIdentityVerificationUI();
            this.updateContinueState();
            return;
          }

          if (this.oneIdPopup?.closed) {
            this.stopOneIdPolling();
            this.processOneIdStorageResult();
            if (!this.isIdentityVerified()) {
              this.markIdentityVerificationAttempted();
            }
            this.updateIdentityVerificationUI();
            this.updateContinueState();
          }
        }, 500);
      } catch (err) {
        if (errorEl) {
          const message = err.message || 'Unable to start identity verification. Please try again.';
          errorEl.textContent = this.canUseDirectGpApi()
            ? message
            : `${message} If this persists on local preview, test on getslimmr.co.uk.`;
          errorEl.classList.add('is-visible');
        }
      } finally {
        if (trigger && !this.isIdentityVerified()) {
          trigger.disabled = false;
          trigger.classList.remove('is-loading');
        }
        this.updateIdentityVerificationUI();
        this.updateContinueState();
      }
    }

    validateVerifyIdentity() {
      if (this.canSkipIdentityVerification()) {
        if (!this.data.identityVerificationAttempted && !this.isIdentityVerified()) {
          void this.syncOneIdVerificationToApi();
        }
        return true;
      }

      this.syncOneIdFromStorage();
      if (!this.isIdentityVerified()) {
        return this.showGroupError('identityVerification', 'Please verify your identity before continuing.');
      }
      return true;
    }

    getMedicationPreferenceOptions() {
      const rx = this.data.previouslyPrescribed;
      let options = [];

      if (rx === PREVIOUS_PRESCRIPTION.WEGOVY_PILL) {
        options = [
          'Continue with Wegovy daily pill',
          'Switch to Mounjaro once weekly injection',
          'Switch to Wegovy once weekly injection',
          MEDICATION_PREFERENCE_UNSURE
        ];
      } else if (rx === PREVIOUS_PRESCRIPTION.WEGOVY_INJECTION) {
        options = [
          'Continue with Wegovy once weekly injection',
          'Switch to Mounjaro once weekly injection',
          'Switch to Wegovy daily pill',
          MEDICATION_PREFERENCE_UNSURE
        ];
      } else if (rx === PREVIOUS_PRESCRIPTION.OZEMPIC) {
        options = [
          'Transition to Wegovy once weekly injection',
          MEDICATION_PREFERENCE_UNSURE
        ];
      } else if (rx === PREVIOUS_PRESCRIPTION.MOUNJARO) {
        options = [
          'Continue with Mounjaro once weekly injection',
          'Switch to Wegovy once weekly injection',
          'Switch to Wegovy daily pill',
          MEDICATION_PREFERENCE_UNSURE
        ];
      }

      return this.filterMedicationPreferenceOptions(options);
    }

    filterMedicationPreferenceOptions(options) {
      const excluded = this.getExcludedMedicationKeys();
      return options.filter((option) => {
        const key = getMedicationPreferenceMedicationKey(option);
        return !key || !excluded.has(key);
      });
    }

    updateFemaleOnlyApplicableConditions() {
      const isFemale = this.data.biologicalSex === 'female';
      const group = this.root.querySelector('[data-selector-group][data-key="applicableConditions"]');
      if (!group) return;

      group.querySelectorAll('[data-female-only]').forEach((btn) => {
        btn.hidden = !isFemale;
      });

      if (!isFemale && Array.isArray(this.data.applicableConditions)) {
        const filtered = this.data.applicableConditions.filter(
          (item) => !FEMALE_ONLY_APPLICABLE_CONDITIONS.includes(item)
        );

        if (filtered.length !== this.data.applicableConditions.length) {
          this.data.applicableConditions = filtered;
          group.querySelectorAll('[data-selector]').forEach((el) => {
            if (FEMALE_ONLY_APPLICABLE_CONDITIONS.includes(el.dataset.value)) {
              el.classList.remove('is-selected');
            }
          });
          this.saveData();
        }
      }
    }

    isWegovyPillExcluded() {
      const allergies = this.data.allergyMedication || [];
      return allergies.some((item) => WEGOVY_PILL_ALLERGY_EXCLUSIONS.includes(item));
    }

    getMultiSelectValues(key) {
      const value = this.data[key];
      if (Array.isArray(value)) return value;
      if (value) return [value];
      return [];
    }

    getPatientAge() {
      if (this.data.age != null && Number.isFinite(this.data.age)) {
        return this.data.age;
      }

      const iso = this.data.dateOfBirth;
      if (iso) {
        const match = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (match) {
          const result = parseDateOfBirth(match[3], match[2], match[1]);
          if (result.valid) {
            this.data.age = result.age;
            return result.age;
          }
        }
      }

      const result = parseDateOfBirth(
        this.getFieldValue('dobDay'),
        this.getFieldValue('dobMonth'),
        this.getFieldValue('dobYear')
      );
      if (result.valid) {
        this.data.age = result.age;
        this.data.dateOfBirth = result.iso;
        return result.age;
      }

      return null;
    }

    isPatientAge85Plus() {
      const age = this.getPatientAge();
      return age != null && age >= MEDICATION_AGE_WEGOVY_MAX;
    }

    hasSharedMedicationAllergyExclusion() {
      const injectionAllergies = this.getMultiSelectValues('allergyInjection');
      const medicationAllergies = this.getMultiSelectValues('allergyMedication');

      return SHARED_MEDICATION_ALLERGY_INGREDIENTS.some((item) => (
        injectionAllergies.includes(item) || medicationAllergies.includes(item)
      ));
    }

    hasInjectionIngredientAllergyExclusion() {
      return this.getMultiSelectValues('allergyInjection').some((item) => (
        INJECTION_INGREDIENT_ALLERGY_EXCLUSIONS.includes(item)
      ));
    }

    hasOrlistatMedicationAllergyExclusion() {
      return this.getMultiSelectValues('allergyMedication').some((item) => (
        ORLISTAT_MEDICATION_ALLERGY_EXCLUSIONS.includes(item)
      ));
    }

    shouldHideInjectionMedications() {
      return this.hasInjectionIngredientAllergyExclusion() || this.hasSharedMedicationAllergyExclusion();
    }

    shouldHideOrlistatAlli() {
      if (this.hasOrlistatMedicationAllergyExclusion()) return true;
      if (this.hasSharedMedicationAllergyExclusion()) return true;
      return this.getMultiSelectValues('listedMedications').includes(LISTED_MEDICATION_WARFARIN);
    }

    getAllergyExcludedMedicationKeys() {
      const excluded = new Set();

      if (this.shouldHideInjectionMedications()) {
        excluded.add(MEDICATION_SELECTION.MOUNJARO);
        excluded.add(MEDICATION_SELECTION.WEGOVY);
      }

      if (this.hasOrlistatMedicationAllergyExclusion() || this.hasSharedMedicationAllergyExclusion()) {
        excluded.add(MEDICATION_SELECTION.ALLI);
      }

      if (this.isWegovyPillExcluded()) {
        excluded.add(MEDICATION_SELECTION.WEGOVY_PILL);
      }

      return excluded;
    }

    hasNoEligibleMedicationsFromAllergies() {
      const excluded = this.getAllergyExcludedMedicationKeys();
      return SELECTABLE_MEDICATIONS.every((key) => excluded.has(key));
    }

    redirectIfAllergyMedicationKickOut() {
      if (!this.hasNoEligibleMedicationsFromAllergies()) return false;
      this.markIneligible('medication_allergies');
      this.redirectIfIneligible();
      return true;
    }

    getExcludedMedicationKeys() {
      const excluded = new Set();

      if (this.shouldHideInjectionMedications()) {
        excluded.add(MEDICATION_SELECTION.MOUNJARO);
        excluded.add(MEDICATION_SELECTION.WEGOVY);
      }

      if (this.isPatientAge85Plus()) {
        excluded.add(MEDICATION_SELECTION.WEGOVY);
        excluded.add(MEDICATION_SELECTION.WEGOVY_PILL);
      }

      if (this.shouldHideOrlistatAlli()) {
        excluded.add(MEDICATION_SELECTION.ALLI);
      }

      if (this.isWegovyPillExcluded()) {
        excluded.add(MEDICATION_SELECTION.WEGOVY_PILL);
      }

      return excluded;
    }

    getAvailableSelectableMedicationCount(excluded = this.getExcludedMedicationKeys()) {
      return SELECTABLE_MEDICATIONS.filter((key) => !excluded.has(key)).length;
    }

    shouldShowPrescriberMedicationCard(excluded = this.getExcludedMedicationKeys()) {
      return this.getAvailableSelectableMedicationCount(excluded) >= 2;
    }

    updateMedicationSelectionVisibility() {
      const excluded = this.getExcludedMedicationKeys();
      const showPrescriber = this.shouldShowPrescriberMedicationCard(excluded);

      this.root.querySelectorAll('[data-med-selection-card]').forEach((card) => {
        const medKey = card.dataset.medKey
          || card.querySelector('[data-med-checkout]')?.dataset.medKey;

        if (medKey === MEDICATION_SELECTION.PRESCRIBER) {
          card.hidden = !showPrescriber;
          card.classList.toggle('is-med-excluded', !showPrescriber);
          return;
        }

        if (!medKey) {
          card.hidden = false;
          card.classList.remove('is-med-excluded');
          return;
        }

        const isExcluded = excluded.has(medKey);
        card.hidden = isExcluded;
        card.classList.toggle('is-med-excluded', isExcluded);
      });

      if (excluded.has(this.data.selectedMedication)) {
        delete this.data.selectedMedication;
        delete this.data.selectedVariantId;
        this.saveData();
      } else if (!showPrescriber && this.data.selectedMedication === MEDICATION_SELECTION.PRESCRIBER) {
        delete this.data.selectedMedication;
        delete this.data.selectedVariantId;
        this.saveData();
      }
    }

    updateMedicationPreferenceOptions() {
      const group = this.root.querySelector('[data-selector-group][data-key="medicationPreference"]');
      if (!group) return;

      const options = this.getMedicationPreferenceOptions();
      const selected = this.data.medicationPreference;

      if (selected && !options.includes(selected)) {
        delete this.data.medicationPreference;
      }

      group.innerHTML = options.map((option) => (
        `<button type="button" class="assessment-form__selector" data-selector data-value="${escapeHtml(option)}">${escapeHtml(option)}</button>`
      )).join('');

      const active = this.data.medicationPreference;
      if (active) {
        group.querySelectorAll('[data-selector]').forEach((el) => {
          el.classList.toggle('is-selected', el.dataset.value === active);
        });
      }
    }

    getLastDoseDateParts() {
      const iso = this.data.glp1LastDoseDate;
      if (iso) {
        const [yy, mm, dd] = iso.split('-').map((part) => Number(part));
        if (yy && mm && dd) return { dd, mm, yy };
      }

      return {
        dd: Number(this.getFieldValue('glp1LastDoseDay')) || 0,
        mm: Number(this.getFieldValue('glp1LastDoseMonth')) || 0,
        yy: Number(this.getFieldValue('glp1LastDoseYear')) || 0
      };
    }

    getNextDoseOptions() {
      if (!this.needsPreviousPrescriptionStep()) return [];
      if (!this.data.previousPrescriptionDose) return [];

      const { dd, mm, yy } = this.getLastDoseDateParts();
      const mode = resolveDosePreferenceMode(this.data.medicationPreference, this.data.previouslyPrescribed);

      return getNeighbourDoses({
        dose: this.data.previousPrescriptionDose,
        mode,
        dd,
        mm,
        yy,
        previouslyPrescribed: this.data.previouslyPrescribed,
        medicationPreference: this.data.medicationPreference
      });
    }

    needsNextDosePreferenceStep() {
      if (!this.needsPreviousPrescriptionStep()) return false;
      if (this.isMedicationPreferencePrescriberDecide()) return false;
      return this.getNextDoseOptions().length > 0;
    }

    isMedicationPreferencePrescriberDecide() {
      const pref = this.data.medicationPreference;
      return pref === MEDICATION_PREFERENCE_UNSURE || pref === MEDICATION_PREFERENCE_DECIDE;
    }

    isWegovyInjectionPreferenceSelected() {
      return resolveMedicationPreferenceTarget(this.data.medicationPreference) === 'wegovy';
    }

    needsPenCycleStep() {
      return this.isWegovyInjectionPreferenceSelected();
    }

    needsMedicationExperienceStep() {
      return this.needsPreviousPrescriptionStep();
    }

    updateNextDosePreferenceOptions() {
      const group = this.root.querySelector('[data-selector-group][data-key="nextDosePreference"]');
      if (!group) return;

      if (this.isMedicationPreferencePrescriberDecide()) {
        delete this.data.nextDosePreference;
        delete this.data.nextDosePreferenceVariantId;
        group.innerHTML = '';
        return;
      }

      const options = this.getNextDoseOptions();
      const selected = this.data.nextDosePreference;

      if (selected && !options.some((option) => option.name === selected)) {
        delete this.data.nextDosePreference;
        delete this.data.nextDosePreferenceVariantId;
      }

      group.innerHTML = options.map((option) => (
        `<button type="button" class="assessment-form__selector" data-selector data-value="${escapeHtml(option.name)}" data-variant-id="${escapeHtml(option.value)}">${escapeHtml(option.name)}</button>`
      )).join('');

      const active = this.data.nextDosePreference;
      if (active) {
        group.querySelectorAll('[data-selector]').forEach((el) => {
          el.classList.toggle('is-selected', el.dataset.value === active);
        });
      }
    }

    updateConditionalSections() {
      const medStatus = this.data.medicationStatus;
      const initialWeight = this.root.querySelector('[data-initial-weight]');
      if (initialWeight) {
        const show = medStatus === 'switching';
        initialWeight.hidden = !show;
        if (!show) {
          ['initialStones', 'initialPounds', 'initialKg'].forEach((name) => {
            const field = this.root.querySelector(`[name="${name}"]`);
            if (field) field.value = '';
            delete this.data[name];
          });
        }
      }

      const followup = this.root.querySelector('[data-followup-section]');
      if (followup && STEPS[this.currentStep] === 'comorbidity-followup' && this.needsComorbidityFollowup()) {
        this.loadFollowupFormForCurrentCondition();
      }

      this.updateEthnicOther();
      this.updateOtherAllergiesDetail();
      this.updateIllnessesOperationsDetail();
      this.updateOtherMedicationsDetail();
      this.updateGpSearchState();
      this.updateGpUnableDetail();
      this.updatePreviousPrescriptionDose();
      this.updatePrescriptionEvidenceDetail();
      this.updateMedicationPreferenceOptions();
      this.updateNextDosePreferenceOptions();
      this.updateMedicationSelectionVisibility();
      this.updateFemaleOnlyApplicableConditions();
      this.updateIdentityVerificationUI();
      this.updateScalePhotoDetail();
    }

    goToStep(index, animate) {
      const bounded = Math.max(0, Math.min(index, STEPS.length - 1));
      const stepId = STEPS[bounded];

      if (stepId === 'medication-selection' && this.hasNoEligibleMedicationsFromAllergies()) {
        this.markIneligible('medication_allergies');
        this.redirectIfIneligible();
        return;
      }

      const steps = Array.from(this.root.querySelectorAll('[data-step]'));

      let activeEl = steps.find((el) => el.dataset.step === stepId);

      if (!activeEl && steps[bounded]) {
        activeEl = steps[bounded];
      }

      if (!activeEl) {
        activeEl = steps[steps.length - 1] || steps[0];
      }

      if (!activeEl) return;

      const activeStepId = activeEl.dataset.step || stepId;
      const slugIndex = STEPS.indexOf(activeStepId);
      this.currentStep = slugIndex >= 0 ? slugIndex : bounded;

      this.root.dataset.currentStepId = getStepId(activeStepId) || activeEl.dataset.stepId || '';

      steps.forEach((el) => {
        el.classList.toggle('is-active', el === activeEl);
      });

      if (this.navEl) {
        this.navEl.hidden = activeStepId === 'intro' || activeStepId === 'ineligible';
      }

      if (this.progressFill) {
        const pct = activeStepId === 'intro' || activeStepId === 'ineligible'
          ? 0
          : (this.currentStep / Math.max(STEPS.length - 1, 1)) * 100;
        this.progressFill.style.width = pct + '%';
      }

      this.data._stepIndex = this.currentStep;
      this.saveData();

      this.updateConditionalSections();
      this.updateContinueState();
      this.updateOptionalExtrasUI();
      if (activeStepId === 'medication-selection') {
        this.updateMedicationSelectionVisibility();
      }
      if (activeStepId === 'delivery-date') {
        this.renderDeliveryCalendar();
      }
      this.hideGpResults();
      this.updateOneIdMismatchCorrectionNote(activeStepId);
      window.scrollTo({ top: 0, behavior: animate === false ? 'auto' : 'smooth' });
    }

    goBack() {
      if (this.currentStep <= 0) return;

      const stepId = STEPS[this.currentStep];
      if (stepId === 'ineligible') return;

      if (stepId === 'basic-info' && this.data.oneIdMismatchCorrectionActive) {
        const verifyIndex = STEPS.indexOf('verify-identity');
        if (verifyIndex >= 0) {
          this.goToStep(verifyIndex);
          return;
        }
      }

      if (stepId === 'comorbidity-followup') {
        const index = this.data.followupIndex || 0;
        if (index > 0) {
          this.saveCurrentFollowupToData();
          this.data.followupIndex = index - 1;
          delete this.data.followupCondition;
          this.saveData();
          this.loadFollowupFormForCurrentCondition(true);
          this.updateContinueState();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
      }

      if (stepId === 'confirm-declarations') {
        if (this.needsMedicationSelectionStep()) {
          this.goToStep(STEPS.indexOf('medication-selection'));
          return;
        }
        if (this.needsMedicationExperienceStep()) {
          this.goToStep(STEPS.indexOf('medication-experience'));
        } else {
          this.goToStep(STEPS.indexOf('previous-prescription'));
        }
        return;
      }

      if (stepId === 'previous-prescription' && this.needsMedicationSelectionStep()) {
        this.goToStep(STEPS.indexOf('diet-lifestyle'));
        return;
      }

      let prev = this.currentStep - 1;

      if (STEPS[prev] === 'comorbidity-followup') {
        if (!this.needsComorbidityFollowup()) {
          prev--;
        } else {
          const conditions = this.getFollowupConditions();
          this.data.followupIndex = Math.max(0, conditions.length - 1);
          delete this.data.followupCondition;
          this.saveData();
        }
      }

      if (STEPS[prev] === 'pen-doses-remaining' && !this.needsPenDosesRemainingStep()) {
        prev--;
      }

      if (STEPS[prev] === 'next-dose-preference' && !this.needsNextDosePreferenceStep()) {
        prev--;
      }

      if (STEPS[prev] === 'medication-experience' && !this.needsMedicationExperienceStep()) {
        prev--;
      }

      if (STEPS[prev] === 'wegovy-pencycle' && !this.needsPenCycleStep()) {
        prev--;
      }

      if (STEPS[prev] === 'medication-selection' && !this.needsMedicationSelectionStep()) {
        prev--;
      }

      if (STEPS[prev] === 'previous-prescription' && !this.needsPreviousPrescriptionStep()) {
        prev--;
      }

      this.goToStep(prev);
    }

    async handleContinue() {
      if (!this.validateCurrentStep()) return;

      const dateConfirm = this.getDateConfirmationPayload();
      if (dateConfirm) {
        const confirmed = await this.promptDateConfirmation(dateConfirm);
        if (!confirmed) return;
      }

      const stepId = STEPS[this.currentStep];

      if (stepId === 'verify-identity') {
        if (
          !this.canSkipIdentityVerification()
          && this.isIdentityVerified()
          && !this.doesOneIdMatchFormDetails()
        ) {
          this.data.oneIdMismatchCorrectionActive = true;
          this.saveData();
          this.showGroupError(
            'identityVerification',
            'Your name or date of birth doesn’t match OneID. Please update your details.'
          );
          const basicIndex = STEPS.indexOf('basic-info');
          if (basicIndex >= 0) {
            this.goToStep(basicIndex);
            return;
          }
        }

        if (this.data.oneIdMismatchCorrectionActive && this.doesOneIdMatchFormDetails()) {
          delete this.data.oneIdMismatchCorrectionActive;
          this.saveData();
        }
      }

      if (stepId === 'date-of-birth' && this.data.oneIdMismatchCorrectionActive) {
        const verifyIndex = STEPS.indexOf('verify-identity');
        if (verifyIndex >= 0) {
          this.goToStep(verifyIndex);
          return;
        }
      }

      if (stepId === 'allergies') {
        const reason = this.getEligibilityFailureReason();
        if (reason) {
          this.markIneligible(reason);
          this.redirectIfIneligible();
          return;
        }
      }

      if (stepId === 'basic-info') {
        const redirected = await this.handleExistingPatientRedirect();
        if (redirected) return;
      }

      if (stepId === 'comorbidity-followup') {
        const conditions = this.getFollowupConditions();
        const index = this.data.followupIndex || 0;

        if (index < conditions.length - 1) {
          this.data.followupIndex = index + 1;
          delete this.data.followupCondition;
          this.saveData();
          this.loadFollowupFormForCurrentCondition(true);
          this.updateContinueState();
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        this.goToStep(STEPS.indexOf('weight-mood') >= 0 ? STEPS.indexOf('weight-mood') : this.currentStep + 1);
        return;
      }

      if (stepId === 'diet-lifestyle') {
        if (this.needsMedicationSelectionStep()) {
          if (this.redirectIfAllergyMedicationKickOut()) return;
          const medIndex = STEPS.indexOf('medication-selection');
          if (medIndex >= 0) {
            this.goToStep(medIndex);
            return;
          }
        }
        const presIndex = STEPS.indexOf('previous-prescription');
        if (presIndex >= 0) {
          this.goToStep(presIndex);
          return;
        }
      }

      if (stepId === 'previous-prescription') {
        if (!this.needsPreviousPrescriptionStep()) {
          if (this.needsMedicationSelectionStep()) {
            if (this.redirectIfAllergyMedicationKickOut()) return;
            const medIndex = STEPS.indexOf('medication-selection');
            if (medIndex >= 0) {
              this.goToStep(medIndex);
              return;
            }
          }
          const confirmIndex = STEPS.indexOf('confirm-declarations');
          if (confirmIndex >= 0) {
            this.goToStep(confirmIndex);
            return;
          }
          this.complete();
          return;
        }
        if (this.needsPreviousPrescriptionStep()) {
          const startIndex = STEPS.indexOf('glp1-treatment-start');
          if (startIndex >= 0) {
            this.goToStep(startIndex);
            return;
          }
        }
        const confirmIndex = STEPS.indexOf('confirm-declarations');
        if (confirmIndex >= 0) {
          this.goToStep(confirmIndex);
          return;
        }
        this.complete();
        return;
      }

      if (stepId === 'medication-preference') {
        if (!this.needsNextDosePreferenceStep() && !this.needsMedicationExperienceStep()) {
          const confirmIndex = STEPS.indexOf('confirm-declarations');
          if (confirmIndex >= 0) {
            this.goToStep(confirmIndex);
            return;
          }
          this.complete();
          return;
        }
      }

      if (stepId === 'next-dose-preference' && !this.needsNextDosePreferenceStep()) {
        if (!this.needsMedicationExperienceStep()) {
          const confirmIndex = STEPS.indexOf('confirm-declarations');
          if (confirmIndex >= 0) {
            this.goToStep(confirmIndex);
            return;
          }
          this.complete();
          return;
        }
      }

      if (stepId === 'medication-experience' && !this.needsMedicationExperienceStep()) {
        const confirmIndex = STEPS.indexOf('confirm-declarations');
        if (confirmIndex >= 0) {
          this.goToStep(confirmIndex);
          return;
        }
        this.complete();
        return;
      }

      if (this.currentStep >= STEPS.length - 1) {
        this.complete();
        return;
      }

      let next = this.currentStep + 1;

      if (STEPS[next] === 'comorbidity-followup') {
        if (!this.needsComorbidityFollowup()) {
          next = STEPS.indexOf('weight-mood');
          if (next < 0) next = this.currentStep + 1;
        } else {
          this.data.followupIndex = 0;
          delete this.data.followupCondition;
          this.pruneComorbidityFollowups();
          this.saveData();
        }
      }

      if (STEPS[next] === 'pen-doses-remaining' && !this.needsPenDosesRemainingStep()) {
        next++;
      }

      if (STEPS[next] === 'next-dose-preference' && !this.needsNextDosePreferenceStep()) {
        const expIndex = STEPS.indexOf('medication-experience');
        next = expIndex >= 0 ? expIndex : next + 1;
      }

      if (STEPS[next] === 'medication-experience' && !this.needsMedicationExperienceStep()) {
        const confirmIndex = STEPS.indexOf('confirm-declarations');
        next = confirmIndex >= 0 ? confirmIndex : next + 1;
      }

      if (STEPS[next] === 'wegovy-pencycle' && !this.needsPenCycleStep()) {
        const verifyIndex = STEPS.indexOf('verify-identity');
        next = verifyIndex >= 0 ? verifyIndex : next + 1;
      }

      if (STEPS[next] === 'medication-selection') {
        if (this.hasNoEligibleMedicationsFromAllergies()) {
          this.markIneligible('medication_allergies');
          this.redirectIfIneligible();
          return;
        }
        if (!this.needsMedicationSelectionStep()) {
          next++;
        }
      }

      if (STEPS[next] === 'previous-prescription' && !this.needsPreviousPrescriptionStep()) {
        const confirmIndex = STEPS.indexOf('confirm-declarations');
        next = confirmIndex >= 0 ? confirmIndex : next + 1;
      }

      this.goToStep(next);
    }

    validateCurrentStep() {
      const stepId = STEPS[this.currentStep];

      switch (stepId) {
        case 'intro':
          return true;

        case 'ineligible':
          return true;

        case 'basic-info':
          return this.validateBasicInfo();

        case 'date-of-birth':
          return this.validateDateOfBirth();

        case 'ethnic-background':
          return this.validateEthnicBackground();

        case 'medication-provider':
          return this.validateRequired('medicationStatus', 'Please choose an option.');

        case 'previous-prescription':
          return this.validatePreviousPrescription();

        case 'glp1-treatment-start':
          return this.validateGlp1TreatmentStart();

        case 'glp1-last-dose':
          return this.validateGlp1LastDose();

        case 'pen-doses-remaining':
          if (!this.needsPenDosesRemainingStep()) return true;
          return this.validateRequired('penDosesRemaining', 'Please choose an option.');

        case 'prescription-evidence':
          return this.validatePrescriptionEvidence();

        case 'medication-preference':
          if (!this.needsPreviousPrescriptionStep() || !this.data.previouslyPrescribed) return true;
          return this.validateRequired('medicationPreference', 'Please choose an option.');

        case 'next-dose-preference':
          if (!this.needsNextDosePreferenceStep()) return true;
          return this.validateRequired('nextDosePreference', 'Please choose a dose.');

        case 'medication-experience':
          if (!this.needsMedicationExperienceStep()) return true;
          return this.validateRequired('medicationExperience', 'Please choose an option.');

        case 'confirm-declarations':
          return this.validateConfirmDeclarations();

        case 'wegovy-pencycle':
          if (!this.needsPenCycleStep()) return true;
          return this.validateRequired('penCycleReturnBox', 'Please choose an option.');

        case 'verify-identity':
          return this.validateVerifyIdentity();

        case 'scale-photo':
          return this.validateScalePhoto();

        case 'optional-extras':
          return true;

        case 'delivery-date':
          return this.validateDeliveryDate();

        case 'body-measurements':
          return this.validateBodyMeasurements();

        case 'biological-sex':
          return this.validateBiologicalSex();

        case 'medical-exclusions':
          return this.validateMultiSelect('medicalExclusions', 'Please choose an option.');

        case 'comorbidities':
          this.pruneComorbidityFollowups();
          return this.validateMultiSelect('comorbidities', 'Please choose an option.');

        case 'comorbidity-followup':
          return this.validateFollowup();

        case 'weight-mood':
          return this.validateRequired('weightMoodImpact', 'Please choose an option.');

        case 'allergies':
          return this.validateAllergies();

        case 'illnesses-operations':
          return this.validateIllnessesOperations();

        case 'medications':
          return this.validateMedications();

        case 'applicable-conditions':
          return this.validateMultiSelect('applicableConditions', 'Please choose an option.');

        case 'gp-surgery':
          return this.validateGpSurgery();

        case 'diet-lifestyle':
          return this.validateDietLifestyle();

        case 'medication-selection':
          return true;

        default:
          return true;
      }
    }

    validateBasicInfo() {
      const firstName = this.getFieldValue('firstName');
      const lastName = this.getFieldValue('lastName');
      const email = this.getFieldValue('email');
      const phone = this.getFieldValue('phone');

      if (!firstName.trim()) return this.showFieldError('firstName', 'Please enter your first name.');
      if (!isValidName(firstName)) {
        return this.showFieldError('firstName', 'First name must be 2–50 letters and may include spaces, hyphens or apostrophes.');
      }

      if (!lastName.trim()) return this.showFieldError('lastName', 'Please enter your last name.');
      if (!isValidName(lastName)) {
        return this.showFieldError('lastName', 'Last name must be 2–50 letters and may include spaces, hyphens or apostrophes.');
      }

      if (!email) return this.showFieldError('email', 'Please enter your email.');
      if (!isValidEmail(email)) return this.showFieldError('email', 'Please enter a valid email address.');

      if (!phone) return this.showFieldError('phone', 'Please enter your phone number.');

      const phoneCountry = this.getPhoneCountry();
      if (!isValidPhone(phone, phoneCountry)) {
        return this.showFieldError('phone', getPhoneValidationMessage(phoneCountry));
      }

      this.data.firstName = firstName.trim();
      this.data.lastName = lastName.trim();
      this.data.email = email.trim().toLowerCase();
      this.data.phoneCountry = phoneCountry;
      this.data.phoneNational = String(phone).replace(/\D/g, '');
      this.data.phone = formatE164(phone, phoneCountry);
      this.saveData();
      return true;
    }

    async checkPatientAssessmentExists(email) {
      const apiUrl = resolveLooprxApiUrl(
        this.root.dataset.checkAssessmentApiUrl,
        'check-assessment',
        CHECK_ASSESSMENT_API
      );
      const tenant = this.root.dataset.gpApiTenant || '';
      const headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
      if (tenant) headers['X-Tenant'] = tenant;

      const response = await fetch(
        `${apiUrl}?patient_email=${encodeURIComponent(email)}&category_id=${ASSESSMENT_CATEGORY_ID}`,
        { method: 'GET', headers }
      );

      if (!response.ok) return false;

      const payload = await response.json();
      return payload?.status === 'success' && payload?.message === 'Assessment found';
    }

    async handleExistingPatientRedirect() {
      if (isVerificationBypassEnabled()) return false;

      const fromParam = String(
        new URLSearchParams(window.location.search).get('from') || ''
      ).trim().toLowerCase();
      if (this.data.fromWbq || fromParam === 'wbq') return false;

      const email = this.data.email;
      if (!email) return false;

      const activeStep = this.root.querySelector('[data-step].is-active');
      const btn = activeStep?.querySelector('[data-assessment-continue]');
      const oldText = btn?.textContent;

      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Checking...';
      }

      try {
        const exists = await this.checkPatientAssessmentExists(email);
        if (exists) {
          window.location.assign(PATIENT_PORTAL_LOGIN_URL);
          return true;
        }
      } catch (_) {}

      if (btn) {
        btn.textContent = oldText || 'Continue';
        this.updateContinueState();
      }

      return false;
    }

    validateEthnicBackground() {
      if (!this.data.ethnicBackground) {
        return this.showGroupError('ethnicBackground', 'Please choose an option.');
      }

      if (this.data.ethnicBackground === 'Other') {
        const other = this.getFieldValue('ethnicOther').trim();
        if (!other) return this.markTextareaError('ethnicOther');
        if (other.length < 2) return this.markTextareaError('ethnicOther');
        this.data.ethnicOther = other;
      } else {
        delete this.data.ethnicOther;
      }

      this.saveData();
      return true;
    }

    validateDateOfBirth() {
      this.clearDobErrors();

      const result = parseDateOfBirth(
        this.getFieldValue('dobDay'),
        this.getFieldValue('dobMonth'),
        this.getFieldValue('dobYear')
      );

      if (!result.valid) {
        if (result.banner) {
          this.showDobError('Invalid Date');
          this.markDobFieldsError();
        } else {
          this.showFieldError(result.field, result.message);
        }
        return false;
      }

      this.hideDobError();
      this.data.dateOfBirth = result.iso;
      this.data.age = result.age;
      this.updateMedicationSelectionVisibility();
      this.saveData();
      return true;
    }

    updateDobErrorBanner() {
      const result = parseDateOfBirth(
        this.getFieldValue('dobDay'),
        this.getFieldValue('dobMonth'),
        this.getFieldValue('dobYear')
      );

      if (!result.valid && result.banner) {
        this.showDobError('Invalid Date');
        this.markDobFieldsError();
      } else {
        this.hideDobError();
      }
    }

    markDobFieldsError() {
      ['dobDay', 'dobMonth', 'dobYear'].forEach((name) => {
        const field = this.root.querySelector(`[name="${name}"]`);
        if (field) field.classList.add('is-error');
      });
    }

    showDobError(message) {
      const banner = this.root.querySelector('[data-dob-error]');
      if (banner) {
        const textEl = banner.querySelector('[data-dob-error-text]');
        if (textEl) textEl.textContent = message;
        banner.classList.add('is-visible');
      }
      return false;
    }

    hideDobError() {
      const banner = this.root.querySelector('[data-dob-error]');
      if (banner) banner.classList.remove('is-visible');
    }

    clearDobErrors() {
      this.hideDobError();
      ['dobDay', 'dobMonth', 'dobYear'].forEach((name) => {
        const field = this.root.querySelector(`[name="${name}"]`);
        if (!field) return;
        field.classList.remove('is-error');
        const errorEl = field.closest('[data-field]')?.querySelector('[data-field-error]');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
      });
    }

    validateGlp1TreatmentStart() {
      this.clearGlp1StartErrors();

      const result = parseGlp1TreatmentStart(
        this.getFieldValue('glp1StartDay'),
        this.getFieldValue('glp1StartMonth'),
        this.getFieldValue('glp1StartYear')
      );

      if (!result.valid) {
        if (result.banner) {
          this.showGlp1StartError('Invalid Date');
          this.markGlp1StartFieldsError();
        } else {
          this.showFieldError(result.field, result.message);
        }
        return false;
      }

      this.hideGlp1StartError();
      this.data.glp1TreatmentStartDate = result.iso;
      this.saveData();
      return true;
    }

    updateGlp1StartErrorBanner() {
      const result = parseGlp1TreatmentStart(
        this.getFieldValue('glp1StartDay'),
        this.getFieldValue('glp1StartMonth'),
        this.getFieldValue('glp1StartYear')
      );

      if (!result.valid && result.banner) {
        this.showGlp1StartError('Invalid Date');
        this.markGlp1StartFieldsError();
      } else {
        this.hideGlp1StartError();
      }
    }

    markGlp1StartFieldsError() {
      ['glp1StartDay', 'glp1StartMonth', 'glp1StartYear'].forEach((name) => {
        const field = this.root.querySelector(`[name="${name}"]`);
        if (field) field.classList.add('is-error');
      });
    }

    showGlp1StartError(message) {
      const banner = this.root.querySelector('[data-glp1-start-error]');
      if (banner) {
        const textEl = banner.querySelector('[data-glp1-start-error-text]');
        if (textEl) textEl.textContent = message;
        banner.classList.add('is-visible');
      }
      return false;
    }

    hideGlp1StartError() {
      const banner = this.root.querySelector('[data-glp1-start-error]');
      if (banner) banner.classList.remove('is-visible');
    }

    clearGlp1StartErrors() {
      this.hideGlp1StartError();
      ['glp1StartDay', 'glp1StartMonth', 'glp1StartYear'].forEach((name) => {
        const field = this.root.querySelector(`[name="${name}"]`);
        if (!field) return;
        field.classList.remove('is-error');
        const errorEl = field.closest('[data-field]')?.querySelector('[data-field-error]');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
      });
    }

    validateGlp1LastDose() {
      this.clearGlp1LastDoseErrors();

      const startResult = parseGlp1TreatmentStart(
        this.getFieldValue('glp1StartDay'),
        this.getFieldValue('glp1StartMonth'),
        this.getFieldValue('glp1StartYear')
      );
      const treatmentStartIso = this.data.glp1TreatmentStartDate || (startResult.valid ? startResult.iso : undefined);

      const result = parseGlp1LastDose(
        this.getFieldValue('glp1LastDoseDay'),
        this.getFieldValue('glp1LastDoseMonth'),
        this.getFieldValue('glp1LastDoseYear'),
        treatmentStartIso
      );

      if (!result.valid) {
        if (result.banner) {
          this.showGlp1LastDoseError(result.message === 'Last dose cannot be before your treatment start date.'
            ? result.message
            : 'Invalid Date');
          this.markGlp1LastDoseFieldsError();
        } else {
          this.showFieldError(result.field, result.message);
        }
        return false;
      }

      this.hideGlp1LastDoseError();
      this.data.glp1LastDoseDate = result.iso;
      this.saveData();
      return true;
    }

    updateGlp1LastDoseErrorBanner() {
      const startResult = parseGlp1TreatmentStart(
        this.getFieldValue('glp1StartDay'),
        this.getFieldValue('glp1StartMonth'),
        this.getFieldValue('glp1StartYear')
      );
      const treatmentStartIso = this.data.glp1TreatmentStartDate || (startResult.valid ? startResult.iso : undefined);

      const result = parseGlp1LastDose(
        this.getFieldValue('glp1LastDoseDay'),
        this.getFieldValue('glp1LastDoseMonth'),
        this.getFieldValue('glp1LastDoseYear'),
        treatmentStartIso
      );

      if (!result.valid && result.banner) {
        this.showGlp1LastDoseError(result.message === 'Last dose cannot be before your treatment start date.'
          ? result.message
          : 'Invalid Date');
        this.markGlp1LastDoseFieldsError();
      } else {
        this.hideGlp1LastDoseError();
      }
    }

    markGlp1LastDoseFieldsError() {
      ['glp1LastDoseDay', 'glp1LastDoseMonth', 'glp1LastDoseYear'].forEach((name) => {
        const field = this.root.querySelector(`[name="${name}"]`);
        if (field) field.classList.add('is-error');
      });
    }

    showGlp1LastDoseError(message) {
      const banner = this.root.querySelector('[data-glp1-last-dose-error]');
      if (banner) {
        const textEl = banner.querySelector('[data-glp1-last-dose-error-text]');
        if (textEl) textEl.textContent = message;
        banner.classList.add('is-visible');
      }
      return false;
    }

    hideGlp1LastDoseError() {
      const banner = this.root.querySelector('[data-glp1-last-dose-error]');
      if (banner) banner.classList.remove('is-visible');
    }

    clearGlp1LastDoseErrors() {
      this.hideGlp1LastDoseError();
      ['glp1LastDoseDay', 'glp1LastDoseMonth', 'glp1LastDoseYear'].forEach((name) => {
        const field = this.root.querySelector(`[name="${name}"]`);
        if (!field) return;
        field.classList.remove('is-error');
        const errorEl = field.closest('[data-field]')?.querySelector('[data-field-error]');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.remove('is-visible');
        }
      });
    }

    calculateBmi() {
      const heightCm = this.parseHeightCm();
      const weightKg = this.parseWeightKg('current');
      if (!heightCm || !weightKg) return 0;

      const heightM = heightCm / 100;
      return Math.round((weightKg / (heightM * heightM)) * 10) / 10;
    }

    getEligibilityFailureReason() {
      const stepIds = Object.keys(ELIGIBILITY.STEP_REASONS);
      for (let i = 0; i < stepIds.length; i++) {
        const reason = this.getEligibilityFailureReasonForStep(stepIds[i]);
        if (reason) return reason;
      }
      return null;
    }

    getEligibilityFailureReasonForStep(stepId) {
      switch (stepId) {
        case 'date-of-birth':
          if (this.data.age != null && this.data.age < ELIGIBILITY.MIN_AGE) {
            return 'underage';
          }
          break;

        case 'body-measurements': {
          const bmi = this.calculateBmi();
          if (bmi > 0 && bmi < ELIGIBILITY.MIN_BMI) {
            return 'low_bmi';
          }
          break;
        }

        case 'biological-sex':
          if (
            this.data.biologicalSex === 'female'
            && ELIGIBILITY.PREGNANCY_INELIGIBLE.includes(this.data.pregnancyStatus)
          ) {
            return 'pregnancy';
          }
          break;

        case 'medical-exclusions':
          if (hasSelectionOtherThanNone(this.data.medicalExclusions, ELIGIBILITY.NONE_OF_ABOVE)) {
            return 'medical_exclusions';
          }
          break;

        case 'comorbidity-followup': {
          const condition = this.getCurrentFollowupCondition();
          if (!this.isType2DiabetesFollowup(condition)) break;

          const management = this.data.type2Management || [];
          if (management.some((value) => ELIGIBILITY.TYPE2_MANAGEMENT_INELIGIBLE.includes(value))) {
            return 'type2_management';
          }

          const applies = this.data.type2Applies || [];
          if (applies.some((value) => ELIGIBILITY.TYPE2_APPLIES_INELIGIBLE.includes(value))) {
            return 'type2_applies';
          }
          break;
        }

        case 'allergies':
          if (this.hasNoEligibleMedicationsFromAllergies()) {
            return 'medication_allergies';
          }
          break;

        default:
          break;
      }

      return null;
    }

    markIneligible(reason) {
      this.data.ineligible = true;
      this.data.ineligibleReason = reason;
      this.saveData();
    }

    redirectIfIneligible() {
      const ineligibleIndex = STEPS.indexOf('ineligible');
      if (ineligibleIndex < 0) return;
      this.goToStep(ineligibleIndex);
    }

    validateBodyMeasurements() {
      const unit = this.data.unitSystem || 'imperial';
      let valid = true;

      if (!this.validateHeightField()) valid = false;

      if (this.data.medicationStatus === 'switching') {
        if (!this.validateWeightFields('initial', true)) valid = false;
      }

      if (!this.validateWeightFields('current', true)) valid = false;

      const waist = parseNumericField(this.getFieldValue('waistCm'));
      const waistRange = BODY_MEASUREMENT_RANGES.WAIST_CM;
      if (waist.empty) {
        this.showRangeError('waistCm', 'Please enter your waist measurement.');
        valid = false;
      } else if (!waist.valid || waist.value < waistRange.min || waist.value > waistRange.max) {
        this.showRangeError('waistCm', waistRange.message);
        valid = false;
      } else {
        this.hideRangeError('waistCm');
      }

      const hasTarget = unit === 'imperial'
        ? (this.getFieldValue('targetStones') || this.getFieldValue('targetPounds'))
        : this.getFieldValue('targetKg');
      if (hasTarget) {
        if (!this.validateWeightFields('target', false)) valid = false;
      } else {
        this.hideRangeError('targetKg');
        this.hideFieldError('targetStones');
        this.hideFieldError('targetPounds');
      }

      this.saveData();
      return valid;
    }

    validateHeightField() {
      const unit = this.data.unitSystem || 'imperial';
      const range = BODY_MEASUREMENT_RANGES.HEIGHT_CM;

      if (unit === 'metric') {
        this.hideHeightError();
        const cm = parseNumericField(this.getFieldValue('heightCm'));
        if (cm.empty) {
          this.showRangeError('heightCm', 'Please enter your height.');
          return false;
        }
        if (!cm.valid || cm.value < range.min || cm.value > range.max) {
          this.showRangeError('heightCm', range.message);
          return false;
        }
        this.hideRangeError('heightCm');
        return true;
      }

      this.hideRangeError('heightCm');
      const feet = parseNumericField(this.getFieldValue('heightFeet'));
      const inchesRaw = this.getFieldValue('heightInches');
      const inches = inchesRaw ? parseNumericField(inchesRaw) : { empty: true, valid: true, value: 0 };

      if (feet.empty) {
        this.hideHeightError();
        this.showFieldError('heightFeet', 'Please enter your height.');
        return false;
      }
      if (!feet.valid || feet.value < 0) {
        this.hideHeightError();
        this.showFieldError('heightFeet', 'Please enter a valid number of feet.');
        return false;
      }
      if (!inches.empty && (!inches.valid || inches.value < 0 || inches.value >= BODY_MEASUREMENT_RANGES.INCHES_MAX)) {
        this.hideHeightError();
        this.showFieldError('heightInches', 'Inches must be between 0 and 11.');
        return false;
      }

      this.hideFieldError('heightFeet');
      this.hideFieldError('heightInches');

      const totalInches = (feet.value * 12) + (inches.value || 0);
      const cm = Math.round(totalInches * 2.54);
      if (cm < range.min || cm > range.max) {
        this.showHeightError(BODY_MEASUREMENT_RANGES.HEIGHT_IMPERIAL_MESSAGE);
        return false;
      }

      this.hideHeightError();
      return true;
    }

    validateWeightFields(prefix, required) {
      const unit = this.data.unitSystem || 'imperial';
      const range = BODY_MEASUREMENT_RANGES.WEIGHT_KG;

      if (unit === 'metric') {
        const kg = parseNumericField(this.getFieldValue(`${prefix}Kg`));
        if (kg.empty) {
          if (required) {
            this.showRangeError(`${prefix}Kg`, 'Please enter your weight.');
            return false;
          }
          this.hideRangeError(`${prefix}Kg`);
          return true;
        }
        if (!kg.valid || kg.value < range.min || kg.value > range.max) {
          this.showRangeError(`${prefix}Kg`, range.message);
          return false;
        }
        this.hideRangeError(`${prefix}Kg`);
        return true;
      }

      const st = parseNumericField(this.getFieldValue(`${prefix}Stones`));
      const lbRaw = this.getFieldValue(`${prefix}Pounds`);
      const lb = lbRaw ? parseNumericField(lbRaw) : { empty: true, valid: true, value: 0 };

      if (st.empty && lb.empty) {
        this.hideFieldError(`${prefix}Pounds`);
        if (required) {
          this.showFieldError(`${prefix}Stones`, 'Please enter your weight.');
          return false;
        }
        this.hideFieldError(`${prefix}Stones`);
        return true;
      }

      if (st.empty || !st.valid || st.value < 0) {
        this.showFieldError(`${prefix}Stones`, 'Please enter a valid weight in stones.');
        return false;
      }
      if (!lb.empty && (!lb.valid || lb.value < 0 || lb.value >= BODY_MEASUREMENT_RANGES.POUNDS_MAX)) {
        this.showFieldError(`${prefix}Pounds`, 'Pounds must be between 0 and 13.');
        return false;
      }

      this.hideFieldError(`${prefix}Pounds`);

      const totalLb = (st.value * 14) + (lb.value || 0);
      const kg = Math.round(totalLb * 0.453592 * 10) / 10;
      if (kg < range.min || kg > range.max) {
        this.showFieldError(`${prefix}Stones`, BODY_MEASUREMENT_RANGES.WEIGHT_IMPERIAL_MESSAGE);
        return false;
      }

      this.hideFieldError(`${prefix}Stones`);
      return true;
    }

    validateBiologicalSex() {
      if (!this.data.biologicalSex) {
        this.showGroupError('biologicalSex', 'Please choose an option.');
        return false;
      }

      if (this.data.biologicalSex === 'female') {
        if (!this.data.pregnancyStatus) {
          this.showGroupError('pregnancyStatus', 'Please choose an option.');
          return false;
        }

        if (!this.data.contraceptiveUse) {
          this.showGroupError('contraceptiveUse', 'Please choose an option.');
          return false;
        }

        const checkbox = this.root.querySelector('[data-assessment-checkbox]');
        if (!checkbox?.checked) {
          this.showGroupError('counselling', 'Please confirm you have read and understood the above.');
          return false;
        }
      }

      this.saveData();
      return true;
    }

    validateFollowup() {
      const condition = this.getCurrentFollowupCondition();

      if (this.isType2DiabetesFollowup(condition)) {
        if (!this.validateMultiSelect('type2Management', 'Please choose an option.')) return false;
        if (!this.validateMultiSelect('type2Applies', 'Please choose an option.')) return false;

        const checkbox = this.root.querySelector('[data-type2-checkbox]');
        if (!checkbox?.checked) {
          this.showGroupError('type2Acknowledgement', 'Please confirm you understand.');
          return false;
      }

        this.data.type2Acknowledged = true;
        this.saveCurrentFollowupToData();
      this.saveData();
      return true;
    }

      if (!this.data.doctorDiagnosed) {
        this.showGroupError('doctorDiagnosed', 'Please choose an option.');
        return false;
      }

      const symptomChanges = this.getFieldValue('symptomChanges');
      const currentManagement = this.getFieldValue('currentManagement');

      if (!symptomChanges) {
        return this.markTextareaError('symptomChanges');
      }

      if (!currentManagement) {
        return this.markTextareaError('currentManagement');
      }

      this.saveCurrentFollowupToData();
      this.saveData();
      return true;
    }

    validateRequired(key, message) {
      if (!this.data[key]) {
        this.showGroupError(key, message);
        return false;
      }
      return true;
    }

    validateMultiSelect(key, message) {
      const values = this.data[key] || [];
      if (!values.length) {
        this.showGroupError(key, message);
        return false;
      }
      return true;
    }

    validateOtherAllergies() {
      if (!this.data.otherAllergies) {
        this.showGroupError('otherAllergies', 'Please choose an option.');
        return false;
      }

      if (this.data.otherAllergies === 'yes') {
        const detail = this.getFieldValue('otherAllergiesDetail');
        if (!detail) {
          return this.markTextareaError('otherAllergiesDetail');
        }
        this.data.otherAllergiesDetail = detail;
      } else {
        delete this.data.otherAllergiesDetail;
      }

      return true;
    }

    validateAllergies() {
      if (!this.validateMultiSelect('allergyInjection', 'Please choose an option.')) return false;
      if (!this.validateMultiSelect('allergyMedication', 'Please choose an option.')) return false;
      if (!this.validateOtherAllergies()) return false;

      this.saveData();
      return true;
    }

    isAllergiesFilled() {
      if (!(this.data.allergyInjection || []).length) return false;
      if (!(this.data.allergyMedication || []).length) return false;
      if (!this.data.otherAllergies) return false;
      if (this.data.otherAllergies === 'yes') {
        return this.getFieldValue('otherAllergiesDetail').length > 0;
      }
      return true;
    }

    validateIllnessesOperations() {
      if (!this.data.illnessesOrOperations) {
        this.showGroupError('illnessesOrOperations', 'Please choose an option.');
        return false;
      }

      if (this.data.illnessesOrOperations === 'yes') {
        const detail = this.getFieldValue('illnessesOrOperationsDetail');
        if (!detail) {
          return this.markTextareaError('illnessesOrOperationsDetail');
        }
        this.data.illnessesOrOperationsDetail = detail;
      } else {
        delete this.data.illnessesOrOperationsDetail;
      }

      this.saveData();
      return true;
    }

    isIllnessesOperationsFilled() {
      if (!this.data.illnessesOrOperations) return false;
      if (this.data.illnessesOrOperations === 'yes') {
        return this.getFieldValue('illnessesOrOperationsDetail').length > 0;
      }
      return true;
    }

    validateOtherMedications() {
      if (!this.data.otherMedications) {
        this.showGroupError('otherMedications', 'Please choose an option.');
        return false;
      }

      if (this.data.otherMedications === 'yes') {
        const detail = this.getFieldValue('otherMedicationsDetail');
        if (!detail) {
          return this.markTextareaError('otherMedicationsDetail');
        }
        this.data.otherMedicationsDetail = detail;
      } else {
        delete this.data.otherMedicationsDetail;
      }

      return true;
    }

    validateMedications() {
      if (!this.validateMultiSelect('listedMedications', 'Please choose an option.')) return false;
      if (!this.validateOtherMedications()) return false;

      this.saveData();
      return true;
    }

    isMedicationsFilled() {
      if (!(this.data.listedMedications || []).length) return false;
      if (!this.data.otherMedications) return false;
      if (this.data.otherMedications === 'yes') {
        return this.getFieldValue('otherMedicationsDetail').length > 0;
      }
      return true;
    }

    validateDietLifestyle() {
      if (!this.validateMultiSelect('weightLossReasons', 'Please choose an option.')) return false;
      if (!this.validateRequired('weightMentalHealthFrequency', 'Please choose an option.')) return false;
      if (!this.validateRequired('currentDiet', 'Please choose an option.')) return false;
      if (!this.validateRequired('physicalExercise', 'Please choose an option.')) return false;
      if (!this.validateMultiSelect('treatmentPriorities', 'Please choose an option.')) return false;

      this.saveData();
      return true;
    }

    isDietLifestyleFilled() {
      if (!(this.data.weightLossReasons || []).length) return false;
      if (!this.data.weightMentalHealthFrequency) return false;
      if (!this.data.currentDiet) return false;
      if (!this.data.physicalExercise) return false;
      if (!(this.data.treatmentPriorities || []).length) return false;
      return true;
    }

    getTextarea(name) {
      return this.root.querySelector(`[data-assessment-textarea][name="${name}"]`);
    }

    markTextareaError(name) {
      const field = this.getTextarea(name);
      if (field) field.classList.add('is-error');
      return false;
    }

    getFieldValue(name) {
      const field = this.getTextarea(name) || this.root.querySelector(`[name="${name}"]`);
      return field ? field.value.trim() : (this.data[name] || '');
    }

    showFieldError(name, message) {
      const field = this.root.querySelector(`[name="${name}"]`);
      if (field) {
        field.classList.add('is-error');
        const errorEl = field.closest('[data-field]')?.querySelector('[data-field-error]');
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.classList.add('is-visible');
        }
      }
      return false;
    }

    hideFieldError(name) {
      const field = this.root.querySelector(`[name="${name}"]`);
      if (!field) return;
      field.classList.remove('is-error');
      const errorEl = field.closest('[data-field]')?.querySelector('[data-field-error]');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
    }

    showRangeError(key, message) {
      this.hideFieldError(key);
      const banner = this.root.querySelector(`[data-range-error="${key}"]`);
      if (banner) {
        const text = banner.querySelector('[data-range-error-text]');
        if (text) text.textContent = message;
        banner.classList.add('is-visible');
      }
      const field = this.root.querySelector(`[name="${key}"]`);
      if (field) field.classList.add('is-error');
      return false;
    }

    hideRangeError(key) {
      const banner = this.root.querySelector(`[data-range-error="${key}"]`);
      if (banner) banner.classList.remove('is-visible');
      this.hideFieldError(key);
    }

    hideBodyMeasurementRangeErrors() {
      ['heightCm', 'currentKg', 'initialKg', 'targetKg', 'waistCm'].forEach((key) => {
        this.hideRangeError(key);
      });
      [
        'heightFeet', 'heightInches',
        'currentStones', 'currentPounds',
        'initialStones', 'initialPounds',
        'targetStones', 'targetPounds'
      ].forEach((key) => this.hideFieldError(key));
      this.hideHeightError();
    }

    showHeightError(message) {
      const banner = this.root.querySelector('[data-height-error]');
      if (banner) {
        banner.querySelector('[data-height-error-text]').textContent = message;
        banner.classList.add('is-visible');
      }
      return false;
    }

    hideHeightError() {
      const banner = this.root.querySelector('[data-height-error]');
      if (banner) banner.classList.remove('is-visible');
    }

    showGroupError(key, message) {
      const group = this.root.querySelector(`[data-selector-group][data-key="${key}"]`);
      const errorEl = group?.closest('[data-step]')?.querySelector(`[data-group-error="${key}"]`)
        || this.root.querySelector(`[data-group-error="${key}"]`);
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.classList.add('is-visible');
      }
      return false;
    }

    updateContinueState() {
      const activeStep = this.root.querySelector('[data-step].is-active');
      const btn = activeStep?.querySelector('[data-assessment-continue]');
      if (!btn) return;

      const stepId = STEPS[this.currentStep];
      let enabled = false;

      switch (stepId) {
        case 'intro':
          enabled = true;
          break;
        case 'basic-info':
          enabled = isValidName(this.getFieldValue('firstName'))
            && isValidName(this.getFieldValue('lastName'))
            && isValidEmail(this.getFieldValue('email'))
            && isValidPhone(this.getFieldValue('phone'), this.getPhoneCountry());
          break;
        case 'date-of-birth':
          enabled = parseDateOfBirth(
            this.getFieldValue('dobDay'),
            this.getFieldValue('dobMonth'),
            this.getFieldValue('dobYear')
          ).valid;
          break;
        case 'ethnic-background':
          if (!this.data.ethnicBackground) {
            enabled = false;
          } else if (this.data.ethnicBackground === 'Other') {
            enabled = this.getFieldValue('ethnicOther').trim().length >= 2;
          } else {
            enabled = true;
          }
          break;
        case 'medication-provider':
          enabled = !!this.data.medicationStatus;
          break;
        case 'previous-prescription':
          enabled = this.isPreviousPrescriptionFilled();
          break;
        case 'glp1-treatment-start':
          enabled = parseGlp1TreatmentStart(
            this.getFieldValue('glp1StartDay'),
            this.getFieldValue('glp1StartMonth'),
            this.getFieldValue('glp1StartYear')
          ).valid;
          break;
        case 'glp1-last-dose': {
          const startResult = parseGlp1TreatmentStart(
            this.getFieldValue('glp1StartDay'),
            this.getFieldValue('glp1StartMonth'),
            this.getFieldValue('glp1StartYear')
          );
          const treatmentStartIso = this.data.glp1TreatmentStartDate || (startResult.valid ? startResult.iso : undefined);
          enabled = parseGlp1LastDose(
            this.getFieldValue('glp1LastDoseDay'),
            this.getFieldValue('glp1LastDoseMonth'),
            this.getFieldValue('glp1LastDoseYear'),
            treatmentStartIso
          ).valid;
          break;
        }
        case 'pen-doses-remaining':
          enabled = !this.needsPenDosesRemainingStep() || !!this.data.penDosesRemaining;
          break;
        case 'prescription-evidence':
          enabled = this.isPrescriptionEvidenceFilled();
          break;
        case 'medication-preference':
          enabled = !this.needsPreviousPrescriptionStep() || !this.data.previouslyPrescribed || !!this.data.medicationPreference;
          break;
        case 'next-dose-preference':
          enabled = !this.needsNextDosePreferenceStep() || !!this.data.nextDosePreference;
          break;
        case 'medication-experience':
          enabled = !this.needsMedicationExperienceStep() || !!this.data.medicationExperience;
          break;
        case 'confirm-declarations':
          enabled = this.isConfirmDeclarationsFilled();
          break;
        case 'wegovy-pencycle':
          enabled = !this.needsPenCycleStep() || !!this.data.penCycleReturnBox;
          break;
        case 'verify-identity':
          enabled = this.isIdentityVerified() || this.canSkipIdentityVerification();
          break;
        case 'scale-photo':
          enabled = this.isScalePhotoFilled();
          break;
        case 'optional-extras':
          enabled = true;
          break;
        case 'body-measurements':
          enabled = this.isBodyMeasurementsFilled();
          break;
        case 'biological-sex':
          enabled = this.isBiologicalSexFilled();
          break;
        case 'medical-exclusions':
          enabled = (this.data.medicalExclusions || []).length > 0;
          break;
        case 'comorbidities':
          enabled = (this.data.comorbidities || []).length > 0;
          break;
        case 'weight-mood':
          enabled = !!this.data.weightMoodImpact;
          break;
        case 'allergies':
          enabled = this.isAllergiesFilled();
          break;
        case 'illnesses-operations':
          enabled = this.isIllnessesOperationsFilled();
          break;
        case 'medications':
          enabled = this.isMedicationsFilled();
          break;
        case 'applicable-conditions':
          enabled = (this.data.applicableConditions || []).length > 0;
          break;
        case 'gp-surgery':
          enabled = this.isGpSurgeryFilled();
          break;
        case 'diet-lifestyle':
          enabled = this.isDietLifestyleFilled();
          break;
        case 'comorbidity-followup': {
          const condition = this.getCurrentFollowupCondition();
          if (this.isType2DiabetesFollowup(condition)) {
            const checkbox = this.root.querySelector('[data-type2-checkbox]');
            enabled = (this.data.type2Management || []).length > 0
              && (this.data.type2Applies || []).length > 0
              && !!checkbox?.checked;
          } else {
            enabled = !!this.data.doctorDiagnosed
              && this.getFieldValue('symptomChanges').length > 0
              && this.getFieldValue('currentManagement').length > 0;
          }
          break;
        }
      }

      btn.disabled = false;
      btn.classList.toggle('is-disabled', !enabled);
    }

    isBodyMeasurementsFilled() {
      const unit = this.data.unitSystem || 'imperial';
      let heightOk = false;

      if (unit === 'imperial') {
        heightOk = !!this.getFieldValue('heightFeet');
      } else {
        heightOk = !!this.getFieldValue('heightCm');
      }

      let weightOk = false;
      if (unit === 'imperial') {
        weightOk = !!this.getFieldValue('currentStones');
      } else {
        weightOk = !!this.getFieldValue('currentKg');
      }

      const waistOk = !!this.getFieldValue('waistCm');

      if (this.data.medicationStatus === 'switching') {
        let initialOk = false;
        if (unit === 'imperial') {
          initialOk = !!this.getFieldValue('initialStones');
        } else {
          initialOk = !!this.getFieldValue('initialKg');
        }
        return heightOk && initialOk && weightOk && waistOk;
      }

      return heightOk && weightOk && waistOk;
    }

    isBiologicalSexFilled() {
      if (!this.data.biologicalSex) return false;
      if (this.data.biologicalSex === 'male') return true;

      if (!this.data.pregnancyStatus) return false;
      if (!this.data.contraceptiveUse) return false;

      const checkbox = this.root.querySelector('[data-assessment-checkbox]');
      return !!checkbox?.checked;
    }

    restoreValues() {
      if (this.data.unitSystem) {
        const toggle = this.root.querySelector(`[data-unit-toggle][data-unit="${this.data.unitSystem}"]`);
        if (toggle) this.handleUnitToggle(toggle);
      }

      Object.keys(this.data).forEach((key) => {
        if (key === 'phone' || key === 'phoneNational') return;
        const field = this.root.querySelector(`[name="${key}"]`);
        if (field) field.value = this.data[key];
      });

      const phoneInput = this.root.querySelector('[name="phone"]');
      if (phoneInput && (this.data.phoneNational || this.data.phone)) {
        if (this.data.phoneNational) {
          phoneInput.value = this.data.phoneNational;
        } else if (String(this.data.phone).startsWith('+')) {
          const region = getPhoneRegion(this.data.phoneCountry || 'GB');
          let digits = String(this.data.phone).replace(/\D/g, '');
          if (digits.startsWith(region.dial)) {
            digits = digits.slice(region.dial.length);
            phoneInput.value = region.trunk ? '0' + digits : digits;
          }
        } else {
          phoneInput.value = this.data.phone;
        }
      }

      ['ethnicBackground', 'medicationStatus', 'biologicalSex', 'pregnancyStatus', 'contraceptiveUse', 'weightMoodImpact', 'otherAllergies', 'illnessesOrOperations', 'otherMedications', 'weightMentalHealthFrequency', 'currentDiet', 'physicalExercise', 'previouslyPrescribed', 'penDosesRemaining', 'prescriptionEvidence', 'prescriptionEvidenceAcknowledgement', 'medicationExperience', 'penCycleReturnBox', 'scalePhoto'].forEach((key) => {
        if (!this.data[key]) return;
        const group = this.root.querySelector(`[data-selector-group][data-key="${key}"]`);
        if (!group) return;
        group.querySelectorAll('[data-selector]').forEach((el) => {
          el.classList.toggle('is-selected', el.dataset.value === this.data[key]);
        });
        if (key === 'biologicalSex') this.toggleFemaleSection(this.data[key] === 'female');
      });

      if (this.data.previousPrescriptionDose && this.data.previouslyPrescribed) {
        const doseGroup = this.root.querySelector('[data-selector-group][data-key="previousPrescriptionDose"]');
        if (doseGroup) {
          doseGroup.querySelectorAll('[data-dose-for]').forEach((el) => {
            el.classList.toggle(
              'is-selected',
              el.dataset.value === this.data.previousPrescriptionDose
                && el.dataset.doseFor === this.data.previouslyPrescribed
            );
          });
        }
      }

      this.updateEthnicOther();
      this.updateOtherAllergiesDetail();
      this.updateIllnessesOperationsDetail();
      this.updateOtherMedicationsDetail();

      ['medicalExclusions', 'comorbidities', 'type2Management', 'type2Applies', 'allergyInjection', 'allergyMedication', 'listedMedications', 'applicableConditions', 'weightLossReasons', 'treatmentPriorities'].forEach((key) => {
        const selected = this.data[key] || [];
        const group = this.root.querySelector(`[data-selector-group][data-key="${key}"]`);
        if (!group) return;
        group.querySelectorAll('[data-selector]').forEach((el) => {
          el.classList.toggle('is-selected', selected.includes(el.dataset.value));
        });
      });

      if (this.data.counsellingAgreed) {
        const checkbox = this.root.querySelector('[data-assessment-checkbox]');
        if (checkbox) checkbox.checked = true;
      }

      if (this.data.confirmDeclarationsAgreed) {
        const confirmCheckbox = this.root.querySelector('[data-confirm-declarations-checkbox]');
        if (confirmCheckbox) confirmCheckbox.checked = true;
      }

      const gpInput = this.root.querySelector('[data-gp-input]');
      if (gpInput) {
        gpInput.value = this.data.gpSurgery?.Name || this.data.gpSearch || '';
      }

      const gpUnableCheckbox = this.root.querySelector('[data-gp-unable-checkbox]');
      if (gpUnableCheckbox) {
        gpUnableCheckbox.checked = !!this.data.gpUnableToProvide;
      }

      if (this.data.gpUnableReason) {
        const group = this.root.querySelector('[data-selector-group][data-key="gpUnableReason"]');
        if (group) {
          group.querySelectorAll('[data-selector]').forEach((el) => {
            el.classList.toggle('is-selected', el.dataset.value === this.data.gpUnableReason);
          });
        }
      }

      const gpDontWantDetail = this.getTextarea('gpDontWantGpDetail');
      if (gpDontWantDetail && this.data.gpDontWantGpDetail) {
        gpDontWantDetail.value = this.data.gpDontWantGpDetail;
      }

      const gpRegisterCheckbox = this.root.querySelector('[data-gp-register-checkbox]');
      if (gpRegisterCheckbox) {
        gpRegisterCheckbox.checked = !!this.data.gpRegisterAcknowledged;
      }

      const gpManualName = this.root.querySelector('[name="gpManualName"]');
      if (gpManualName && this.data.gpManualName) {
        gpManualName.value = this.data.gpManualName;
      }

      const gpManualAddress = this.root.querySelector('[name="gpManualAddress"]');
      if (gpManualAddress && this.data.gpManualAddress) {
        gpManualAddress.value = this.data.gpManualAddress;
      }

      const countrySelect = this.root.querySelector('[data-phone-country]');
      this.updateGpSearchState();
      this.updateGpUnableDetail();
      this.updatePreviousPrescriptionDose();
      this.updatePrescriptionEvidenceDetail();

      if (this.data.prescriptionEvidenceUpload) {
        this.initPrescriptionEvidenceUpload();
        this.updatePrescriptionUploadPreviewFromUrl(this.data.prescriptionEvidenceUpload);
      }

      if (this.data.scalePhotoUpload) {
        this.initScalePhotoUpload();
        this.updateScalePhotoUploadPreviewFromUrl(this.data.scalePhotoUpload);
      }

      if (countrySelect) {
        const country = this.data.phoneCountry && getPhoneRegion(this.data.phoneCountry)
          ? this.data.phoneCountry
          : 'GB';
        this.data.phoneCountry = country;
        countrySelect.value = country;
      }

      this.updateConditionalSections();
      this.updatePhoneFieldHints();
      this.updateContinueState();
      this.updateOptionalExtrasUI();
      this.updateDeliverySubmitState();
    }

    applyBasicInfoFromUrlParams() {
      const params = normalizeCheckoutParams(window.location.search);
      let dirty = false;

      const email = params.get('email');
      if (email && isValidEmail(email)) {
        this.data.email = email.trim().toLowerCase();
        const field = this.root.querySelector('[name="email"]');
        if (field) field.value = this.data.email;
        dirty = true;
      }

      const firstName = params.get('first_name');
      if (firstName) {
        this.data.firstName = firstName.trim();
        const field = this.root.querySelector('[name="firstName"]');
        if (field) field.value = this.data.firstName;
        dirty = true;
      }

      const lastName = params.get('last_name');
      if (lastName) {
        this.data.lastName = lastName.trim();
        const field = this.root.querySelector('[name="lastName"]');
        if (field) field.value = this.data.lastName;
        dirty = true;
      }

      const phoneParam = params.get('phone');
      if (phoneParam) {
        const resolved = resolvePhoneFromCheckoutParam(phoneParam, params.get('country') || this.getPhoneCountry());
        if (resolved) {
          this.data.phoneCountry = resolved.phoneCountry;
          this.data.phoneNational = resolved.phoneNational;
          this.data.phone = resolved.phone;

          const countrySelect = this.root.querySelector('[data-phone-country]');
          if (countrySelect) countrySelect.value = resolved.phoneCountry;

          const phoneInput = this.root.querySelector('[name="phone"]');
          if (phoneInput) {
            const region = getPhoneRegion(resolved.phoneCountry);
            phoneInput.value = region?.trunk
              ? `0${resolved.phoneNational}`
              : resolved.phoneNational;
          }

          this.updatePhoneFieldHints();
          dirty = true;
        }
      }

      const fromParam = String(params.get('from') || '').trim().toLowerCase();
      if (fromParam === 'wbq' && !this.data.fromWbq) {
        this.data.fromWbq = true;
        dirty = true;
      }

      if (dirty) {
      this.saveData();
        this.updateContinueState();
      }
    }

    ensureCheckoutContactData() {
      const phoneInput = this.getFieldValue('phone');
      const phoneCountry = this.getPhoneCountry();

      if (phoneInput && isValidPhone(phoneInput, phoneCountry)) {
        this.data.phoneCountry = phoneCountry;
        this.data.phoneNational = String(phoneInput).replace(/\D/g, '');
        this.data.phone = formatE164(phoneInput, phoneCountry);
      }

      const emailInput = this.getFieldValue('email');
      if (emailInput && isValidEmail(emailInput)) {
        this.data.email = emailInput.trim().toLowerCase();
      }

      const firstName = this.getFieldValue('firstName');
      const lastName = this.getFieldValue('lastName');
      if (firstName) this.data.firstName = firstName.trim();
      if (lastName) this.data.lastName = lastName.trim();

      this.saveData();
    }

    getCheckoutPhone() {
      if (this.data.phone) return this.data.phone;

      const phoneInput = this.getFieldValue('phone');
      const phoneCountry = this.getPhoneCountry();
      if (!phoneInput || !isValidPhone(phoneInput, phoneCountry)) return '';

      return formatE164(phoneInput, phoneCountry);
    }

    buildAssessmentCheckoutQS() {
      this.ensureCheckoutContactData();
      const params = new URLSearchParams();
      const phone = this.getCheckoutPhone();

      if (this.data.email) {
        params.set('email', this.data.email);
        params.set('checkout[email]', this.data.email);
      }
      if (this.data.firstName) {
        params.set('first_name', this.data.firstName);
        params.set('checkout[shipping_address][first_name]', this.data.firstName);
        params.set('checkout[billing_address][first_name]', this.data.firstName);
      }
      if (this.data.lastName) {
        params.set('last_name', this.data.lastName);
        params.set('checkout[shipping_address][last_name]', this.data.lastName);
        params.set('checkout[billing_address][last_name]', this.data.lastName);
      }
      if (this.data.firstName || this.data.lastName) {
        params.set('name', `${this.data.firstName || ''} ${this.data.lastName || ''}`.trim());
      }
      if (phone) {
        params.set('phone', phone);
        params.set('mobile', phone);
        params.set('checkout[phone]', phone);
        params.set('checkout[shipping_address][phone]', phone);
        params.set('checkout[billing_address][phone]', phone);
      }
      if (this.data.phoneCountry) {
        params.set('country', this.data.phoneCountry);
        params.set('checkout[shipping_address][country]', this.data.phoneCountry);
        params.set('checkout[billing_address][country]', this.data.phoneCountry);
      }
      if (this.data.dateOfBirth) {
        params.set('dob', this.data.dateOfBirth);
      }
      if (this.data.deliveryDate) {
        params.set('attributes[Preferred delivery date]', this.formatDeliveryDateLabel(this.data.deliveryDate));
      }

      return params.toString();
    }

    cartPermalinkCheckout(variantId, qty) {
      return this.cartPermalinkCheckoutItems([{ id: Number(variantId), qty: qty || 1 }]);
    }

    cartPermalinkCheckoutItems(items) {
      const lines = (items || [])
        .map((item) => ({ id: Number(item.id), qty: Number(item.qty) || 1 }))
        .filter((item) => item.id > 0);

      if (!lines.length) return null;

      const checkoutQS = this.buildAssessmentCheckoutQS();
      const base = `/cart/${lines.map((item) => `${encodeURIComponent(String(item.id))}:${encodeURIComponent(String(item.qty))}`).join(',')}`;
      const step = 'step=contact_information';
      if (!checkoutQS) return `${base}?${step}`;
      return `${base}?${checkoutQS}&${step}`;
    }

    clearCart() {
      return fetch('/cart/clear', { method: 'POST', credentials: 'same-origin' });
    }

    getCheckoutLineItems() {
      const seen = new Set();
      const lines = [];

      const add = (id, qty) => {
        const variantId = Number(id);
        if (!variantId || seen.has(variantId)) return;
        seen.add(variantId);
        lines.push({ id: variantId, qty: qty || 1 });
      };

      if (this.data.selectedVariantId) add(this.data.selectedVariantId, 1);
      if (this.data.nextDosePreferenceVariantId) add(this.data.nextDosePreferenceVariantId, 1);
      (this.data.optionalExtras || []).forEach((variantId) => add(variantId, 1));

      return lines;
    }

    async addOptionalExtrasToCart() {
      const extras = (this.data.optionalExtras || [])
        .map((id) => Number(id))
        .filter((id) => id > 0);

      if (!extras.length) return;

      await this.clearCart();
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: extras.map((id) => ({ id, quantity: 1 }))
        })
      });
    }

    isOptionalExtraSelected(variantId) {
      const id = Number(variantId);
      return (this.data.optionalExtras || []).some((extraId) => Number(extraId) === id);
    }

    updateOptionalExtraSelectState(select) {
      const card = select.closest('[data-optional-extra-card]');
      const btn = card?.querySelector('[data-optional-extra-add]');
      if (!btn) return;

      const groupVariantIds = (card.dataset.optionalExtraVariants || '')
        .split(',')
        .map((id) => Number(id))
        .filter((id) => id > 0);

      const selectedInGroup = groupVariantIds.find((id) => this.isOptionalExtraSelected(id));
      if (selectedInGroup && !select.value) {
        select.value = String(selectedInGroup);
      }

      const variantId = Number(select.value);
      if (variantId > 0) {
        btn.dataset.variantId = String(variantId);
        btn.disabled = false;
        btn.classList.toggle('is-added', this.isOptionalExtraSelected(variantId));
        btn.textContent = this.isOptionalExtraSelected(variantId) ? 'Added' : 'Add to cart';
      } else {
        delete btn.dataset.variantId;
        btn.disabled = true;
        btn.classList.remove('is-added');
        btn.textContent = 'Add to cart';
      }
    }

    updateOptionalExtrasUI() {
      this.root.querySelectorAll('[data-optional-extra-add]').forEach((btn) => {
        const variantId = Number(btn.dataset.variantId);
        if (!variantId) return;
        const added = this.isOptionalExtraSelected(variantId);
        btn.classList.toggle('is-added', added);
        btn.textContent = added ? 'Added' : 'Add to cart';
      });

      this.root.querySelectorAll('[data-optional-extra-select]').forEach((select) => {
        this.updateOptionalExtraSelectState(select);
      });
    }

    handleOptionalExtraAdd(btn) {
      const variantId = Number(btn.dataset.variantId);
      if (!variantId) return;

      if (!Array.isArray(this.data.optionalExtras)) this.data.optionalExtras = [];

      const card = btn.closest('[data-optional-extra-card]');
      const groupVariantIds = (card?.dataset.optionalExtraVariants || '')
        .split(',')
        .map((id) => Number(id))
        .filter((id) => id > 0);

      const index = this.data.optionalExtras.findIndex((id) => Number(id) === variantId);
      if (index >= 0) {
        this.data.optionalExtras.splice(index, 1);
        btn.classList.remove('is-added');
        btn.textContent = 'Add to cart';
      } else {
        if (groupVariantIds.length) {
          this.data.optionalExtras = this.data.optionalExtras.filter(
            (id) => !groupVariantIds.includes(Number(id))
          );
        }
        this.data.optionalExtras.push(variantId);
        btn.classList.add('is-added');
        btn.textContent = 'Added';
      }

      this.saveData();
      this.updateOptionalExtrasUI();

      if (index < 0) {
        this.goToDeliveryDateStep();
      }
    }

    goToDeliveryDateStep() {
      const deliveryIndex = STEPS.indexOf('delivery-date');
      if (deliveryIndex >= 0) {
        this.goToStep(deliveryIndex);
      }
    }

    getDeliveryCalendarViewDate() {
      if (this.deliveryCalendarView) return new Date(this.deliveryCalendarView.year, this.deliveryCalendarView.month, 1);

      const minDate = this.getMinDeliveryDate();
      if (this.data.deliveryDate) {
        const selected = new Date(this.data.deliveryDate + 'T00:00:00');
        if (!Number.isNaN(selected.getTime())) {
          this.deliveryCalendarView = { year: selected.getFullYear(), month: selected.getMonth() };
          return new Date(this.deliveryCalendarView.year, this.deliveryCalendarView.month, 1);
        }
      }

      this.deliveryCalendarView = { year: minDate.getFullYear(), month: minDate.getMonth() };
      return new Date(this.deliveryCalendarView.year, this.deliveryCalendarView.month, 1);
    }

    getMinDeliveryDate() {
      const now = new Date();
      const startDate = new Date(now);

      if (now.getHours() >= DELIVERY_DAILY_CUTOFF_HOUR) {
        startDate.setDate(startDate.getDate() + 1);
      }

      let businessDaysAdded = 0;

      while (businessDaysAdded < DELIVERY_BUSINESS_LEAD_DAYS) {
        startDate.setDate(startDate.getDate() + 1);

        const day = startDate.getDay();
        if (day !== 0 && day !== 6) {
          businessDaysAdded += 1;
        }
      }

      if (startDate.getDay() === 1) {
        startDate.setDate(startDate.getDate() + 1);
      }

      startDate.setHours(0, 0, 0, 0);
      return startDate;
    }

    getBrowserTodayDate() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return today;
    }

    getMaxDeliveryDate() {
      const max = this.getMinDeliveryDate();
      max.setMonth(max.getMonth() + 3);
      return max;
    }

    isDeliveryDateSelectable(isoDate) {
      const date = new Date(isoDate + 'T00:00:00');
      if (Number.isNaN(date.getTime())) return false;
      if (isPermanentDeliveryDate(isoDate)) return false;
      if (DELIVERY_DISABLED_WEEKDAYS.indexOf(date.getDay()) !== -1) return false;

      const today = this.getBrowserTodayDate();
      if (date < today) return false;

      const min = this.getMinDeliveryDate();
      if (date < min) return false;

      const max = this.getMaxDeliveryDate();
      if (date > max) return false;

      return true;
    }

    formatDeliveryDateLabel(isoDate) {
      const date = new Date(isoDate + 'T00:00:00');
      if (Number.isNaN(date.getTime())) return isoDate;
      return date.toLocaleDateString('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    }

    toIsoDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    shiftDeliveryCalendarMonth(delta) {
      const view = this.getDeliveryCalendarViewDate();
      view.setMonth(view.getMonth() + delta);
      this.deliveryCalendarView = { year: view.getFullYear(), month: view.getMonth() };
      this.renderDeliveryCalendar();
    }

    selectDeliveryDate(isoDate) {
      if (!this.isDeliveryDateSelectable(isoDate)) return;

      this.data.deliveryDate = isoDate;
      this.saveData();
      this.renderDeliveryCalendar();
      this.updateDeliverySubmitState();
    }

    renderDeliveryCalendar() {
      const grid = this.root.querySelector('[data-delivery-calendar-grid]');
      const label = this.root.querySelector('[data-delivery-month-label]');
      const prevBtn = this.root.querySelector('[data-delivery-prev]');
      const nextBtn = this.root.querySelector('[data-delivery-next]');
      if (!grid || !label) return;

      if (this.data.deliveryDate && !this.isDeliveryDateSelectable(this.data.deliveryDate)) {
        this.data.deliveryDate = null;
        this.saveData();
      }

      const view = this.getDeliveryCalendarViewDate();
      const year = view.getFullYear();
      const month = view.getMonth();
      const monthFormatter = new Intl.DateTimeFormat('en-GB', { month: 'long', year: 'numeric' });
      label.textContent = monthFormatter.format(view);

      const minView = new Date(this.getMinDeliveryDate().getFullYear(), this.getMinDeliveryDate().getMonth(), 1);
      const maxView = new Date(this.getMaxDeliveryDate().getFullYear(), this.getMaxDeliveryDate().getMonth(), 1);
      const viewIndex = year * 12 + month;
      const minIndex = minView.getFullYear() * 12 + minView.getMonth();
      const maxIndex = maxView.getFullYear() * 12 + maxView.getMonth();
      if (prevBtn) prevBtn.disabled = viewIndex <= minIndex;
      if (nextBtn) nextBtn.disabled = viewIndex >= maxIndex;

      const firstDay = new Date(year, month, 1);
      const startOffset = (firstDay.getDay() + 6) % 7;
      const gridStart = new Date(year, month, 1 - startOffset);

      const cells = [];
      for (let i = 0; i < 42; i += 1) {
        const date = new Date(gridStart);
        date.setDate(gridStart.getDate() + i);
        const iso = this.toIsoDate(date);
        const inMonth = date.getMonth() === month;
        const dayOfWeek = date.getDay();
        const selectable = inMonth && this.isDeliveryDateSelectable(iso);
        const isSelected = this.data.deliveryDate === iso;
        const classes = ['assessment-form__calendar-day'];

        if (!inMonth) classes.push('is-outside');
        if (dayOfWeek === 0) classes.push('is-sunday');
        if (dayOfWeek === 1 && inMonth) classes.push('is-monday');
        if (dayOfWeek === 6 && inMonth) classes.push('is-saturday');
        if (isSelected) classes.push('is-selected');
        if (!selectable) classes.push('is-disabled');

        cells.push(
          `<button type="button" class="${classes.join(' ')}" data-delivery-day data-date="${iso}" ${selectable ? '' : 'disabled'}>${date.getDate()}</button>`
        );
      }

      grid.innerHTML = cells.join('');
      this.updateDeliverySubmitState();
    }

    updateDeliverySubmitState() {
      const btn = this.root.querySelector('[data-delivery-submit]');
      if (!btn) return;
      const enabled = !!this.data.deliveryDate;
      btn.disabled = !enabled;
      btn.classList.toggle('is-disabled', !enabled);
    }

    validateDeliveryDate() {
      if (!this.data.deliveryDate || !this.isDeliveryDateSelectable(this.data.deliveryDate)) {
        return this.showGroupError('deliveryDate', 'Please select a delivery date.');
      }
      this.saveData();
      return true;
    }

    clearAssessmentSubmitError() {
      const errorEl = this.root.querySelector('[data-group-error="assessmentSubmit"]');
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible', 'is-success');
    }

    showAssessmentSubmitError(message) {
      const errorEl = this.root.querySelector('[data-group-error="assessmentSubmit"]');
      if (!errorEl) return false;
      errorEl.classList.remove('is-success');
      errorEl.textContent = message;
      errorEl.classList.add('is-visible');
      return false;
    }

    showAssessmentSubmitProgress(message) {
      const submitBtn = this.root.querySelector('[data-delivery-submit]');
      const statusEl = this.root.querySelector('[data-assessment-submit-status]');

      if (statusEl) {
        statusEl.textContent = message;
        statusEl.hidden = false;
        statusEl.classList.add('is-visible');
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = message;
      }
    }

    hideAssessmentSubmitProgress() {
      const statusEl = this.root.querySelector('[data-assessment-submit-status]');
      if (!statusEl) return;
      statusEl.textContent = '';
      statusEl.hidden = true;
      statusEl.classList.remove('is-visible');
    }

    getCreateAssessmentSuccessMessage() {
      const response = this.lastCreateAssessmentResponse;
      if (!response?.ok) return 'Form submitted successfully.';

      const apiMessage = response.result?.message;
      if (apiMessage) return apiMessage;

      if (response.result?.form_submission_saved) {
        return 'Assessment saved successfully.';
      }

      return `Form submitted successfully. (API ${response.status})`;
    }

    getCreateAssessmentResponsePreview() {
      const response = this.lastCreateAssessmentResponse;
      const submission = this.lastCreateAssessmentSubmission;

      if (response?.text) return response.text;

      if (submission?.assessment) {
        return JSON.stringify({
          'First-Name': submission['First-Name'],
          'Last-Name': submission['Last-Name'],
          patient_email: submission.patient_email,
          Phone: submission.Phone,
          consent: submission.consent,
          assessment: submission.assessment
        }, null, 2);
      }

      if (response?.result && Object.keys(response.result).length) {
        return JSON.stringify(response.result, null, 2);
      }

      return response?.ok ? `HTTP ${response.status} — assessment saved.` : '';
    }

    showAssessmentSubmitSuccess(message) {
      const resolvedMessage = message || this.getCreateAssessmentSuccessMessage();
      const errorEl = this.root.querySelector('[data-group-error="assessmentSubmit"]');
      const resultEl = this.root.querySelector('[data-assessment-submit-result]');
      const titleEl = this.root.querySelector('[data-assessment-submit-title]');
      const detailEl = this.root.querySelector('[data-assessment-submit-detail]');
      const calendarEl = this.root.querySelector('[data-delivery-calendar]');
      const submitBtn = this.root.querySelector('[data-delivery-submit]');
      const backBtn = this.root.querySelector('[data-step="delivery-date"] [data-assessment-back]');
      const actionsEl = this.root.querySelector('[data-step="delivery-date"] .assessment-form__actions');

      this.hideAssessmentSubmitProgress();

      if (errorEl) {
        errorEl.textContent = resolvedMessage;
        errorEl.classList.add('is-visible', 'is-success');
      }

      if (titleEl) titleEl.textContent = resolvedMessage;

      const preview = this.getCreateAssessmentResponsePreview();
      if (detailEl) {
        if (preview) {
          detailEl.textContent = preview;
          detailEl.hidden = false;
        } else {
          detailEl.textContent = '';
          detailEl.hidden = true;
        }
      }

      if (resultEl) {
        resultEl.hidden = false;
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      if (calendarEl) calendarEl.hidden = true;
      if (actionsEl) actionsEl.hidden = true;

      if (submitBtn) {
        submitBtn.hidden = true;
        submitBtn.disabled = true;
      }

      if (backBtn) backBtn.hidden = true;
    }

    buildCheckoutUrl() {
      const checkoutQS = this.buildAssessmentCheckoutQS();
      return checkoutQS
        ? `/checkout?${checkoutQS}&step=contact_information`
        : '/checkout?step=contact_information';
    }

    async proceedToShopifyCheckout() {
      this.ensureCheckoutContactData();
      const checkoutLines = this.getCheckoutLineItems();

      try {
        await this.clearCart();
      } catch (_) {}

      let checkoutUrl;
      if (checkoutLines.length) {
        checkoutUrl = this.cartPermalinkCheckoutItems(checkoutLines) || this.buildCheckoutUrl();
      } else if ((this.data.optionalExtras || []).length) {
        try {
          await this.addOptionalExtrasToCart();
        } catch (_) {}
        checkoutUrl = this.buildCheckoutUrl();
      } else {
        checkoutUrl = this.buildCheckoutUrl();
      }

      await this.setDeliveryDateCartAttribute();
      window.location.assign(checkoutUrl);
    }

    submitDeliveryDate() {
      if (!this.validateDeliveryDate()) return;
      void this.confirmDeliveryDateThenComplete();
    }

    async confirmDeliveryDateThenComplete() {
      const confirmed = await this.promptDateConfirmation({
        title: 'Please confirm your delivery date',
        dateLabel: this.formatConfirmDateLabel(this.data.deliveryDate, { weekday: true }),
        hint: 'We will aim for this date for your delivery.'
      });
      if (!confirmed) return;
      await this.complete();
    }

    formatConfirmDateLabel(isoDate, options = {}) {
      const date = new Date(`${isoDate}T00:00:00`);
      if (Number.isNaN(date.getTime())) return String(isoDate || '');
      const format = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      };
      if (options.weekday) format.weekday = 'long';
      return date.toLocaleDateString('en-GB', format);
    }

    getDateConfirmationPayload() {
      const stepId = STEPS[this.currentStep];

      if (stepId === 'date-of-birth' && this.data.dateOfBirth) {
        return {
          title: 'Please confirm your date of birth',
          dateLabel: this.formatConfirmDateLabel(this.data.dateOfBirth),
          hint: 'This date is used to check your eligibility.'
        };
      }

      if (stepId === 'glp1-treatment-start' && this.data.glp1TreatmentStartDate) {
        return {
          title: 'Please confirm your treatment start date',
          dateLabel: this.formatConfirmDateLabel(this.data.glp1TreatmentStartDate),
          hint: 'Please check carefully before continuing.'
        };
      }

      if (stepId === 'glp1-last-dose' && this.data.glp1LastDoseDate) {
        return {
          title: 'Please confirm your last dose date',
          dateLabel: this.formatConfirmDateLabel(this.data.glp1LastDoseDate),
          hint: 'This is the date your last dose was administered.'
        };
      }

      return null;
    }

    promptDateConfirmation({ title, dateLabel, hint }) {
      const modal = this.root.querySelector('[data-date-confirm]');
      if (!modal) return Promise.resolve(true);

      const titleEl = modal.querySelector('[data-date-confirm-title]');
      const dateEl = modal.querySelector('[data-date-confirm-date]');
      const hintEl = modal.querySelector('[data-date-confirm-hint]');
      const okBtn = modal.querySelector('[data-date-confirm-ok]');
      const editBtn = modal.querySelector('[data-date-confirm-edit]');
      const dismissEls = modal.querySelectorAll('[data-date-confirm-dismiss]');

      if (titleEl) titleEl.textContent = title || 'Please confirm this date is correct';
      if (dateEl) dateEl.textContent = dateLabel || '';
      if (hintEl) {
        hintEl.textContent = hint || 'Please check carefully before continuing.';
      }

      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (okBtn) okBtn.focus();

      return new Promise((resolve) => {
        const finish = (confirmed) => {
          modal.hidden = true;
          document.body.style.overflow = '';
          okBtn?.removeEventListener('click', onOk);
          editBtn?.removeEventListener('click', onEdit);
          dismissEls.forEach((el) => el.removeEventListener('click', onEdit));
          document.removeEventListener('keydown', onKey);
          resolve(confirmed);
        };

        const onOk = () => finish(true);
        const onEdit = () => finish(false);
        const onKey = (e) => {
          if (e.key === 'Escape') finish(false);
        };

        okBtn?.addEventListener('click', onOk);
        editBtn?.addEventListener('click', onEdit);
        dismissEls.forEach((el) => el.addEventListener('click', onEdit));
        document.addEventListener('keydown', onKey);
      });
    }

    async complete() {
      this.saveData();
      this.clearAssessmentSubmitError();

      if (this.data.ineligible) {
        this.redirectIfIneligible();
        return;
      }

      const submitBtn = this.root.querySelector('[data-delivery-submit]');
      const submitBtnText = submitBtn?.textContent;
      this.showAssessmentSubmitProgress('Submitting assessment...');

      try {
        const submitted = await this.syncCreateAssessmentToApi();

        if (!submitted) {
          this.hideAssessmentSubmitProgress();
          const apiMessage = this.lastCreateAssessmentResponse?.result?.message;
          this.showAssessmentSubmitError(
            apiMessage || 'We could not submit your assessment. Please try again.'
          );
          if (submitBtn) {
            submitBtn.textContent = submitBtnText || 'Submit';
            this.updateDeliverySubmitState();
          }
        return;
      }

        // Customer exists after create-assessment; sync OneID status (soft-fail).
        await this.syncOneIdVerificationToApi();

        if (isCheckoutDisabled()) {
          this.showAssessmentSubmitSuccess();
          if (this.hasPendingAssessmentImages()) {
            void this.syncAssessmentImagesToApi();
          }
          return;
        }

        if (this.hasPendingAssessmentImages()) {
          this.showAssessmentSubmitProgress('Saving photos and redirecting to checkout...');
          await this.syncAssessmentImagesToApi({ maxAttempts: 2 });
        } else {
          this.showAssessmentSubmitProgress('Redirecting to checkout...');
        }
        await this.proceedToShopifyCheckout();
      } catch (_) {
        this.hideAssessmentSubmitProgress();
        this.showAssessmentSubmitError('We could not submit your assessment. Please try again.');
        if (submitBtn) {
          submitBtn.textContent = submitBtnText || 'Submit';
          this.updateDeliverySubmitState();
        }
      }
    }

    async setDeliveryDateCartAttribute() {
      const attributes = {};

      if (this.data.deliveryDate) {
        attributes['Preferred delivery date'] = this.formatDeliveryDateLabel(this.data.deliveryDate);
      }

      const phone = this.getCheckoutPhone();
      if (phone) {
        attributes.Phone = phone;
      }

      if (!Object.keys(attributes).length) return;

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes })
        });
      } catch (_) {}
    }

    handleMedicationCheckout(btn) {
      const medKey = btn.dataset.medKey;
      let variantId = btn.dataset.variantId;

      if (!medKey) return;

      if (!variantId) {
        const fallback = {
          [MEDICATION_SELECTION.MOUNJARO]: MEDICATION_VARIANT_IDS.MOUNJARO,
          [MEDICATION_SELECTION.WEGOVY]: MEDICATION_VARIANT_IDS.WEGOVY,
          [MEDICATION_SELECTION.WEGOVY_PILL]: this.wegovyPillStarterVariantId
            || DOSE_CATALOG.WEGOVY_PILL.find((dose) => dose.name === '1.5mg')?.value
            || 0,
          [MEDICATION_SELECTION.ALLI]: MEDICATION_VARIANT_IDS.ALLI,
          [MEDICATION_SELECTION.PRESCRIBER]: MEDICATION_VARIANT_IDS.PRESCRIBER
        }[medKey];
        if (fallback) variantId = String(fallback);
      }

      if (!variantId) return;

      this.data.selectedMedication = medKey;
      this.data.selectedVariantId = Number(variantId);
      this.saveData();

      const confirmIndex = STEPS.indexOf('confirm-declarations');
      if (confirmIndex >= 0) {
        this.goToStep(confirmIndex);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }

  function initGpSearchRelayOnly() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('gp_relay') !== '1' || window.self === window.top) return false;

    const root = document.querySelector('[data-assessment-form]');
    const apiUrl = root?.dataset.gpApiUrl || NHS_ORG_API;
    const tenant = root?.dataset.gpApiTenant || '';
    const allowedOrigins = new Set([
      'https://getslimmr.co.uk',
      'https://www.getslimmr.co.uk',
      'http://127.0.0.1:9292',
      'http://localhost:9292',
      'https://getslimmr.myshopify.com'
    ]);

    if (root) root.hidden = true;

    window.addEventListener('message', async (event) => {
      if (!allowedOrigins.has(event.origin)) return;
      if (!event.data || event.data.type !== 'gp-search') return;

      const query = String(event.data.query || '').trim();
      const requestId = event.data.requestId;

      try {
        const organisations = await fetchGpOrganisationsFromApi(apiUrl, tenant, query);
        event.source.postMessage({
          type: 'gp-search-result',
          requestId,
          ok: true,
          organisations
        }, event.origin);
      } catch (_) {
        event.source.postMessage({
          type: 'gp-search-result',
          requestId,
          ok: false,
          error: 'Search failed'
        }, event.origin);
      }
    });

    window.parent.postMessage({ type: 'gp-relay-ready' }, '*');
    return true;
  }

  function init() {
    document.querySelectorAll('[data-assessment-form]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      new AssessmentForm(root);
    });
  }

  if (initGpSearchRelayOnly()) {
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.SlimmrAssessment = {
    clearSession: clearAssessmentSession,
    storageKey: STORAGE_KEY
  };
})();
